;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="dde9591c-c1d1-4420-9477-604e83cac942",e._sentryDebugIdIdentifier="sentry-dbid-dde9591c-c1d1-4420-9477-604e83cac942")}catch(e){}}();
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 91195:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(7452);
// EXTERNAL MODULE: ./assets/common/js/polyfills.js
var polyfills = __webpack_require__(58345);
// EXTERNAL MODULE: ./node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(27813);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/sdk.js + 1 modules
var sdk = __webpack_require__(87447);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4899);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/index.js + 225 modules
var esm = __webpack_require__(43560);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(95093);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-urls.js
var blacklisted_urls = __webpack_require__(1858);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-errors.js
var blacklisted_errors = __webpack_require__(83731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(5338);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var dist = __webpack_require__(47767);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(84976);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 14 modules
var mobxreact_esm = __webpack_require__(44015);
// EXTERNAL MODULE: ./react/components/errorBoundaries/index.tsx
var errorBoundaries = __webpack_require__(83819);
// EXTERNAL MODULE: ./react/components/ScrollToTop.tsx
var ScrollToTop = __webpack_require__(53199);
// EXTERNAL MODULE: ./react/portal/components/UpdateFormProgressState.tsx
var UpdateFormProgressState = __webpack_require__(4396);
// EXTERNAL MODULE: ./react/components/RetinoLoader.tsx
var RetinoLoader = __webpack_require__(5114);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
// EXTERNAL MODULE: ./react/public-api/index.tsx
var public_api = __webpack_require__(35750);
// EXTERNAL MODULE: ./react/stores/hooks.ts
var hooks = __webpack_require__(9432);
;// ./react/portal/contexts/FormAuthContext.tsx






const FormAuthContext = /*#__PURE__*/(0,react.createContext)(null);
const useFormAuth = () => (0,utils/* useContextSafe */.qr)(FormAuthContext);
function WithFormAuth() {
  const {
    formAuthId
  } = (0,dist/* useParams */.g)();
  const publicApi = (0,public_api/* default */.Ay)();
  const [formAuth, setFormAuth] = (0,react.useState)(null);
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthApi.retrieve({
      id: formAuthId
    });
    setFormAuth(response);
  });
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  const value = (0,react.useMemo)(() => ({
    formAuth,
    setFormAuth
  }), [formAuth, setFormAuth]);
  if (!formAuth) {
    return /*#__PURE__*/react.createElement(RetinoLoader/* default */.A, null);
  }
  return /*#__PURE__*/react.createElement(FormAuthContext.Provider, {
    value: value
  }, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null));
}

// EXTERNAL MODULE: ./react/portal/contexts/FormProgressContext.tsx
var FormProgressContext = __webpack_require__(16523);
;// ./react/portal/contexts/FormsContext.tsx





const FormsContext = /*#__PURE__*/(0,react.createContext)(null);
const useForms = () => (0,utils/* useContextSafe */.qr)(FormsContext);
function WithFormsContext() {
  const {
    companyId
  } = (0,dist/* useParams */.g)();
  const publicApi = (0,public_api/* default */.Ay)();
  const [forms, setForms] = (0,react.useState)(null);
  const load = async () => {
    const response = await publicApi.PortalFormApi.list({
      company_id: companyId
    });
    const formIds = (window.appState.search.get('form-ids') || '').split(';').filter(Boolean);
    setForms(response.filter(form => formIds.length === 0 || formIds.includes(form.id)));
  };
  (0,react.useEffect)(() => {
    load();
  }, []);
  if (forms === null) {
    return /*#__PURE__*/react.createElement(RetinoLoader/* default */.A, null);
  }
  return /*#__PURE__*/react.createElement(FormsContext.Provider, {
    value: forms
  }, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null));
}

// EXTERNAL MODULE: ./react/portal/contexts/PortalUIThemeContext.tsx
var PortalUIThemeContext = __webpack_require__(75487);
;// ./react/portal/contexts/ShippingProvidersConfig.tsx




const ShippingProvidersConfigContext = /*#__PURE__*/react.createContext(null);
const useShippingProvidersConfig = () => useContextSafe(ShippingProvidersConfigContext);
function WithShippingProvidersConfig() {
  const publicApi = (0,public_api/* default */.Ay)();
  const [config, setConfig] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    const fetchConfig = async () => {
      const response = await publicApi.ShippingProvidersConfigApi.list({
        include_internal: true
      });
      setConfig(response);
    };
    fetchConfig();
  }, []);
  if (config === null) {
    return null;
  }
  return /*#__PURE__*/react.createElement(ShippingProvidersConfigContext.Provider, {
    value: config
  }, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null));
}

// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(22926);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(37427);
;// ./react/portal/contexts/Stripe.tsx






const STRIPE_LOCALES = new Set(['bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hr', 'hu', 'it', 'lt', 'lv', 'nb', 'nl', 'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'tr']);
function stripeLocale(lang) {
  // Portal languages include regional variants (de-at, fr-be, …) that Stripe
  // does not know — fall back to the base language, then to auto-detection.
  const base = lang.split('-')[0];
  if (STRIPE_LOCALES.has(lang)) {
    return lang;
  }
  if (STRIPE_LOCALES.has(base)) {
    return base;
  }
  return 'auto';
}
function WithStripe() {
  var _formProgress$payment2, _formProgress$payment3;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    lang
  } = (0,dist/* useParams */.g)();
  const portalTheme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const stripePromiseRef = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    stripePromiseRef.current = (0,stripe_esm/* loadStripe */.c)(window.appState.stripeApiKey);
  }, []);
  const options = (0,react.useMemo)(() => {
    var _formProgress$payment;
    const getBorderRadius = () => {
      switch (portalTheme.input.radius) {
        case 'none':
          return '0';
        case 'sm':
          return '0.125rem';
        case 'md':
          return '0.375rem';
        case 'lg':
          return '0.5rem';
        default:
          return '1.5rem';
      }
    };
    const appearance = {
      theme: 'stripe',
      variables: {
        colorPrimary: portalTheme.colors.primary.default,
        colorBackground: '#ffffff',
        colorText: '#1f2937',
        colorTextSecondary: '#6b7280',
        colorTextPlaceholder: '#9ca3af',
        colorDanger: '#ef4444',
        borderRadius: getBorderRadius()
      },
      rules: {
        '.Input': {
          borderColor: '#e5e7eb',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
        },
        '.Input:focus': {
          borderColor: portalTheme.colors.primary.default,
          boxShadow: "0 0 0 1px ".concat(portalTheme.colors.primary.default)
        },
        '.Input--invalid': {
          borderColor: '#ef4444'
        },
        '.Label': {
          color: '#374151',
          fontWeight: '500'
        },
        '.Tab': {
          borderColor: '#e5e7eb'
        },
        '.Tab--selected': {
          borderColor: portalTheme.colors.primary.default,
          color: portalTheme.colors.primary.default
        }
      }
    };
    return {
      clientSecret: formProgress === null || formProgress === void 0 || (_formProgress$payment = formProgress.payment_intent) === null || _formProgress$payment === void 0 ? void 0 : _formProgress$payment.client_secret,
      appearance,
      locale: stripeLocale(lang)
    };
  }, [portalTheme.colors.primary.default, portalTheme.input.radius, formProgress === null || formProgress === void 0 || (_formProgress$payment2 = formProgress.payment_intent) === null || _formProgress$payment2 === void 0 ? void 0 : _formProgress$payment2.client_secret, lang]);
  return /*#__PURE__*/react.createElement(react_stripe_umd.Elements, {
    stripe: stripePromiseRef.current,
    options: options,
    key: formProgress === null || formProgress === void 0 || (_formProgress$payment3 = formProgress.payment_intent) === null || _formProgress$payment3 === void 0 ? void 0 : _formProgress$payment3.client_secret
  }, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null));
}
/* harmony default export */ const Stripe = (WithStripe);
;// ./react/portal/hooks.ts
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




// eslint-disable-next-line import/prefer-default-export
function useSubmitRef() {
  const submitRef = (0,react.useRef)(null);
  const handleSubmit = () => {
    if (submitRef.current) {
      submitRef.current.click();
    }
  };
  return [submitRef, handleSubmit];
}
function useShippingProviderConfig() {
  const publicApi = (0,public_api/* default */.Ay)();
  const [config, setConfig] = (0,react.useState)(null);
  const [loadConfig, isLoading] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.ShippingProvidersConfigApi.list({
      include_internal: true
    });
    const typeToConfig = response.reduce((acc, item) => _objectSpread(_objectSpread({}, acc), {}, {
      [item.type]: item
    }), {});
    setConfig(typeToConfig);
    return typeToConfig;
  });
  return [config, loadConfig, isLoading];
}
// EXTERNAL MODULE: ./react/portal/ui/index.tsx
var ui = __webpack_require__(17961);
// EXTERNAL MODULE: ./react/public-api/codegen/index.ts
var codegen = __webpack_require__(7816);
// EXTERNAL MODULE: ./react/public-api/codegen/base.ts
var base = __webpack_require__(10895);
;// ./react/public-api/utils.ts

function isResponse(error) {
  return error instanceof base/* ResponseError */.o3;
}
async function getErrors(error) {
  if (isResponse(error)) {
    return error.response.json();
  }
  return null;
}
async function getFieldErrors(error) {
  if (!isResponse(error)) return {};
  const body = await error.response.text();
  let errors;
  try {
    errors = JSON.parse(body);
  } catch (parseError) {
    if (parseError instanceof SyntaxError) return {};
    throw parseError;
  }
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return {};
  const fields = {};
  Object.entries(errors).forEach(_ref => {
    let [field, messages] = _ref;
    if (typeof messages === 'string') {
      fields[field] = messages;
    } else if (Array.isArray(messages) && messages.every(message => typeof message === 'string')) {
      fields[field] = messages.join(' ');
    }
  });
  return fields;
}
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var react_ui = __webpack_require__(35443);
// EXTERNAL MODULE: ./react/routes/codegen/portalRoutes.ts
var portalRoutes = __webpack_require__(19312);
// EXTERNAL MODULE: ./react/stores/constants.ts
var constants = __webpack_require__(25193);
;// ./react/portal/customer/CustomerInfo/Address.tsx







function Address(_ref) {
  var _address$name, _address$street, _address$house_number, _address$city, _address$postal_code, _address$country;
  let {
    address,
    changeAddress,
    errors,
    countryReadOnly
  } = _ref;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [name, setName] = (0,react.useState)((_address$name = address === null || address === void 0 ? void 0 : address.name) !== null && _address$name !== void 0 ? _address$name : '');
  const [street, setStreet] = (0,react.useState)((_address$street = address === null || address === void 0 ? void 0 : address.street) !== null && _address$street !== void 0 ? _address$street : '');
  const [houseNumber, setHouseNumber] = (0,react.useState)((_address$house_number = address === null || address === void 0 ? void 0 : address.house_number) !== null && _address$house_number !== void 0 ? _address$house_number : '');
  const [city, setCity] = (0,react.useState)((_address$city = address === null || address === void 0 ? void 0 : address.city) !== null && _address$city !== void 0 ? _address$city : '');
  const [postalCode, setPostalCode] = (0,react.useState)((_address$postal_code = address === null || address === void 0 ? void 0 : address.postal_code) !== null && _address$postal_code !== void 0 ? _address$postal_code : '');
  const [country, setCountry] = (0,react.useState)((_address$country = address === null || address === void 0 ? void 0 : address.country) !== null && _address$country !== void 0 ? _address$country : formProgress.form.default_country);
  (0,react.useEffect)(() => {
    if ((address === null || address === void 0 ? void 0 : address.city) !== city || address.country !== country || address.name !== name || address.street !== street || address.house_number !== houseNumber || address.postal_code !== postalCode) {
      changeAddress({
        name,
        street,
        city,
        postal_code: postalCode,
        house_number: houseNumber,
        country
      });
    }
  }, [name, street, houseNumber, city, postalCode, country, changeAddress]);
  const [openChangeCountryModal, setOpenChangeCountryModal] = (0,react.useState)(false);
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-4 px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "name",
    autoComplete: "name",
    value: name,
    onChange: setName,
    label: pgettext('portal_i18n', 'Contact name'),
    required: true,
    error: errors === null || errors === void 0 ? void 0 : errors.name
  }), /*#__PURE__*/react.createElement("div", {
    className: "grid grid-cols-3 gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "street",
    autoComplete: "street address-line1",
    value: street,
    onChange: setStreet,
    label: pgettext('portal_i18n', 'Street'),
    required: true,
    error: errors === null || errors === void 0 ? void 0 : errors.street
  })), /*#__PURE__*/react.createElement("div", {
    className: "col-span-1"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "house-number",
    autoComplete: "street address-line2",
    value: houseNumber,
    onChange: setHouseNumber,
    label: pgettext('portal_i18n', 'House number'),
    required: true,
    error: errors === null || errors === void 0 ? void 0 : errors.house_number
  }))), /*#__PURE__*/react.createElement("div", {
    className: "grid grid-cols-5 gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "col-span-3"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "city",
    value: city,
    onChange: setCity,
    label: pgettext('portal_i18n', 'City'),
    required: true,
    error: errors === null || errors === void 0 ? void 0 : errors.city
  })), /*#__PURE__*/react.createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "zip-code",
    value: postalCode,
    onChange: setPostalCode,
    label: pgettext('portal_i18n', 'Postal code'),
    required: true,
    error: errors === null || errors === void 0 ? void 0 : errors.postal_code
  }))), countryReadOnly ? /*#__PURE__*/react.createElement(ui/* default */.A.Form.Field, {
    label: pgettext('portal_i18n', 'Country')
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-2 bg-gray-100 rounded-md border-gray-300 border shadow-sm flex items-center justify-between"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-800"
  }, constants/* allCountries */.mn[country]), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    size: "tiny",
    onClick: () => setOpenChangeCountryModal(true)
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm"
  }, pgettext('portal_i18n', 'Change')))))) : /*#__PURE__*/react.createElement(ui/* default */.A.Form.Select, {
    name: "country",
    value: country,
    onChange: setCountry,
    label: pgettext('portal_i18n', 'Country'),
    choices: formProgress.form.shipping_countries.map(c => ({
      key: c,
      value: c,
      label: constants/* allCountries */.mn[c]
    })),
    separatorIndexes: [formProgress.form.countries.length],
    error: errors === null || errors === void 0 ? void 0 : errors.country
  }), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF, {
    open: openChangeCountryModal,
    onClose: () => setOpenChangeCountryModal(false)
  }, /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "text-center space-y-2"
  }, /*#__PURE__*/react.createElement("h1", {
    className: "font-bold text-gray-900 text-lg"
  }, pgettext('portal_i18n', 'There is shipping related to this country')), /*#__PURE__*/react.createElement("p", null, pgettext('portal_i18n', 'To change the country, you must select the new shipping type.')))), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Footer, null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center gap-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => setOpenChangeCountryModal(false)
  }, pgettext('portal_i18n', 'Close'))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true,
    onClick: () => {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingCountry({
        companyId,
        formProgressId,
        lang
      }));
    }
  }, pgettext('portal_i18n', 'Change country and shipping type')))))));
}
/* harmony default export */ const CustomerInfo_Address = (Address);
;// ./react/portal/customer/CustomerInfo/AddressPreview.tsx



function AddressPreview(_ref) {
  let {
    address: {
      city,
      country,
      name,
      postal_code,
      street,
      house_number
    },
    onEditClick
  } = _ref;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, name), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    onClick: onEditClick
  }, pgettext('portal_i18n', 'edit')))), /*#__PURE__*/react.createElement("div", {
    className: "my-2 text-gray-500"
  }, /*#__PURE__*/react.createElement("div", null, [street, house_number].join(' ')), /*#__PURE__*/react.createElement("div", null, [city, postal_code].join(', ')), /*#__PURE__*/react.createElement("div", null, constants/* allCountries */.mn[country]))));
}
/* harmony default export */ const CustomerInfo_AddressPreview = (AddressPreview);
// EXTERNAL MODULE: ./react/portal/components/CustomField.tsx
var CustomField = __webpack_require__(1160);
;// ./react/portal/customer/CustomerInfo/CustomerBlock.tsx
function CustomerBlock_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CustomerBlock_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CustomerBlock_ownKeys(Object(t), !0).forEach(function (r) { CustomerBlock_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CustomerBlock_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CustomerBlock_defineProperty(obj, key, value) { key = CustomerBlock_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function CustomerBlock_toPropertyKey(t) { var i = CustomerBlock_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function CustomerBlock_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





function CustomerBlock(_ref) {
  var _errors$customer_bloc2;
  let {
    block,
    value,
    onChange,
    errors,
    readOnly
  } = _ref;
  if (readOnly) {
    return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Field, {
      label: (0,utils/* currentLanguage */.aS)(block.name)
    }, /*#__PURE__*/react.createElement("div", {
      className: "font-medium text-gray-900"
    }, block.ticket_field ? value[block.ticket_field] : value.custom_fields[block.ticket_custom_field_type.id])));
  }
  if (block.ticket_custom_field_type) {
    var _errors$customer_bloc, _block$ticket_custom_;
    return /*#__PURE__*/react.createElement(CustomField/* default */.A, {
      label: (0,utils/* currentLanguage */.aS)(block.name),
      required: block.is_required,
      field: block.ticket_custom_field_type,
      value: value.custom_fields[block.ticket_custom_field_type.id],
      error: errors !== null && errors !== void 0 && errors.customer_blocks_data ? (_errors$customer_bloc = errors.customer_blocks_data) === null || _errors$customer_bloc === void 0 || (_errors$customer_bloc = _errors$customer_bloc.custom_fields) === null || _errors$customer_bloc === void 0 ? void 0 : _errors$customer_bloc[(_block$ticket_custom_ = block.ticket_custom_field_type) === null || _block$ticket_custom_ === void 0 ? void 0 : _block$ticket_custom_.id] : undefined,
      onChange: newValue => {
        onChange(CustomerBlock_objectSpread(CustomerBlock_objectSpread({}, value), {}, {
          custom_fields: CustomerBlock_objectSpread(CustomerBlock_objectSpread({}, value.custom_fields), {}, {
            [block.ticket_custom_field_type.id]: newValue
          })
        }));
      }
    });
  }
  if (!block.ticket_field) return null;
  let inputType = 'text';
  switch (block.ticket_field) {
    case codegen/* BackendPublicEnums */.C.TicketFieldEnum.CUSTOMER_EMAIL:
      inputType = 'email';
      break;
    case codegen/* BackendPublicEnums */.C.TicketFieldEnum.CUSTOMER_PHONE:
      inputType = 'tel';
      break;
    default:
      inputType = 'text';
      break;
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    type: inputType,
    required: block.is_required,
    label: (0,utils/* currentLanguage */.aS)(block.name),
    name: block.ticket_field,
    value: value[block.ticket_field],
    error: errors === null || errors === void 0 || (_errors$customer_bloc2 = errors.customer_blocks_data) === null || _errors$customer_bloc2 === void 0 ? void 0 : _errors$customer_bloc2[block.ticket_field],
    onChange: newValue => {
      onChange(CustomerBlock_objectSpread(CustomerBlock_objectSpread({}, value), {}, {
        [block.ticket_field]: newValue
      }));
    }
  });
}
/* harmony default export */ const CustomerInfo_CustomerBlock = (CustomerBlock);
;// ./react/portal/customer/CustomerInfo/utils.ts
function toJustAddress(address) {
  if (!address) return {};
  return {
    name: address.name,
    street: address.street,
    house_number: address.house_number,
    city: address.city,
    postal_code: address.postal_code,
    country: address.country
  };
}
;// ./react/portal/customer/CustomerInfo/index.tsx
function CustomerInfo_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CustomerInfo_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CustomerInfo_ownKeys(Object(t), !0).forEach(function (r) { CustomerInfo_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CustomerInfo_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CustomerInfo_defineProperty(obj, key, value) { key = CustomerInfo_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function CustomerInfo_toPropertyKey(t) { var i = CustomerInfo_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function CustomerInfo_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












function CustomerInfo() {
  var _formProgress$is_bill, _formProgress$shippin, _errors$customer_bloc, _errors$customer_bloc2, _errors$customer_bloc3, _formProgress$shippin2, _errors$new_shipping_;
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [billingSameAsShipping, setBillingSameAsShipping] = (0,react.useState)((_formProgress$is_bill = formProgress.is_billing_address_same_as_shipping_address) !== null && _formProgress$is_bill !== void 0 ? _formProgress$is_bill : false);
  const [shippingAddress, setShippingAddress] = (0,react.useState)(toJustAddress(formProgress.new_shipping_address));
  const [billingAddress, setBillingAddress] = (0,react.useState)(toJustAddress(formProgress.new_billing_address));
  const handleChangeBillingAddress = (0,react.useCallback)(value => {
    setBillingAddress(value);
  }, []);
  const isShippingAddressFilled = Boolean(formProgress.new_shipping_address && formProgress.new_shipping_address.name && formProgress.new_shipping_address.city && formProgress.new_shipping_address.country && formProgress.new_shipping_address.street && formProgress.new_shipping_address.postal_code && formProgress.new_shipping_address.house_number);
  const isBillingAddressFilled = Boolean(formProgress.new_billing_address && formProgress.new_billing_address.name && formProgress.new_billing_address.city && formProgress.new_billing_address.country && formProgress.new_billing_address.street && formProgress.new_billing_address.postal_code && formProgress.new_billing_address.house_number);
  const [displayShippingAddress, setDisplayShippingAddress] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setDisplayShippingAddress(formProgress.is_shipping_address_required);
  }, [formProgress.is_shipping_address_required, formProgress.shipping_route, (_formProgress$shippin = formProgress.shipping_route) === null || _formProgress$shippin === void 0 ? void 0 : _formProgress$shippin.provider_config]);
  const [shippingAddressPreview, setShippingAddressPreview] = (0,react.useState)(isShippingAddressFilled);
  const [billingAddressPreview, setBillingAddressPreview] = (0,react.useState)(isBillingAddressFilled);
  const [customerBlocksData, setCustomerBlocksData] = (0,react.useState)(() => {
    var _formProgress$custome, _formProgress$custome2;
    return CustomerInfo_objectSpread(CustomerInfo_objectSpread({}, formProgress.customer_blocks_data), {}, {
      customer_phone: formProgress.is_contact_phone_number_required || formProgress.form.blocks.find(block => block.ticket_field === 'customer_phone') ? (_formProgress$custome = formProgress.customer_blocks_data.customer_phone) !== null && _formProgress$custome !== void 0 ? _formProgress$custome : '' : undefined,
      custom_fields: (_formProgress$custome2 = formProgress.customer_blocks_data.custom_fields) !== null && _formProgress$custome2 !== void 0 ? _formProgress$custome2 : {}
    });
  });
  const [errors, setErrors] = (0,react.useState)({});
  (0,react.useEffect)(() => {
    if (errors.new_shipping_address) {
      setShippingAddressPreview(false);
    }
  }, [errors.new_shipping_address]);
  (0,react.useEffect)(() => {
    if (errors.new_billing_address) {
      setBillingAddressPreview(false);
    }
  }, [errors.new_billing_address]);
  const [submitRef, submit] = useSubmitRef();
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      let billingAddr;
      if (formProgress.is_billing_address_required) {
        billingAddr = displayShippingAddress && billingSameAsShipping ? shippingAddress : billingAddress;
      }
      await updateFormProgress({
        new_shipping_address: formProgress.is_shipping_address_required ? shippingAddress : undefined,
        new_billing_address: billingAddr,
        customer_blocks_data: customerBlocksData,
        is_billing_address_same_as_shipping_address: billingSameAsShipping
      });
      setErrors({});
      navigateNext();
    } catch (errorResponse) {
      if (isResponse(errorResponse) && errorResponse.response.status === 400) {
        setErrors(await getErrors(errorResponse));
      }
    }
  });
  const errorList = [(_errors$customer_bloc = errors.customer_blocks_data) === null || _errors$customer_bloc === void 0 ? void 0 : _errors$customer_bloc.customer_phone, Object.values(((_errors$customer_bloc2 = errors.customer_blocks_data) === null || _errors$customer_bloc2 === void 0 ? void 0 : _errors$customer_bloc2.custom_fields) || [])].flat().filter(Boolean);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Your details')
    }),
    footer: /*#__PURE__*/react.createElement("div", {
      className: "space-y-2"
    }, errorList.length > 0 && /*#__PURE__*/react.createElement(react_ui/* Message */.QB, {
      error: true
    }, errorList.length > 1 ? /*#__PURE__*/react.createElement("ul", {
      className: "ml-4 list-outside list-disc space-y-1"
    }, errorList.map(error => /*#__PURE__*/react.createElement("li", {
      key: error
    }, error))) : /*#__PURE__*/react.createElement("div", null, errorList.map(error => /*#__PURE__*/react.createElement("div", {
      key: error
    }, error)))), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: submit,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue')))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    hidden: true,
    type: "submit",
    ref: submitRef
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Information about you'),
    description: pgettext('portal_i18n', "We'll need just a couple more things.")
  }), /*#__PURE__*/react.createElement("div", {
    className: "mb-10 space-y-4 px-5"
  }, formProgress.is_contact_phone_number_required && !formProgress.form.blocks.find(block => block.ticket_field === 'customer_phone') && /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "phone",
    value: customerBlocksData.customer_phone,
    onChange: customer_phone => setCustomerBlocksData(old => CustomerInfo_objectSpread(CustomerInfo_objectSpread({}, old), {}, {
      customer_phone
    })),
    label: pgettext('portal_i18n', 'Your phone number'),
    helpText: pgettext('portal_i18n', 'Please enter your phone number with a prefix (e.g. +420)'),
    required: true,
    error: (_errors$customer_bloc3 = errors.customer_blocks_data) === null || _errors$customer_bloc3 === void 0 ? void 0 : _errors$customer_bloc3.customer_phone
  }), formProgress.form.blocks.filter(block => block.ticket_custom_field_type || block.ticket_field).map(block => /*#__PURE__*/react.createElement(CustomerInfo_CustomerBlock, {
    key: block.id,
    block: block,
    value: customerBlocksData,
    onChange: setCustomerBlocksData,
    errors: errors,
    readOnly: block.ticket_field === codegen/* BackendPublicEnums */.C.TicketFieldEnum.ORDER_ID && !!formProgress.immutable_order
  }))), displayShippingAddress && /*#__PURE__*/react.createElement("div", {
    className: "my-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: ((_formProgress$shippin2 = formProgress.shipping_route) === null || _formProgress$shippin2 === void 0 ? void 0 : _formProgress$shippin2.provider_config.submit_type) === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.DROP_OFF ? pgettext('portal_i18n', 'Sender address') : pgettext('portal_i18n', 'Pickup address'),
    description: pgettext('portal_i18n', "We'll need your address to order the shipping.")
  }), shippingAddressPreview ? /*#__PURE__*/react.createElement(CustomerInfo_AddressPreview, {
    address: shippingAddress,
    onEditClick: () => setShippingAddressPreview(false)
  }) : /*#__PURE__*/react.createElement(CustomerInfo_Address, {
    countryReadOnly: Boolean((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country) && !((_errors$new_shipping_ = errors.new_shipping_address) !== null && _errors$new_shipping_ !== void 0 && _errors$new_shipping_.country) && formProgress.shipping_route),
    address: shippingAddress,
    changeAddress: setShippingAddress,
    errors: errors.new_shipping_address
  }), formProgress.is_billing_address_required && /*#__PURE__*/react.createElement("div", {
    className: "mt-4 mb-10 px-5"
  }, /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Checkbox, {
    value: billingSameAsShipping,
    onChange: setBillingSameAsShipping,
    label: pgettext('portal_i18n', 'Same as billing address')
  }))), formProgress.is_billing_address_required && !billingSameAsShipping && /*#__PURE__*/react.createElement("div", {
    className: "my-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Billing address'),
    description: pgettext('portal_i18n', "We'll issue an invoice for the shipping with these details.")
  }), billingAddressPreview ? /*#__PURE__*/react.createElement(CustomerInfo_AddressPreview, {
    address: billingAddress,
    onEditClick: () => setBillingAddressPreview(false)
  }) : /*#__PURE__*/react.createElement(CustomerInfo_Address, {
    address: billingAddress,
    changeAddress: handleChangeBillingAddress,
    errors: errors.new_billing_address
  }))));
}
/* harmony default export */ const customer_CustomerInfo = (CustomerInfo);
;// ./react/portal/errors/ErrorFallback.tsx
const _excluded = ["removeError", "isOutdated", "fetching"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function PortalErrorFallback(_ref) {
  let {
      removeError,
      isOutdated,
      fetching
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (fetching) {
    return /*#__PURE__*/react.createElement(react_ui/* Loader */.aH, null);
  }
  if (isOutdated) {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-center p-4"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col items-center rounded-md border border-gray-200 bg-gray-50 p-6"
    }, /*#__PURE__*/react.createElement("div", {
      className: "text-base font-bold leading-6 text-gray-900"
    }, gettext('New version of Retino available.')), /*#__PURE__*/react.createElement("p", {
      className: "text-sm text-gray-500"
    }, gettext("We've just released a new version of Retino.")), /*#__PURE__*/react.createElement("p", {
      className: "text-sm text-gray-500"
    }, gettext('Please refresh the page.')), /*#__PURE__*/react.createElement("div", {
      className: "mt-4",
      style: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
      primary: true,
      onClick: () => window.location.reload()
    }, gettext('Refresh')))));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center rounded-md border border-gray-200 bg-gray-50 p-6"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-bold leading-6 text-gray-900"
  }, gettext("There was an error and we couldn't process your request.")), /*#__PURE__*/react.createElement("p", {
    className: "text-sm text-gray-500"
  }, gettext('Please reload the page and try again. If the error prevails, please contact our support and we will help you.')), /*#__PURE__*/react.createElement("div", {
    className: "mt-4 flex justify-center gap-4"
  }, /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    primary: true,
    onClick: () => window.location.reload()
  }, gettext('Try again')), /*#__PURE__*/react.createElement(react_ui/* Popup */.zD, {
    on: "hover",
    trigger: /*#__PURE__*/react.createElement("a", {
      href: "mailto:support+portal@retino.com",
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/react.createElement(react_ui/* Button */.$n, null, gettext('Contact support')))
  }, /*#__PURE__*/react.createElement("span", null, "support@retino.com")))));
}
/* harmony default export */ const ErrorFallback = (PortalErrorFallback);
;// ./react/portal/products/loop.ts
function getOrderItem(orderItemId, formProgress) {
  var _formProgress$immutab;
  return (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.items.find(item => item.id === orderItemId);
}
function getLoopOrderItemIds(formProgress) {
  var _formProgress$order_i, _formProgress$immutab2, _formProgress$immutab3;
  if ((_formProgress$order_i = formProgress.order_items) !== null && _formProgress$order_i !== void 0 && _formProgress$order_i.length) {
    return formProgress.order_items;
  }
  return (_formProgress$immutab2 = (_formProgress$immutab3 = formProgress.immutable_order) === null || _formProgress$immutab3 === void 0 ? void 0 : _formProgress$immutab3.items.map(item => item.id)) !== null && _formProgress$immutab2 !== void 0 ? _formProgress$immutab2 : [];
}
function getNextOrderItemId(orderItemId, formProgress) {
  const ids = getLoopOrderItemIds(formProgress);
  return ids[ids.indexOf(orderItemId) + 1];
}
function getLoopSubstepProgress(orderItemId, formProgress) {
  const ids = getLoopOrderItemIds(formProgress);
  if (!ids.length) {
    return 0;
  }
  return Math.max(ids.indexOf(orderItemId), 0) / ids.length;
}
;// ./react/portal/exchange/portalExchange.ts
function portalExchange_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function portalExchange_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? portalExchange_ownKeys(Object(t), !0).forEach(function (r) { portalExchange_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : portalExchange_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function portalExchange_defineProperty(obj, key, value) { key = portalExchange_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function portalExchange_toPropertyKey(t) { var i = portalExchange_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function portalExchange_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class PortalExchangeActions {
  constructor(api) {
    this.api = void 0;
    this.api = api;
  }
  loadWizard(formProgressId, immutableOrderItemId) {
    return this.api.PortalFormProgressExchangeWizardApi.retrieve({
      id: formProgressId,
      immutable_order_item: immutableOrderItemId
    });
  }
  searchCatalog(formProgressId, query) {
    return this.api.PortalFormProgressExchangeCatalogApi.list({
      id: formProgressId,
      q: query
    });
  }
  loadVariants(formProgressId, code) {
    return this.api.PortalFormProgressExchangeVariantsApi.retrieve({
      id: formProgressId,
      code
    });
  }
  loadPreview(formProgressId) {
    return this.api.PortalFormProgressExchangePreviewApi.retrieve({
      id: formProgressId
    });
  }
  loadMethods(formProgressId, country) {
    return this.api.PortalFormProgressExchangeMethodsApi.retrieve({
      id: formProgressId,
      country
    });
  }
}
function withExchangeChoice(formProgress, immutableOrderItemId, choice) {
  var _formProgress$exchang;
  const products = formProgress.products.map(product => {
    if (product.immutable_order_item !== immutableOrderItemId) {
      return product;
    }
    if (choice.type === 'SWAP') {
      return portalExchange_objectSpread(portalExchange_objectSpread({}, product), {}, {
        exchange_type: codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.SWAP,
        exchange_code: choice.code
      });
    }
    if (choice.type === 'CREDIT') {
      return portalExchange_objectSpread(portalExchange_objectSpread({}, product), {}, {
        exchange_type: codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.CREDIT,
        exchange_code: ''
      });
    }
    return portalExchange_objectSpread(portalExchange_objectSpread({}, product), {}, {
      exchange_type: null,
      exchange_code: ''
    });
  });
  let purchases = [...((_formProgress$exchang = formProgress.exchange_purchases) !== null && _formProgress$exchang !== void 0 ? _formProgress$exchang : [])];
  if (choice.type === 'CREDIT') {
    purchases.push({
      code: choice.purchaseCode,
      amount: '1'
    });
  }
  const hasCreditItem = products.some(product => product.exchange_type === codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.CREDIT);
  if (!hasCreditItem) {
    purchases = [];
  }
  return {
    products,
    exchange_purchases: purchases
  };
}
function withoutPurchase(formProgress, index) {
  var _formProgress$exchang2;
  const purchases = ((_formProgress$exchang2 = formProgress.exchange_purchases) !== null && _formProgress$exchang2 !== void 0 ? _formProgress$exchang2 : []).filter((purchase, purchaseIndex) => purchaseIndex !== index);
  const products = purchases.length ? formProgress.products : formProgress.products.map(product => product.exchange_type === BackendPublicEnums.ExchangeTypeEnum.CREDIT ? portalExchange_objectSpread(portalExchange_objectSpread({}, product), {}, {
    exchange_type: null,
    exchange_code: ''
  }) : product);
  return {
    products,
    exchange_purchases: purchases
  };
}
function hasExchangeDecision(formProgress) {
  var _formProgress$exchang3;
  return formProgress.products.some(product => product.exchange_type) || ((_formProgress$exchang3 = formProgress.exchange_purchases) !== null && _formProgress$exchang3 !== void 0 ? _formProgress$exchang3 : []).length > 0;
}
function exchangeBalance(preview) {
  const surcharge = Number(preview.surcharge);
  const refund = Number(preview.refund_due);
  if (surcharge > 0) {
    return {
      kind: 'surcharge',
      amount: surcharge
    };
  }
  if (refund > 0) {
    return {
      kind: 'refund',
      amount: refund
    };
  }
  return {
    kind: 'even',
    amount: 0
  };
}
;// ./react/portal/exchange/useExchangePreview.ts




function useExchangePreview() {
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const active = hasExchangeDecision(formProgress);
  const [preview, setPreview] = (0,react.useState)(null);
  const [failed, setFailed] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (!active) {
      setPreview(null);
      setFailed(false);
      return undefined;
    }
    let cancelled = false;
    actions.loadPreview(formProgress.id).then(response => {
      if (!cancelled) {
        setPreview(response);
        setFailed(false);
      }
    }).catch(() => {
      if (!cancelled) {
        setPreview(null);
        setFailed(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgress, active]);
  return {
    preview,
    failed,
    active
  };
}
/* harmony default export */ const exchange_useExchangePreview = (useExchangePreview);
;// ./react/portal/exchange/components.tsx






function ItemThumb(_ref) {
  let {
    imageUrl,
    name,
    size = 'size-12'
  } = _ref;
  if (!imageUrl) {
    return /*#__PURE__*/react.createElement("div", {
      className: "".concat(size, " flex shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-400 ring-1 ring-inset ring-gray-950/5")
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-lg font-semibold"
    }, name.charAt(0)));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(size, " shrink-0 overflow-hidden rounded-lg bg-white ring-1 ring-gray-950/10")
  }, /*#__PURE__*/react.createElement("img", {
    className: "h-full w-full object-contain",
    src: imageUrl,
    alt: name
  }));
}
function ChoiceRow(_ref2) {
  let {
    title,
    icon,
    iconPrimary,
    selected,
    disabled,
    onClick
  } = _ref2;
  return /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "flex w-full items-center gap-3 bg-white px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--colors-primary)] ".concat(disabled ? 'cursor-not-allowed opacity-60' : 'hover:bg-gray-50'),
    disabled: disabled,
    onClick: onClick
  }, icon && /*#__PURE__*/react.createElement("div", {
    className: "flex w-5 shrink-0 justify-center ".concat(iconPrimary ? 'text-[var(--colors-primary)]' : 'text-gray-400')
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: icon,
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1 text-base font-semibold text-gray-900"
  }, title), onClick && !selected && /*#__PURE__*/react.createElement("span", {
    className: "shrink-0"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "chevron-right",
    solid: true,
    color: "gray",
    colorIntensity: 400,
    fitted: true
  })), selected && /*#__PURE__*/react.createElement("span", {
    className: "flex size-5 shrink-0 items-center justify-center rounded-full bg-[var(--colors-primary)] text-white"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "check",
    solid: true,
    fitted: true,
    size: "small"
  })));
}
function RadioCard(_ref3) {
  let {
    name,
    checked,
    loading,
    onSelect,
    children
  } = _ref3;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card.Label, null, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    name: name,
    checked: checked,
    disabled: loading,
    onChange: onSelect,
    className: "sr-only"
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    loading: loading
  }, children));
}
function RadioMark(_ref4) {
  let {
    selected
  } = _ref4;
  if (selected) {
    return /*#__PURE__*/react.createElement("span", {
      className: "flex size-5 shrink-0 items-center justify-center rounded-full bg-[var(--colors-primary)] text-white"
    }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
      name: "check",
      solid: true,
      fitted: true,
      size: "small"
    }));
  }
  return /*#__PURE__*/react.createElement("span", {
    className: "size-5 shrink-0 rounded-full ring-1 ring-inset ring-gray-300"
  });
}
function BalanceBar() {
  const {
    preview,
    failed
  } = exchange_useExchangePreview();
  if (failed) {
    return /*#__PURE__*/react.createElement("div", {
      className: "rounded-md bg-amber-50 px-4 py-3 text-sm text-amber-800"
    }, pgettext('portal_i18n', 'Some of the selected items are no longer available. Please review your choices.'));
  }
  if (!preview) {
    return null;
  }
  const balance = exchangeBalance(preview);
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-3 rounded-md bg-gray-50 px-4 py-3 ring-1 ring-inset ring-gray-950/10"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Running balance')), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-semibold tabular-nums text-gray-900"
  }, (0,utils/* formatPrice */.$g)(balance.amount, preview.currency)), balance.kind === 'surcharge' && /*#__PURE__*/react.createElement("span", {
    className: "rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-600/20"
  }, pgettext('portal_i18n', 'Surcharge')), balance.kind === 'refund' && /*#__PURE__*/react.createElement("span", {
    className: "rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20"
  }, pgettext('portal_i18n', 'Overpayment'))));
}
// EXTERNAL MODULE: ./react/components/PaddedLoader.tsx
var PaddedLoader = __webpack_require__(90931);
;// ./react/portal/exchange/ExchangeVariants.tsx













function StockBadge(_ref) {
  let {
    orderable
  } = _ref;
  if (orderable) {
    return null;
  }
  return /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 rounded bg-red-100 px-1.5 py-0.5 text-xs font-medium text-red-800"
  }, pgettext('portal_i18n', 'Out of stock'));
}
function DeltaLabel(_ref2) {
  let {
    delta,
    currency
  } = _ref2;
  if (delta === 0) {
    return null;
  }
  return /*#__PURE__*/react.createElement("span", {
    className: "truncate tabular-nums ".concat(delta < 0 ? 'text-green-700' : 'text-gray-500')
  }, delta < 0 ? '−' : '+', (0,utils/* formatPrice */.$g)(Math.abs(delta), currency));
}
function ExchangeVariants() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    orderItemId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const immutableOrder = formProgress.immutable_order;
  const currentOrderItem = immutableOrder.items.find(item => item.id === orderItemId);
  const currentProduct = formProgress.products.find(product => product.immutable_order_item === orderItemId);
  const [options, setOptions] = (0,react.useState)(null);
  const [shippingHint, setShippingHint] = (0,react.useState)(null);
  const [selectedCode, setSelectedCode] = (0,react.useState)((currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.exchange_code) || undefined);
  (0,react.useEffect)(() => {
    let cancelled = false;
    actions.loadWizard(formProgressId, orderItemId).then(wizard => {
      if (cancelled || !wizard.options) {
        return;
      }
      setOptions(wizard.options);
      setShippingHint(wizard.shipping_hint);
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgressId, orderItemId]);
  const [handleConfirm, isSaving] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const updated = withExchangeChoice(formProgress, orderItemId, {
      type: 'SWAP',
      code: selectedCode
    });
    const updatedFormProgress = await updateFormProgress(updated);
    const nextOrderItemId = getNextOrderItemId(orderItemId, formProgress);
    if (nextOrderItemId) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
        companyId,
        formProgressId,
        orderItemId: nextOrderItemId,
        lang
      }));
    } else {
      navigateNext(updatedFormProgress);
    }
  });
  if (!options || !currentProduct) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  const currency = immutableOrder.currency;
  const selectedVariant = options.variants.find(variant => variant.code === selectedCode);
  const selectedVariantDelta = selectedVariant ? Number(selectedVariant.price_delta) : null;
  const hasStructuredAxes = options.axes.length > 0;
  const singleAxis = options.axes.length === 1 ? options.axes[0] : null;
  const hasAnyDelta = options.variants.some(variant => Number(variant.price_delta) !== 0);
  // A grid column never grows to its content, so it must already fit a price.
  const hasShortValues = !!(singleAxis !== null && singleAxis !== void 0 && singleAxis.values.every(value => String(value).length <= 8));
  let variantsLayout = 'flex flex-wrap gap-2';
  if (hasShortValues && hasAnyDelta) {
    variantsLayout = 'grid grid-cols-[repeat(auto-fill,minmax(6rem,1fr))] gap-2';
  } else if (hasShortValues) {
    variantsLayout = 'grid grid-cols-[repeat(auto-fill,minmax(4.5rem,1fr))] gap-2';
  }
  const hasTrailingStatus = hasAnyDelta || options.variants.some(variant => !variant.is_orderable);
  const variantValues = variant => options.axes.map(axis => String(variant.parameters[axis.name]));
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Choose another variant'),
      substepProgress: getLoopSubstepProgress(orderItemId, formProgress)
    }),
    footer: /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-4"
    }, /*#__PURE__*/react.createElement(BalanceBar, null), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleConfirm,
      loading: isSaving,
      disabled: !(selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.is_orderable)
    }, pgettext('portal_i18n', 'Confirm selection')))
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4 px-5 pb-4"
  }, /*#__PURE__*/react.createElement(ItemThumb, {
    imageUrl: currentOrderItem.image_url,
    name: currentOrderItem.name
  }), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-semibold text-gray-900"
  }, currentOrderItem.name), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, [pgettext('portal_i18n', 'Currently:'), [currentOrderItem.variant, (0,utils/* formatPrice */.$g)(Number(currentOrderItem.unit_price_with_vat), currency)].filter(Boolean).join(' · ')].join(' ')))), singleAxis ? /*#__PURE__*/react.createElement("div", {
    className: "border-y border-gray-950/10 bg-white px-5 py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mb-2 text-xs font-medium uppercase tracking-wide text-gray-500"
  }, singleAxis.name), /*#__PURE__*/react.createElement("div", {
    className: variantsLayout,
    role: "radiogroup",
    "aria-label": singleAxis.name
  }, options.variants.map(variant => {
    const isSelected = variant.code === selectedCode && variant.is_orderable;
    const priceDelta = Number(variant.price_delta);
    let buttonStateClasses = 'border-gray-300 text-gray-900 hover:border-gray-400 hover:bg-gray-50';
    if (!variant.is_orderable) {
      buttonStateClasses = 'cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400';
    } else if (isSelected) {
      buttonStateClasses = 'border-[var(--colors-primary)] bg-[var(--colors-primary)]/10 font-semibold text-gray-900 ring-1 ring-[var(--colors-primary)]';
    }
    return /*#__PURE__*/react.createElement("button", {
      key: variant.code,
      type: "button",
      role: "radio",
      "aria-checked": isSelected,
      title: variant.is_orderable ? undefined : pgettext('portal_i18n', 'Out of stock'),
      className: "min-h-11 max-w-full break-words rounded-md border px-3 py-2 text-center text-sm tabular-nums focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--colors-primary)] ".concat(buttonStateClasses),
      disabled: !variant.is_orderable,
      onClick: () => setSelectedCode(variant.code)
    }, /*#__PURE__*/react.createElement("span", {
      className: variant.is_orderable ? undefined : 'line-through'
    }, variantValues(variant)[0]), !variant.is_orderable && /*#__PURE__*/react.createElement("span", {
      className: "sr-only"
    }, pgettext('portal_i18n', 'Out of stock')), hasAnyDelta && /*#__PURE__*/react.createElement("span", {
      className: "mt-0.5 block h-4 text-xs font-normal"
    }, variant.is_orderable && /*#__PURE__*/react.createElement(DeltaLabel, {
      delta: priceDelta,
      currency: currency
    })));
  }))) : /*#__PURE__*/react.createElement("div", {
    className: "divide-y divide-gray-950/5 border-y border-gray-950/10 bg-white",
    role: "radiogroup",
    "aria-label": pgettext('portal_i18n', 'Choose another variant')
  }, hasStructuredAxes && /*#__PURE__*/react.createElement("div", {
    "aria-hidden": true,
    className: "flex items-center gap-3 bg-gray-50 px-5 py-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex min-w-0 flex-1 gap-3"
  }, options.axes.map(axis => /*#__PURE__*/react.createElement("div", {
    key: axis.name,
    className: "min-w-0 flex-1 basis-0 text-xs font-medium uppercase tracking-wide text-gray-500"
  }, axis.name))), hasTrailingStatus && /*#__PURE__*/react.createElement("span", {
    className: "w-28 shrink-0"
  }), /*#__PURE__*/react.createElement("span", {
    className: "size-5 shrink-0"
  })), options.variants.map(variant => /*#__PURE__*/react.createElement("button", {
    key: variant.code,
    type: "button",
    role: "radio",
    "aria-checked": variant.code === selectedCode && variant.is_orderable,
    className: "flex w-full items-center gap-3 px-5 py-3.5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--colors-primary)] ".concat(variant.is_orderable ? 'hover:bg-gray-50' : 'cursor-not-allowed opacity-60', " ").concat(variant.code === selectedCode && variant.is_orderable ? 'bg-[var(--colors-primary)]/5 font-medium' : ''),
    disabled: !variant.is_orderable,
    onClick: () => setSelectedCode(variant.code)
  }, hasStructuredAxes ? /*#__PURE__*/react.createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-3"
  }, variantValues(variant).map((value, index) => /*#__PURE__*/react.createElement("div", {
    key: options.axes[index].name,
    className: "min-w-0 flex-1 basis-0 text-sm tabular-nums ".concat(variant.is_orderable ? 'text-gray-900' : 'text-gray-500')
  }, value))) : /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1 text-sm ".concat(variant.is_orderable ? 'text-gray-900' : 'text-gray-500')
  }, variant.variant || variant.name), hasTrailingStatus && /*#__PURE__*/react.createElement("div", {
    className: "flex w-28 shrink-0 justify-end text-sm"
  }, !variant.is_orderable && /*#__PURE__*/react.createElement(StockBadge, {
    orderable: false
  }), variant.is_orderable && /*#__PURE__*/react.createElement(DeltaLabel, {
    delta: Number(variant.price_delta),
    currency: currency
  })), /*#__PURE__*/react.createElement(RadioMark, {
    selected: variant.code === selectedCode && variant.is_orderable
  })))), (shippingHint || selectedVariantDelta !== null) && /*#__PURE__*/react.createElement("div", {
    className: "mx-5 mt-4 space-y-1.5 rounded-md bg-gray-50 px-4 py-3 ring-1 ring-inset ring-gray-950/5"
  }, shippingHint && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-2 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-gray-400"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "truck",
    fitted: true,
    size: "small"
  })), /*#__PURE__*/react.createElement("span", {
    className: "min-w-0 flex-1"
  }, pgettext('portal_i18n', 'New goods delivery')), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 tabular-nums text-gray-700"
  }, Number(shippingHint.price) > 0 ? interpolate(pgettext('portal_i18n', 'from %(price)s'), {
    price: (0,utils/* formatPrice */.$g)(Number(shippingHint.price), currency)
  }, true) : pgettext('portal_i18n', 'free'))), selectedVariantDelta !== null && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-2 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-gray-400"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "switch-horizontal",
    fitted: true,
    size: "small"
  })), /*#__PURE__*/react.createElement("span", {
    className: "min-w-0 flex-1 truncate"
  }, pgettext('portal_i18n', 'Goods price difference')), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 tabular-nums ".concat(selectedVariantDelta < 0 ? 'text-green-700' : 'text-gray-700')
  }, selectedVariantDelta > 0 && "+".concat((0,utils/* formatPrice */.$g)(selectedVariantDelta, currency)), selectedVariantDelta < 0 && interpolate(pgettext('portal_i18n', '%(amount)s back to you'), {
    amount: (0,utils/* formatPrice */.$g)(Math.abs(selectedVariantDelta), currency)
  }, true), selectedVariantDelta === 0 && (0,utils/* formatPrice */.$g)(0, currency))))));
}
/* harmony default export */ const exchange_ExchangeVariants = (ExchangeVariants);
;// ./react/portal/exchange/ExchangeCatalog.tsx













function SearchHint(_ref) {
  let {
    icon,
    title,
    children
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3 px-5 py-3.5"
  }, /*#__PURE__*/react.createElement("span", {
    className: "mt-0.5 shrink-0 text-gray-400"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: icon,
    size: "small",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("dt", {
    className: "text-sm font-medium text-gray-900"
  }, title), /*#__PURE__*/react.createElement("dd", {
    className: "text-sm text-gray-500"
  }, children)));
}
function normalizedUrl(url) {
  if (!url) {
    return null;
  }
  return url.match(/^https?:\/\//) ? url : "https://".concat(url);
}
function SearchHints(_ref2) {
  let {
    exampleCode,
    shopUrl
  } = _ref2;
  return /*#__PURE__*/react.createElement("div", {
    className: "mt-3 border-y border-gray-200"
  }, shopUrl && /*#__PURE__*/react.createElement("div", {
    className: "bg-gray-50 px-5 py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Choose on the shop first')), /*#__PURE__*/react.createElement("div", {
    className: "mt-0.5 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Open the shop in a new tab, find the product you want, then paste its name or URL here.')), /*#__PURE__*/react.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true,
    size: "small",
    fluid: false,
    onClick: () => window.open(shopUrl, '_blank', 'noopener,noreferrer')
  }, pgettext('portal_i18n', 'Open shop')))), /*#__PURE__*/react.createElement("dl", {
    className: "divide-y divide-gray-100"
  }, /*#__PURE__*/react.createElement(SearchHint, {
    icon: "search",
    title: pgettext('portal_i18n', 'Search by product name')
  }, pgettext('portal_i18n', 'Accents don’t matter — type it as you remember it.')), /*#__PURE__*/react.createElement(SearchHint, {
    icon: "link",
    title: pgettext('portal_i18n', 'Paste a link from the shop')
  }, pgettext('portal_i18n', 'Open the product in the e-shop and copy the address from the browser.')), /*#__PURE__*/react.createElement(SearchHint, {
    icon: "hashtag",
    title: pgettext('portal_i18n', 'Product code or EAN')
  }, interpolate(pgettext('portal_i18n', 'From the invoice or the product page — e.g. %(code)s.'), {
    code: exampleCode
  }, true))));
}
function ExchangeCatalog() {
  var _currentProduct$amoun, _currentOrderItem$cod, _variants$variants;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    orderItemId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const immutableOrder = formProgress.immutable_order;
  const currentOrderItem = immutableOrder.items.find(item => item.id === orderItemId);
  const currentProduct = formProgress.products.find(product => product.immutable_order_item === orderItemId);
  const [query, setQuery] = (0,react.useState)('');
  const [results, setResults] = (0,react.useState)([]);
  const [isSearching, setIsSearching] = (0,react.useState)(false);
  const [pickedItem, setPickedItem] = (0,react.useState)(null);
  const [variants, setVariants] = (0,react.useState)(null);
  const [selectedCode, setSelectedCode] = (0,react.useState)();
  const [shippingHint, setShippingHint] = (0,react.useState)(null);
  const searchTimer = (0,react.useRef)();
  (0,react.useEffect)(() => {
    let cancelled = false;
    actions.loadWizard(formProgressId, orderItemId).then(wizard => {
      if (!cancelled) {
        setShippingHint(wizard.shipping_hint);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgressId, orderItemId]);
  (0,react.useEffect)(() => {
    if (query.trim().length < 2) {
      setResults([]);
      return undefined;
    }
    let cancelled = false;
    setIsSearching(true);
    searchTimer.current = window.setTimeout(async () => {
      try {
        const rows = await actions.searchCatalog(formProgressId, query.trim());
        if (!cancelled) {
          setResults(rows);
        }
      } finally {
        if (!cancelled) {
          setIsSearching(false);
        }
      }
    }, 300);
    return () => {
      cancelled = true;
      window.clearTimeout(searchTimer.current);
    };
  }, [actions, formProgressId, query]);
  const [handleAddPurchase, isSaving] = (0,hooks/* useAsyncFunction */.m_)(async purchaseCode => {
    const updated = withExchangeChoice(formProgress, orderItemId, {
      type: 'CREDIT',
      purchaseCode
    });
    const updatedFormProgress = await updateFormProgress(updated);
    const nextOrderItemId = getNextOrderItemId(orderItemId, formProgress);
    if (nextOrderItemId) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
        companyId,
        formProgressId,
        orderItemId: nextOrderItemId,
        lang
      }));
    } else {
      navigateNext(updatedFormProgress);
    }
  });
  const handlePickItem = async item => {
    if (item.variant_count < 2) {
      handleAddPurchase(item.code);
      return;
    }
    setPickedItem(item);
    setVariants(null);
    setSelectedCode(undefined);
    const options = await actions.loadVariants(formProgressId, item.code);
    setVariants(options);
  };
  const currency = immutableOrder.currency;
  const credit = (0,utils/* formatPrice */.$g)(Number(currentOrderItem.unit_price_with_vat) * ((_currentProduct$amoun = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.amount) !== null && _currentProduct$amoun !== void 0 ? _currentProduct$amoun : 1), currency);
  const hasQuery = query.trim().length >= 2;
  const shopUrl = normalizedUrl(formProgress.company_shop_url);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Choose another product'),
      substepProgress: getLoopSubstepProgress(orderItemId, formProgress)
    }),
    footer: /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-4"
    }, /*#__PURE__*/react.createElement(BalanceBar, null), pickedItem && variants && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: () => handleAddPurchase(selectedCode),
      loading: isSaving,
      disabled: !selectedCode
    }, pgettext('portal_i18n', 'Add this product')))
  }, /*#__PURE__*/react.createElement("div", null, !pickedItem && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/react.createElement("input", {
    type: "text",
    name: "exchange-product-search",
    value: query,
    autoFocus: true,
    "aria-label": pgettext('portal_i18n', 'Search for a product'),
    className: "block w-full rounded-md border-0 px-3 py-2.5 pr-10 text-base text-gray-900 ring-1 ring-inset ring-gray-950/10 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--colors-primary)] sm:text-sm",
    placeholder: pgettext('portal_i18n', 'Product name, code, EAN or a link from the shop…'),
    onChange: event => setQuery(event.target.value)
  }), isSearching && /*#__PURE__*/react.createElement("span", {
    className: "absolute inset-y-0 right-3 flex items-center"
  }, /*#__PURE__*/react.createElement("span", {
    className: "size-4 animate-spin rounded-full border-2 border-gray-200 border-t-[var(--colors-primary)]"
  }))), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap items-center gap-x-2 pt-2 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Item value'), " ", /*#__PURE__*/react.createElement("span", {
    className: "tabular-nums text-gray-700"
  }, credit)), shippingHint && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true"
  }, "\xB7"), /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Delivery'), ' ', /*#__PURE__*/react.createElement("span", {
    className: "tabular-nums text-gray-700"
  }, Number(shippingHint.price) > 0 ? interpolate(pgettext('portal_i18n', 'from %(price)s'), {
    price: (0,utils/* formatPrice */.$g)(Number(shippingHint.price), currency)
  }, true) : pgettext('portal_i18n', 'free')))))), !hasQuery && /*#__PURE__*/react.createElement(SearchHints, {
    exampleCode: (_currentOrderItem$cod = currentOrderItem.code) !== null && _currentOrderItem$cod !== void 0 ? _currentOrderItem$cod : '49396',
    shopUrl: shopUrl
  }), hasQuery && /*#__PURE__*/react.createElement("div", {
    className: "mt-3 divide-y divide-gray-100 border-y border-gray-200 bg-white ".concat(isSearching ? 'opacity-60' : '')
  }, results.map(item => /*#__PURE__*/react.createElement("button", {
    key: item.code,
    type: "button",
    className: "flex w-full items-center gap-3 px-5 py-4 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--colors-primary)] disabled:cursor-not-allowed disabled:opacity-60",
    disabled: isSaving,
    onClick: () => handlePickItem(item)
  }, /*#__PURE__*/react.createElement(ItemThumb, {
    imageUrl: item.img_url,
    name: item.name
  }), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "truncate text-sm font-semibold text-gray-900"
  }, item.name), item.variant_count > 1 ? /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, interpolate(pgettext('portal_i18n', '%(count)s variants'), {
    count: item.variant_count
  }, true)) : item.variant && /*#__PURE__*/react.createElement("div", {
    className: "truncate text-sm text-gray-500"
  }, item.variant)), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-sm tabular-nums text-gray-700"
  }, (0,utils/* formatPrice */.$g)(Number(item.price), currency)), /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "chevron-right",
    solid: true,
    color: "gray",
    colorIntensity: 400
  }))), !isSearching && results.length === 0 && /*#__PURE__*/react.createElement("div", {
    className: "px-5 py-4 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'No products found. Try a different name, code, EAN, or paste the product link from the shop.')))), pickedItem && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4 px-5 pb-3"
  }, /*#__PURE__*/react.createElement(ItemThumb, {
    imageUrl: pickedItem.img_url,
    name: pickedItem.name
  }), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "truncate text-sm font-semibold text-gray-900"
  }, pickedItem.name), /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "pt-1 text-sm font-medium text-[var(--colors-primary)] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--colors-primary)]",
    onClick: () => setPickedItem(null)
  }, pgettext('portal_i18n', 'Back to search')))), /*#__PURE__*/react.createElement("div", {
    className: "divide-y divide-gray-100 border-y border-gray-200 bg-white"
  }, ((_variants$variants = variants === null || variants === void 0 ? void 0 : variants.variants) !== null && _variants$variants !== void 0 ? _variants$variants : []).map(variant => /*#__PURE__*/react.createElement("button", {
    key: variant.code,
    type: "button",
    className: "flex w-full items-center gap-3 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--colors-primary)] ".concat(variant.is_orderable ? 'hover:bg-gray-50' : 'cursor-not-allowed opacity-60', " ").concat(variant.code === selectedCode ? 'bg-gray-50' : ''),
    disabled: !variant.is_orderable,
    onClick: () => setSelectedCode(variant.code)
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "truncate text-sm font-semibold ".concat(variant.is_orderable ? 'text-gray-900' : 'text-gray-500')
  }, variant.variant || variant.name), /*#__PURE__*/react.createElement(StockBadge, {
    orderable: variant.is_orderable
  })), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-sm tabular-nums text-gray-700"
  }, (0,utils/* formatPrice */.$g)(Number(variant.price), currency)), /*#__PURE__*/react.createElement(RadioMark, {
    selected: variant.code === selectedCode
  })))))));
}
/* harmony default export */ const exchange_ExchangeCatalog = (ExchangeCatalog);
;// ./react/portal/exchange/ExchangePayment.tsx












function ExchangePayment() {
  var _preview$payment2;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const {
    preview
  } = exchange_useExchangePreview();
  const [methods, setMethods] = (0,react.useState)(null);
  const [selected, setSelected] = (0,react.useState)(formProgress.exchange_payment_method_external_id || undefined);
  (0,react.useEffect)(() => {
    let cancelled = false;
    actions.loadMethods(formProgress.id).then(response => {
      if (!cancelled) {
        setMethods(response);
        setSelected(current => current && response.payment.some(method => method.external_id === current) ? current : undefined);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgress.id]);
  (0,react.useEffect)(() => {
    if (!selected && preview !== null && preview !== void 0 && preview.payment && methods !== null && methods !== void 0 && methods.payment.some(method => {
      var _preview$payment;
      return method.external_id === ((_preview$payment = preview.payment) === null || _preview$payment === void 0 ? void 0 : _preview$payment.external_id);
    })) {
      setSelected(preview.payment.external_id);
    }
  }, [preview, selected, methods]);
  const [handleConfirm, isSaving] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    await updateFormProgress({
      exchange_payment_method_external_id: selected
    });
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdSummary({
      companyId,
      formProgressId,
      lang
    }), {
      replace: true
    });
  });
  if (!methods) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  const currency = formProgress.immutable_order.currency;
  const surcharge = preview ? (0,utils/* formatPrice */.$g)(Number(preview.surcharge), currency) : '';
  const recycledExternalId = preview !== null && preview !== void 0 && (_preview$payment2 = preview.payment) !== null && _preview$payment2 !== void 0 && _preview$payment2.is_recycled ? preview.payment.external_id : undefined;
  const header = interpolate(pgettext('portal_i18n', 'How do you want to pay the surcharge of %(surcharge)s?'), {
    surcharge
  }, true);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Surcharge payment')
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleConfirm,
      loading: isSaving,
      disabled: !selected
    }, pgettext('portal_i18n', 'Confirm'))
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: header,
    description: pgettext('portal_i18n', 'We will send the payment details once the shop approves the exchange.')
  }), !methods.payment.length && /*#__PURE__*/react.createElement("p", {
    className: "px-5 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'No payment price is available. Please contact the shop.')), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1",
    role: "radiogroup",
    "aria-label": header
  }, methods.payment.map(method => /*#__PURE__*/react.createElement(RadioCard, {
    key: method.external_id,
    name: "exchange-payment-method",
    checked: method.external_id === selected,
    onSelect: () => setSelected(method.external_id)
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900 sm:text-base"
  }, method.name), method.external_id === recycledExternalId && /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, pgettext('portal_i18n', 'Same as your original order'))), /*#__PURE__*/react.createElement("div", {
    className: "flex shrink-0 items-center gap-3"
  }, Number(method.price) > 0 && /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium tabular-nums text-gray-900"
  }, "+", (0,utils/* formatPrice */.$g)(Number(method.price), currency)), /*#__PURE__*/react.createElement(RadioMark, {
    selected: method.external_id === selected
  })))))), /*#__PURE__*/react.createElement("p", {
    className: "px-5 pt-3 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'A method fee, if any, is reflected in the surcharge in the summary.'))));
}
/* harmony default export */ const exchange_ExchangePayment = (ExchangePayment);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(46942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// ./react/portal/exchange/carrierBranchLists.ts
const CARRIER_BRANCH_LISTS = {
  zasilkovna: 'https://www.zasilkovna.cz/pobocky',
  'logistics-packeta': 'https://www.zasilkovna.cz/pobocky',
  'packeta-plus': 'https://www.zasilkovna.cz/pobocky',
  'ppl-cz': 'https://www.ppl.cz/mapa-vydejnich-mist',
  'logistics-ppl': 'https://www.ppl.cz/mapa-vydejnich-mist',
  'ceska-posta': 'https://www.balikovna.cz/cs/vyhledat-balikovnu',
  'logistics-ceska-post': 'https://www.balikovna.cz/cs/vyhledat-balikovnu',
  'logistics-balikovna': 'https://www.balikovna.cz/cs/vyhledat-balikovnu',
  cpost: 'https://www.balikovna.cz/cs/vyhledat-balikovnu',
  glsCz: 'https://gls-group.com/CZ/cs/vydejni-mista-gls/',
  'logistics-gls': 'https://gls-group.com/CZ/cs/vydejni-mista-gls/',
  'dpd-cz': 'https://www.dpd.com/cz/cs/cekam-balik/vydejni-mista/',
  'logistics-dpd': 'https://www.dpd.com/cz/cs/cekam-balik/vydejni-mista/',
  dpd: 'https://www.dpd.com/cz/cs/cekam-balik/vydejni-mista/',
  'dpdsk-prod': 'https://www.dpd.com/sk/sk/pickup/',
  'logistics-dpd-sk': 'https://www.dpd.com/sk/sk/pickup/',
  postSk: 'https://www.posta.sk/pobocky-a-balikoboxy',
  'logistics-slovenska-posta': 'https://www.posta.sk/pobocky-a-balikoboxy',
  sps: 'https://www.sps-sro.sk/parcelshopy',
  'sps-prod': 'https://www.sps-sro.sk/parcelshopy',
  wedo: 'https://onedelivery.cz/mapa-boxu-a-vydejnich-mist',
  'logistics-alza': 'https://www.alza.cz/alzabox',
  'bm-alzabox': 'https://www.alza.cz/alzabox'
};
function carrierBranchListUrl(carrierCode) {
  return carrierCode ? CARRIER_BRANCH_LISTS[carrierCode] : undefined;
}
;// ./react/portal/exchange/ExchangeShipping.tsx
function ExchangeShipping_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ExchangeShipping_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ExchangeShipping_ownKeys(Object(t), !0).forEach(function (r) { ExchangeShipping_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ExchangeShipping_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ExchangeShipping_defineProperty(obj, key, value) { key = ExchangeShipping_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ExchangeShipping_toPropertyKey(t) { var i = ExchangeShipping_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function ExchangeShipping_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
















const REQUIRED_ADDRESS_FIELDS = ['name', 'street', 'city', 'zip'];
function originalDeliveryAddress(order) {
  const useShipping = Boolean(order.shipping_address_name);
  const pick = (shipping, billing) => {
    var _ref;
    return (_ref = useShipping ? shipping : billing) !== null && _ref !== void 0 ? _ref : '';
  };
  return {
    name: pick(order.shipping_address_name, order.billing_address_name),
    company: pick(order.shipping_address_company, order.billing_address_company) || undefined,
    street: [pick(order.shipping_address_street, order.billing_address_street), pick(order.shipping_address_housenumber, order.billing_address_housenumber)].filter(Boolean).join(' '),
    city: pick(order.shipping_address_city, order.billing_address_city),
    zip: pick(order.shipping_address_zip, order.billing_address_zip),
    country: pick(order.shipping_address_country, order.billing_address_country) || undefined,
    phone: order.customer_phone || undefined
  };
}
function AddressLines(_ref2) {
  var _allCountries;
  let {
    address
  } = _ref2;
  return /*#__PURE__*/react.createElement("div", {
    className: "text-sm leading-5 text-gray-500"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, address.name), address.company && /*#__PURE__*/react.createElement("div", null, address.company), /*#__PURE__*/react.createElement("div", null, address.street), /*#__PURE__*/react.createElement("div", null, [address.zip, address.city].filter(Boolean).join(' ')), address.country && /*#__PURE__*/react.createElement("div", null, (_allCountries = constants/* allCountries */.mn[address.country]) !== null && _allCountries !== void 0 ? _allCountries : address.country), address.phone && /*#__PURE__*/react.createElement("div", {
    className: "mt-1"
  }, address.phone));
}
function ShippingNotice(_ref3) {
  let {
    className,
    children
  } = _ref3;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('rounded-md bg-amber-50 px-4 py-3 text-sm text-amber-800', className)
  }, children);
}
function SectionHeading(_ref4) {
  let {
    title,
    description
  } = _ref4;
  return /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("h2", {
    className: "text-sm font-semibold text-gray-900"
  }, title), /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm leading-5 text-gray-500"
  }, description));
}
function ExchangeShipping() {
  var _formProgress$exchang, _formProgress$exchang2, _preview$shipping2, _address$name, _address$company, _address$street, _address$city, _address$zip, _address$country, _address$phone;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const {
    preview
  } = exchange_useExchangePreview();
  const order = formProgress.immutable_order;
  const originalAddress = (0,react.useMemo)(() => originalDeliveryAddress(order), [order]);
  const [methods, setMethods] = (0,react.useState)(null);
  const [methodsCountry, setMethodsCountry] = (0,react.useState)(null);
  const [selected, setSelected] = (0,react.useState)(formProgress.exchange_shipping_method_external_id || undefined);
  const [address, setAddress] = (0,react.useState)((_formProgress$exchang = formProgress.exchange_delivery_address) !== null && _formProgress$exchang !== void 0 ? _formProgress$exchang : null);
  const [editingAddress, setEditingAddress] = (0,react.useState)(false);
  const [showAddressErrors, setShowAddressErrors] = (0,react.useState)(false);
  const [note, setNote] = (0,react.useState)((_formProgress$exchang2 = formProgress.exchange_note) !== null && _formProgress$exchang2 !== void 0 ? _formProgress$exchang2 : '');
  const shippingSectionRef = (0,react.useRef)(null);
  const destinationCountry = (address === null || address === void 0 ? void 0 : address.country) || originalAddress.country || '';
  // Prices depend on the destination; the previous list stays visible while the new one loads.
  const isLoadingMethods = methodsCountry !== destinationCountry;
  (0,react.useEffect)(() => {
    let cancelled = false;
    actions.loadMethods(formProgress.id, destinationCountry).then(response => {
      if (!cancelled) {
        setMethods(response);
        setMethodsCountry(destinationCountry);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgress.id, destinationCountry]);
  (0,react.useEffect)(() => {
    if (!selected && preview !== null && preview !== void 0 && preview.shipping && methods !== null && methods !== void 0 && methods.shipping.some(method => {
      var _preview$shipping;
      return method.external_id === ((_preview$shipping = preview.shipping) === null || _preview$shipping === void 0 ? void 0 : _preview$shipping.external_id);
    })) {
      setSelected(preview.shipping.external_id);
    }
  }, [preview, selected, methods]);
  const missingAddressFields = address ? REQUIRED_ADDRESS_FIELDS.filter(field => {
    var _address$field;
    return !((_address$field = address[field]) !== null && _address$field !== void 0 ? _address$field : '').trim();
  }) : [];
  const [handleConfirm, isSaving] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (missingAddressFields.length) {
      setShowAddressErrors(true);
      return;
    }
    await updateFormProgress({
      exchange_shipping_method_external_id: selected,
      exchange_delivery_address: address,
      exchange_note: note.trim()
    });
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdSummary({
      companyId,
      formProgressId,
      lang
    }), {
      replace: true
    });
  });
  if (!methods) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  const currency = order.currency;
  const recycledExternalId = preview !== null && preview !== void 0 && (_preview$shipping2 = preview.shipping) !== null && _preview$shipping2 !== void 0 && _preview$shipping2.is_recycled ? preview.shipping.external_id : undefined;
  const selectedMethod = methods.shipping.find(method => method.external_id === selected);
  const hasNoShipping = !isLoadingMethods && !methods.shipping.length;
  const isSelectionUnavailable = !isLoadingMethods && Boolean(selected) && !selectedMethod && !hasNoShipping;
  let shippingNotice = null;
  if (hasNoShipping) {
    shippingNotice = pgettext('portal_i18n', 'No shipping price is available for this destination. Please contact the shop.');
  } else if (isSelectionUnavailable) {
    shippingNotice = pgettext('portal_i18n', 'The shipping you selected is not available for this destination. Please choose another one.');
  }
  const branchListUrl = carrierBranchListUrl(selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.carrier_code);
  const header = pgettext('portal_i18n', 'Where should we deliver the new goods?');
  const startEditingAddress = () => {
    setAddress(current => current !== null && current !== void 0 ? current : ExchangeShipping_objectSpread({}, originalAddress));
    setEditingAddress(true);
  };
  const resetAddress = () => {
    setAddress(null);
    setEditingAddress(false);
    setShowAddressErrors(false);
  };
  const finishEditingAddress = () => {
    if (missingAddressFields.length) {
      setShowAddressErrors(true);
      return;
    }
    setEditingAddress(false);
    // A new destination can drop the chosen shipping; Done sits far below the list that resolves it.
    if (shippingNotice) {
      var _shippingSectionRef$c;
      (_shippingSectionRef$c = shippingSectionRef.current) === null || _shippingSectionRef$c === void 0 || _shippingSectionRef$c.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const setAddressField = (field, value) => setAddress(current => ExchangeShipping_objectSpread(ExchangeShipping_objectSpread({}, current !== null && current !== void 0 ? current : originalAddress), {}, {
    [field]: value
  }));
  const addressError = field => showAddressErrors && missingAddressFields.includes(field) ? pgettext('portal_i18n', 'Required') : undefined;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Shipping of the new goods')
    }),
    footer: /*#__PURE__*/react.createElement(react.Fragment, null, shippingNotice && /*#__PURE__*/react.createElement(ShippingNotice, null, shippingNotice), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleConfirm,
      loading: isSaving,
      disabled: isLoadingMethods || !selectedMethod
    }, pgettext('portal_i18n', 'Confirm')))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-10 pb-8"
  }, /*#__PURE__*/react.createElement("div", {
    ref: shippingSectionRef,
    className: "scroll-mt-24"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: header,
    description: pgettext('portal_i18n', 'First choose how the shop should send your new order.')
  }), shippingNotice && /*#__PURE__*/react.createElement(ShippingNotice, {
    className: "mx-5 mb-3"
  }, shippingNotice), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1",
    role: "radiogroup",
    "aria-label": header
  }, methods.shipping.map(method => /*#__PURE__*/react.createElement(RadioCard, {
    key: method.external_id,
    name: "exchange-shipping-method",
    checked: method.external_id === selected,
    loading: isLoadingMethods,
    onSelect: () => setSelected(method.external_id)
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900 sm:text-base"
  }, method.name), method.external_id === recycledExternalId && /*#__PURE__*/react.createElement("div", {
    className: "mt-0.5 text-xs text-gray-500"
  }, pgettext('portal_i18n', 'Same as your original order'))), /*#__PURE__*/react.createElement("div", {
    className: "flex shrink-0 items-center gap-3"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium tabular-nums text-gray-900"
  }, (0,utils/* formatPrice */.$g)(Number(method.price), currency)), /*#__PURE__*/react.createElement(RadioMark, {
    selected: method.external_id === selected
  }))))))), /*#__PURE__*/react.createElement("section", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement(SectionHeading, {
    title: pgettext('portal_i18n', 'Delivery address'),
    description: pgettext('portal_i18n', 'If you choose delivery to an address, the shop will use the details below.')
  }), editingAddress ? /*#__PURE__*/react.createElement("div", {
    className: "border-y border-gray-200 bg-white px-5 py-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "name",
    autoComplete: "name",
    value: (_address$name = address === null || address === void 0 ? void 0 : address.name) !== null && _address$name !== void 0 ? _address$name : '',
    onChange: value => setAddressField('name', value),
    label: pgettext('portal_i18n', 'Contact name'),
    required: true,
    error: addressError('name')
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "company",
    autoComplete: "organization",
    value: (_address$company = address === null || address === void 0 ? void 0 : address.company) !== null && _address$company !== void 0 ? _address$company : '',
    onChange: value => setAddressField('company', value),
    label: pgettext('portal_i18n', 'Company')
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "street",
    autoComplete: "street-address",
    value: (_address$street = address === null || address === void 0 ? void 0 : address.street) !== null && _address$street !== void 0 ? _address$street : '',
    onChange: value => setAddressField('street', value),
    label: pgettext('portal_i18n', 'Street and house number'),
    required: true,
    error: addressError('street')
  }), /*#__PURE__*/react.createElement("div", {
    className: "grid grid-cols-5 gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "col-span-3"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "city",
    autoComplete: "address-level2",
    value: (_address$city = address === null || address === void 0 ? void 0 : address.city) !== null && _address$city !== void 0 ? _address$city : '',
    onChange: value => setAddressField('city', value),
    label: pgettext('portal_i18n', 'City'),
    required: true,
    error: addressError('city')
  })), /*#__PURE__*/react.createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "zip",
    autoComplete: "postal-code",
    value: (_address$zip = address === null || address === void 0 ? void 0 : address.zip) !== null && _address$zip !== void 0 ? _address$zip : '',
    onChange: value => setAddressField('zip', value),
    label: pgettext('portal_i18n', 'Postal code'),
    required: true,
    error: addressError('zip')
  }))), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Select, {
    name: "country",
    value: (_address$country = address === null || address === void 0 ? void 0 : address.country) !== null && _address$country !== void 0 ? _address$country : '',
    onChange: value => setAddressField('country', String(value)),
    label: pgettext('portal_i18n', 'Country'),
    choices: formProgress.form.countries.map(country => ({
      key: country,
      value: country,
      label: constants/* allCountries */.mn[country]
    }))
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "phone",
    type: "tel",
    autoComplete: "tel",
    value: (_address$phone = address === null || address === void 0 ? void 0 : address.phone) !== null && _address$phone !== void 0 ? _address$phone : '',
    onChange: value => setAddressField('phone', value),
    label: pgettext('portal_i18n', 'Phone')
  })), /*#__PURE__*/react.createElement("div", {
    className: "mt-5 flex items-center justify-between gap-4 border-t border-gray-100 pt-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: resetAddress,
    link: true,
    size: "small"
  }, pgettext('portal_i18n', 'Use original address')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: finishEditingAddress,
    primary: true,
    size: "small"
  }, pgettext('portal_i18n', 'Done')))) : /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-500"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "home",
    fitted: true,
    size: "small"
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement(AddressLines, {
    address: address !== null && address !== void 0 ? address : originalAddress
  }), address && /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: resetAddress,
    className: "mt-2 text-xs font-medium text-gray-500 hover:text-gray-700"
  }, pgettext('portal_i18n', 'Use the address from the original order'))), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    onClick: startEditingAddress,
    size: "small"
  }, pgettext('portal_i18n', 'Edit'))))), /*#__PURE__*/react.createElement("section", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement(SectionHeading, {
    title: pgettext('portal_i18n', 'Delivery details'),
    description: branchListUrl ? pgettext('portal_i18n', 'Choose a pick-up point on the carrier map and paste its name into the note.') : pgettext('portal_i18n', 'Add anything the shop should know when delivering your new order.')
  }), /*#__PURE__*/react.createElement("div", {
    className: "mx-5 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Textarea, {
    name: "exchange-note",
    rows: 3,
    value: note,
    onChange: setNote,
    label: pgettext('portal_i18n', 'Note for delivery'),
    cornerHint: pgettext('portal_i18n', 'Optional'),
    placeholder: pgettext('portal_i18n', 'E.g. the pick-up point or parcel box you want the goods delivered to.')
  })), branchListUrl && /*#__PURE__*/react.createElement("a", {
    href: branchListUrl,
    target: "_blank",
    rel: "noreferrer",
    className: "flex items-center gap-3 border-t border-gray-100 bg-gray-50 px-4 py-3 text-[var(--colors-primary)] hover:bg-gray-100 hover:text-[var(--colors-primary-hover)]"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex size-9 shrink-0 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-gray-950/5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "map",
    fitted: true,
    size: "small"
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium"
  }, pgettext('portal_i18n', 'Open pick-up point map')), /*#__PURE__*/react.createElement("div", {
    className: "truncate text-xs text-gray-500"
  }, selectedMethod.name)), /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "external-link",
    fitted: true,
    size: "tiny"
  }))))));
}
/* harmony default export */ const exchange_ExchangeShipping = (ExchangeShipping);
// EXTERNAL MODULE: ./node_modules/react-string-replace/index.js
var react_string_replace = __webpack_require__(99947);
var react_string_replace_default = /*#__PURE__*/__webpack_require__.n(react_string_replace);
;// ./react/portal/img/email-icon-retina.png
/* harmony default export */ const email_icon_retina = ("https://cdn.retino.com/dist/files/react/portal/img/email-icon-retina.png");
;// ./react/portal/FormAuth/FormAuthPendingVerification/index.tsx











function FormAuthPendingVerification() {
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formAuth
  } = useFormAuth();
  const forms = useForms();
  const publicApi = (0,public_api/* default */.Ay)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const form = forms.find(f => f.id === formAuth.form);
  const handleOpenEmail = () => {
    window.open("https://mail.google.com/mail/#search/noreply@sg.retino.com");
  };
  const [handleProceedManually, isProceedingManually] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthCreateWithoutOrderApi.create({
      id: formAuth.id
    });
    if (response.form_progress) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressDetail({
        companyId,
        formProgressId: response.form_progress,
        lang
      }));
    } else {
      throw new Error('Form progress without order was not created.');
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    footer:
    // When it's gmail and not a phone, show the button
    formAuth.customer_email.includes('gmail.com') && window.outerWidth >= 640 && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleOpenEmail
    }, pgettext('portal_i18n', 'Open Gmail'))
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center px-5 py-12"
  }, /*#__PURE__*/react.createElement("img", {
    width: 237,
    height: 219,
    src: email_icon_retina,
    alt: "sent-mail"
  })), /*#__PURE__*/react.createElement("div", {
    className: "px-5 text-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-lg font-bold text-gray-900"
  }, pgettext('portal_i18n', 'Check your email inbox')), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 text-sm text-gray-500"
  }, react_string_replace_default()(pgettext('portal_i18n', "We have sent an email to your email address %(customer_email)s. You'll find a link to view all your orders there."), '%(customer_email)s', () => /*#__PURE__*/react.createElement("span", {
    className: "font-medium text-gray-900"
  }, formAuth.customer_email)))), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 flex flex-col items-center justify-center gap-2"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.formFormIdEmailOrder({
      companyId,
      formId: formAuth.form,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true
  }, pgettext('portal_i18n', 'Change email address'))), (form === null || form === void 0 ? void 0 : form.allow_manual_ticket_creation) && /*#__PURE__*/react.createElement(react_ui/* Confirm */.pT, {
    onConfirm: handleProceedManually
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    loading: isProceedingManually
  }, pgettext('portal_i18n', 'Create a ticket manually')))));
}
/* harmony default export */ const FormAuth_FormAuthPendingVerification = (FormAuthPendingVerification);
;// ./react/portal/FormAuth/FormAuthVerifiedNoOrders/index.tsx









function FormAuthVerifiedNoOrders(_ref) {
  let {
    email
  } = _ref;
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formAuth
  } = useFormAuth();
  const forms = useForms();
  const form = forms.find(f => f.id === formAuth.form);
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const [handleProceedManually, isProceedingManually] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthCreateWithoutOrderApi.create({
      id: formAuth.id
    });
    if (response.form_progress) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressDetail({
        companyId,
        formProgressId: response.form_progress,
        lang
      }));
    } else {
      throw new Error('Form progress without order was not created.');
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    footer: /*#__PURE__*/react.createElement("div", {
      className: "space-y-4"
    }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
      to: portalRoutes/* default */.A.formFormIdEmailOrder({
        companyId,
        formId: formAuth.form,
        lang
      })
    }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true
    }, pgettext('portal_i18n', 'Change order details'))), (form === null || form === void 0 ? void 0 : form.allow_manual_ticket_creation) && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      onClick: handleProceedManually,
      loading: isProceedingManually
    }, pgettext('portal_i18n', 'Continue without prefilling')))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'No orders found')
  }), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("p", {
    className: "text-sm text-gray-500"
  }, interpolate(form !== null && form !== void 0 && form.allow_manual_ticket_creation ? pgettext('portal_i18n', 'We are really sorry, but we did not find any orders associated with %(customer_email)s. Click Continue if you want to fill in all the information manually.') : pgettext('portal_i18n', 'We are really sorry, but we did not find any orders associated with %(customer_email)s.'), {
    customer_email: email
  }, true))));
}
/* harmony default export */ const FormAuth_FormAuthVerifiedNoOrders = (FormAuthVerifiedNoOrders);
;// ./react/portal/FormAuth/FormAuthVerifyEmail/index.tsx










function FormAuthVerifyEmail() {
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formAuth,
    setFormAuth
  } = useFormAuth();
  const forms = useForms();
  const publicApi = (0,public_api/* default */.Ay)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const form = forms.find(f => f.id === formAuth.form);
  const [handleSendVerification, isSending] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthSendVerificationMailApi.create({
      id: formAuth.id
    });
    setFormAuth(response);
  });
  const [handleProceedManually, isProceedingManually] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthCreateWithoutOrderApi.create({
      id: formAuth.id
    });
    if (response.form_progress) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressDetail({
        companyId,
        formProgressId: response.form_progress,
        lang
      }));
    } else {
      throw new Error('Form progress without order was not created.');
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, null, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'We have not found your order'),
    description: interpolate(pgettext('portal_i18n', 'We have not found an order with the number %(order_number)s associated with the email %(customer_email)s. Please check whether you have filled in the email and the order number correctly.'), {
      order_number: formAuth.order_code,
      customer_email: formAuth.customer_email
    }, true)
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    padded: false,
    header: pgettext('portal_i18n', 'Correct email or order number'),
    description: pgettext('portal_i18n', 'If you made a mistake in your email or order number, please correct the entered data.')
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.formFormIdEmailOrder({
      companyId,
      formId: formAuth.form,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, null, pgettext('portal_i18n', 'Correct email or order number')))))), /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    padded: false,
    header: pgettext('portal_i18n', 'View all orders'),
    description: interpolate(pgettext('portal_i18n', 'We will send you a verification email to %(customer_email)s and then show you all orders associated with this address.'), {
      customer_email: formAuth.customer_email
    }, true)
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true,
    loading: isSending,
    onClick: handleSendVerification
  }, pgettext('portal_i18n', 'Verify email address')))), (form === null || form === void 0 ? void 0 : form.allow_manual_ticket_creation) && /*#__PURE__*/react.createElement("div", {
    className: "px-5 py-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    padded: false,
    header: pgettext('portal_i18n', 'Fill in manually'),
    description: pgettext('portal_i18n', 'You can also create a ticket manually. This is the least convenient way to create a ticket, as you have to fill in all the fields yourself.')
  }), /*#__PURE__*/react.createElement(react_ui/* Confirm */.pT, {
    onConfirm: handleProceedManually
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    loading: isProceedingManually
  }, pgettext('portal_i18n', 'Create a ticket manually')))))));
}
/* harmony default export */ const FormAuth_FormAuthVerifyEmail = (FormAuthVerifyEmail);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(43591);
;// ./react/portal/postMessageApi.tsx



class PostMessageApi {
  constructor() {
    this.listenersPerType = void 0;
    this.listenersPerType = {};
  }
  init() {
    window.addEventListener('message', this.receive.bind(this), false);
  }
  receive(event) {
    const message = event.data;
    if (message.rootId === getPortalRootId() && this.listenersPerType[message.type]) {
      this.listenersPerType[message.type].forEach(listener => listener(message.data));
    }
  }
  registerListener(messageType, listener) {
    if (!this.listenersPerType[messageType]) {
      this.listenersPerType[messageType] = [];
    }
    this.listenersPerType[messageType].push(listener);
    return () => {
      this.unregisterListener(messageType, listener);
    };
  }
  unregisterListener(messageType, listener) {
    if (this.listenersPerType[messageType]) {
      this.listenersPerType[messageType] = this.listenersPerType[messageType].filter(l => l !== listener);
    }
  }
  unregisterListeners(messageType) {
    if (this.listenersPerType[messageType]) {
      this.listenersPerType[messageType] = [];
    }
  }
  static resizeIframe(width, height) {
    const portalRootId = getPortalRootId();
    if (portalRootId) window.parent.postMessage({
      rootId: portalRootId,
      type: 'resize',
      data: {
        width,
        height
      }
    }, '*');
  }
  static displayModal(shouldDisplayModal) {
    window.parent.postMessage({
      rootId: getPortalRootId(),
      type: 'displayModal',
      data: {
        shouldDisplayModal
      }
    }, '*');
  }
  static setUrl(url) {
    window.parent.postMessage({
      rootId: getPortalRootId(),
      type: 'setQueryParam',
      data: {
        key: 'url',
        value: url
      }
    }, '*');
  }
  static ticketCreated() {
    window.parent.postMessage({
      rootId: getPortalRootId(),
      type: 'ticket_created'
    }, '*');
  }
  static requestLocationData() {
    window.parent.postMessage({
      rootId: getPortalRootId(),
      type: 'locationData'
    }, '*');
  }
}
const PostMessageApiContext = /*#__PURE__*/react.createContext(null);
const usePostMessageApi = () => (0,utils/* useContextSafe */.qr)(PostMessageApiContext);
function PostMessageApiProvider(_ref) {
  let {
    children
  } = _ref;
  const [postMessageApi] = (0,react.useState)(() => new PostMessageApi());
  (0,react.useEffect)(() => {
    postMessageApi.init();
  }, [postMessageApi]);
  return /*#__PURE__*/react.createElement(PostMessageApiContext.Provider, {
    value: postMessageApi
  }, children);
}
;// ./react/portal/utils.ts
/* provided dependency */ var utils_moment = __webpack_require__(95093);



function resizeIframeFactory(container) {
  let prev = {
    width: '100%',
    height: 500
  };
  const func = () => {
    const current = {
      width: container.scrollWidth || '100%',
      height: container.scrollHeight
    };
    if ((prev.width !== current.width || prev.height !== current.height) && current.height) {
      PostMessageApi.resizeIframe(current.width, current.height);
      prev = current;
    }
  };
  return func;
}
function setupIframeResizer(observed) {
  const resizeListener = resizeIframeFactory(observed);
  const mutationObserver = new MutationObserver(resizeListener);
  mutationObserver.observe(observed, {
    attributes: true,
    childList: true,
    subtree: true
  });
  try {
    const resizeObserver = new ResizeObserver_es/* default */.A(() => window.requestAnimationFrame(resizeListener));
    resizeObserver.observe(observed);
  } catch (e) {
    console.error(e);
  }
}
function getDayName(date) {
  const today = utils_moment().startOf('day');
  const tomorrow = utils_moment(today).add(1, 'day');
  if (date.isSame(today)) return pgettext('portal_i18n', 'Today');
  if (date.isSame(tomorrow)) return pgettext('portal_i18n', 'Tomorrow');
  return utils/* weekDays */.Mq[date.day() - 1 >= 0 ? date.day() - 1 : 6];
}
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
function getDistanceFromLatLngInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d;
}
function getGeolocationPosition(callback, errorCallback) {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(position => callback(position.coords.latitude, position.coords.longitude), errorCallback !== null && errorCallback !== void 0 ? errorCallback : null);
  } else if (errorCallback) {
    errorCallback();
  }
}
function getPortalRootId() {
  var _window$appState$sear;
  return (_window$appState$sear = window.appState.search) === null || _window$appState$sear === void 0 ? void 0 : _window$appState$sear.get('root-id');
}
function getShippingTypePrice(route) {
  let amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (route) {
    const price = Number(route.customer_amount);
    const currency = route.customer_currency;
    if (!Number.isNaN(price) && currency) {
      if (price === 0) {
        return pgettext('portal_i18n', 'for free');
      }
      return (0,utils/* formatPrice */.$g)(price * amount, currency);
    }
  }
  return '';
}
function getLowestRoutePrice(routes) {
  if (routes === undefined) {
    return '';
  }
  const [minPrice, minPriceCurrency] = (routes || []).reduce((min, item) => Number(item.customer_amount) < min[0] ? [Number(item.customer_amount), item.customer_currency] : min, [Number(routes[0].customer_amount), routes[0].customer_currency]);
  const allSamePrice = routes.every(route => {
    var _route$customer_amoun;
    return Number((_route$customer_amoun = route.customer_amount) !== null && _route$customer_amoun !== void 0 ? _route$customer_amoun : 0) === minPrice && route.customer_currency === minPriceCurrency;
  });
  if (allSamePrice) {
    if (minPrice === 0) {
      return pgettext('portal_i18n', 'for free');
    }
    return (0,utils/* formatPrice */.$g)(minPrice, minPriceCurrency);
  }
  const firstValidCurrency = routes.find(route => route.customer_currency).customer_currency;
  return interpolate(pgettext('portal_i18n', 'from %(price)s'), {
    price: (0,utils/* formatPrice */.$g)(minPrice, firstValidCurrency)
  }, true);
}
;// ./react/portal/FormAuth/OrderSelect/index.tsx
/* provided dependency */ var OrderSelect_moment = __webpack_require__(95093);











function OrderSelect() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formAuth
  } = useFormAuth();
  const forms = useForms();
  const publicApi = (0,public_api/* default */.Ay)();
  const [handleOrderSelect, isSelectingOrder] = (0,hooks/* useAsyncFunction */.m_)(async order => {
    const formProgress = await publicApi.PortalFormProgressApi.create({
      request: {
        order: order.id,
        company: companyId,
        form: formAuth.form,
        location: formAuth.location,
        root_id: getPortalRootId()
      }
    });
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  });
  const form = forms.find(f => f.id === formAuth.form);
  const isTheOnlyOrderOutdated = formAuth.orders.length === 1 && !OrderSelect_moment(formAuth.orders[0].order_date).isAfter(OrderSelect_moment().subtract(form === null || form === void 0 ? void 0 : form.orders_max_age_days, 'days'));
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement("div", {
      className: "w-full border-b border-gray-200 bg-white px-5 pb-3 shadow-md sm:py-6"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex justify-between"
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
      className: "text-sm font-medium leading-6 text-gray-900 sm:text-lg"
    }, pgettext('portal_i18n', 'Select an order')))), /*#__PURE__*/react.createElement("div", {
      className: "sm:mt-1"
    }, /*#__PURE__*/react.createElement(ui/* default */.A.ProgressBar, {
      progress: 15,
      gradient: false
    })), /*#__PURE__*/react.createElement("div", {
      className: "hidden justify-end sm:flex"
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
      className: "text-xs text-gray-500"
    }, pgettext('portal_i18n', 'Next step'), ": "), /*#__PURE__*/react.createElement("span", {
      className: "text-xs font-medium text-gray-500"
    }, pgettext('portal_i18n', 'Order items'))))),
    footer: formAuth.orders.length === 1 && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: !isTheOnlyOrderOutdated,
      loading: isSelectingOrder,
      onClick: () => handleOrderSelect(formAuth.orders[0])
    }, (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.ticket_type_continue_button)))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Your orders'),
    description: pgettext('portal_i18n', 'The orders associated with your email are listed below. Please choose an order.')
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1"
  }, formAuth.orders.sort((a, b) => OrderSelect_moment(b.order_date).diff(OrderSelect_moment(a.order_date))).map(order => {
    const isOrderOutdated = !OrderSelect_moment(order.order_date).isAfter(OrderSelect_moment().subtract(form === null || form === void 0 ? void 0 : form.orders_max_age_days, 'days'));
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
      key: order.id
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
      className: "flex flex-wrap justify-between gap-x-4"
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
      className: "text-base font-medium leading-6 text-gray-900"
    }, pgettext('portal_i18n', 'Order'), " ", order.code)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
      className: "text-sm text-gray-500"
    }, pgettext('portal_i18n', 'ordered on'), " ", OrderSelect_moment(order.order_date).format('LL')))), isOrderOutdated && /*#__PURE__*/react.createElement(react_ui/* Label */.JU, {
      color: "yellow"
    }, pgettext('portal_i18n', 'This order is too old')), /*#__PURE__*/react.createElement("div", {
      className: "mt-4 space-y-4"
    }, order.items.map(item => /*#__PURE__*/react.createElement("div", {
      key: item.id,
      className: "flex items-center gap-4"
    }, item.image_url && /*#__PURE__*/react.createElement("div", {
      className: "flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-md border border-gray-200 bg-white"
    }, /*#__PURE__*/react.createElement("img", {
      src: item.image_url,
      alt: item.image_name
    })), /*#__PURE__*/react.createElement("div", {
      className: "flex flex-grow flex-wrap justify-between gap-x-4 text-sm text-gray-500"
    }, /*#__PURE__*/react.createElement("div", null, Number(item.amount), "\xD7 ", item.name), item.unit_price_with_vat && order.currency && /*#__PURE__*/react.createElement("div", null, (0,utils/* formatPrice */.$g)(item.unit_price_with_vat, order.currency)))))), formAuth.orders.length > 1 && /*#__PURE__*/react.createElement("div", {
      className: "mt-6"
    }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: !isOrderOutdated,
      loading: isSelectingOrder,
      onClick: () => handleOrderSelect(order)
    }, (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.ticket_type_continue_button)))));
  })));
}
/* harmony default export */ const FormAuth_OrderSelect = (OrderSelect);
;// ./react/portal/FormAuth/index.tsx







function FormAuth() {
  const {
    formAuth
  } = useFormAuth();

  // There are orders, let them choose
  if (formAuth.orders.length > 0) {
    return /*#__PURE__*/react.createElement(FormAuth_OrderSelect, null);
  }

  // No orders and email is verified
  if (formAuth.is_email_verified) {
    return /*#__PURE__*/react.createElement(FormAuth_FormAuthVerifiedNoOrders, {
      email: formAuth.customer_email
    });
  }

  // Waiting for email verification
  if (formAuth.is_email_verification_pending) {
    return /*#__PURE__*/react.createElement(FormAuth_FormAuthPendingVerification, null);
  }
  return /*#__PURE__*/react.createElement(FormAuth_FormAuthVerifyEmail, null);
}
/* harmony default export */ const portal_FormAuth = ((0,mobxreact_esm/* observer */.PA)(FormAuth));
;// ./react/portal/FormAuthClosed/index.tsx







function FormAuthClosed() {
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const forms = useForms();
  const {
    formAuth
  } = useFormAuth();
  const form = forms.find(f => f.id === formAuth.form);
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center p-8"
  }, /*#__PURE__*/react.createElement("div", {
    className: "max-w-screen-lg rounded-md border bg-white p-6 text-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-lg font-medium"
  }, pgettext('portal_i18n', 'Ticket creation in progress')), /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'You have an unfinished ticket of the type'), ': ', (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.ticket_type_name)), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.authFormAuthDetail({
      companyId,
      formAuthId: formAuth.id,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true
  }, pgettext('portal_i18n', 'Continue')))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "mr-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'or')), /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.index({
      companyId,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true
  }, pgettext('portal_i18n', 'start from scratch'))))));
}
/* harmony default export */ const portal_FormAuthClosed = (FormAuthClosed);
;// ./react/portal/FormProgressClosed/index.tsx






function FormProgressClosed() {
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  if (formProgress.result_ticket) {
    return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
      to: portalRoutes/* default */.A.index({
        companyId,
        lang
      })
    });
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center p-8"
  }, /*#__PURE__*/react.createElement("div", {
    className: "max-w-screen-lg rounded-md border bg-white p-6 text-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-lg font-medium"
  }, pgettext('portal_i18n', 'Ticket creation in progress')), /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'You have an unfinished ticket of the type'), ' ', (0,utils/* currentLanguage */.aS)(formProgress.form.strings.ticket_type_name)), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.formProgressFormProgressDetail({
      companyId,
      formProgressId: formProgress.id,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true
  }, pgettext('portal_i18n', 'Continue')))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "mr-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'or')), /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.index({
      companyId,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true
  }, pgettext('portal_i18n', 'start from scratch'))))));
}
/* harmony default export */ const portal_FormProgressClosed = (FormProgressClosed);
;// ./react/portal/FormProgressRedirections/index.tsx


function FormProgressRedirections() {
  const {
    formProgress,
    navigateToState
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  (0,react.useEffect)(() => {
    navigateToState(formProgress.state);
  }, []);
  return null;
}
/* harmony default export */ const portal_FormProgressRedirections = (FormProgressRedirections);
;// ./react/portal/layout/ClosedModal.tsx



function ClosedModal() {
  (0,react.useEffect)(() => {
    PostMessageApi.displayModal(false);
  }, []);
  return /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null);
}
/* harmony default export */ const layout_ClosedModal = (ClosedModal);
;// ./react/portal/layout/OpenedModal.tsx





function OpenedModal() {
  const {
    companyId,
    formProgressId,
    formAuthId,
    lang
  } = (0,dist/* useParams */.g)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const postMessageApi = usePostMessageApi();
  const unregisterListener = (0,react.useRef)();
  (0,react.useEffect)(() => {
    PostMessageApi.displayModal(true);
  }, []);
  (0,react.useEffect)(() => {
    const closeOnEscape = event => {
      const isFromSelect = event.target instanceof HTMLSelectElement;
      if (event.key === 'Escape' && !isFromSelect && !document.querySelector('[role="dialog"]')) {
        PostMessageApi.displayModal(false);
      }
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, []);
  const onOutsideModalClose = data => {
    if (!data.isOpen && companyId) {
      if (formProgressId) {
        navigate(portalRoutes/* default */.A.formProgressFormProgressIdClosed({
          companyId,
          formProgressId,
          lang: lang
        }));
      } else if (formAuthId) {
        navigate(portalRoutes/* default */.A.authFormAuthIdClosed({
          companyId,
          formAuthId,
          lang: lang
        }));
      } else {
        navigate(portalRoutes/* default */.A.index({
          companyId,
          lang: lang
        }));
      }
    }
  };
  (0,react.useEffect)(() => {
    if (unregisterListener.current) {
      unregisterListener.current();
    }
    unregisterListener.current = postMessageApi.registerListener('modalState', onOutsideModalClose);
  }, [companyId, formProgressId, formAuthId]);
  return /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null);
}
/* harmony default export */ const layout_OpenedModal = (OpenedModal);
;// ./react/portal/order-search/AuthOrderCodeEmail/index.tsx










function AuthOrderCodeEmail() {
  const {
    formId,
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const forms = useForms();
  const form = forms.find(f => f.id === formId);
  const publicApi = (0,public_api/* default */.Ay)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const [submitRef, clickSubmitRef] = useSubmitRef();
  const [customerMail, setCustomerMail] = (0,react.useState)('');
  const [orderCode, setOrderCode] = (0,react.useState)('');
  const [handleFormAuthCreate, isCreating] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormAuthApi.create({
      request: {
        form: formId,
        location: window.appState.search.get('location'),
        language: window.appState.lang,
        customer_email: customerMail,
        order_code: orderCode,
        root_id: getPortalRootId()
      }
    });
    if (response.form_progress) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
        companyId,
        formProgressId: response.form_progress,
        lang
      }));
    } else {
      navigate(portalRoutes/* default */.A.authFormAuthDetail({
        companyId,
        formAuthId: response.id,
        lang
      }));
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: clickSubmitRef,
      loading: isCreating
    }, pgettext('portal_i18n', 'Order search'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Find your order'),
    description: (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.order_select_subtitle)
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleFormAuthCreate
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6 px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    autoFocus: true,
    required: true,
    name: "order-code",
    label: (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.order_select_code_label),
    value: orderCode,
    onChange: setOrderCode
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    required: true,
    type: "email",
    name: "email",
    label: (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.order_select_email_label),
    value: customerMail,
    onChange: setCustomerMail
  })), /*#__PURE__*/react.createElement("input", {
    ref: submitRef,
    type: "submit",
    className: "hidden"
  })), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 px-5 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: portalRoutes/* default */.A.formFormIdEmail({
      companyId,
      formId,
      lang
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true
  }, pgettext('portal_i18n', "I don't remember the order number")))));
}
/* harmony default export */ const order_search_AuthOrderCodeEmail = (AuthOrderCodeEmail);
;// ./react/portal/order-search/OrderEmailSearch/index.tsx











function PortalOrderSearch() {
  const {
    formId,
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const forms = useForms();
  const form = forms.find(f => f.id === formId);
  const publicApi = (0,public_api/* default */.Ay)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const [submitRef, clickSubmitRef] = useSubmitRef();
  const [customerMail, setCustomerMail] = (0,react.useState)('');
  const [error, setError] = (0,react.useState)({});
  const [handleFormAuthCreate, isCreating] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      const response = await publicApi.PortalFormAuthApi.create({
        request: {
          form: formId,
          location: window.appState.search.get('location'),
          language: window.appState.lang,
          customer_email: customerMail,
          root_id: getPortalRootId()
        }
      });
      await publicApi.PortalFormAuthSendVerificationMailApi.create({
        id: response.id
      });
      setError({});
      if (response.form_progress) {
        navigate(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
          companyId,
          formProgressId: response.form_progress,
          lang
        }));
      } else {
        navigate(portalRoutes/* default */.A.authFormAuthDetail({
          companyId,
          formAuthId: response.id,
          lang
        }));
      }
    } catch (errorResponse) {
      if (isResponse(errorResponse)) {
        const errors = await getErrors(errorResponse);
        setError(errors);
      }
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: clickSubmitRef,
      loading: isCreating
    }, pgettext('portal_i18n', 'Send a verification email'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Email address verification'),
    description: pgettext('portal_i18n', "We'll send you a link to your email address, which will take you to the page with all of your orders.")
  }), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleFormAuthCreate
  }, /*#__PURE__*/react.createElement("input", {
    type: "submit",
    hidden: true,
    ref: submitRef
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    required: true,
    type: "email",
    name: "customer_email",
    label: (0,utils/* currentLanguage */.aS)(form === null || form === void 0 ? void 0 : form.strings.order_select_email_label),
    onChange: setCustomerMail,
    value: customerMail,
    error: error.customer_email
  }))));
}
/* harmony default export */ const OrderEmailSearch = (PortalOrderSearch);
// EXTERNAL MODULE: ./react/img/billing/Powered_by_Stripe-blurple.svg
var Powered_by_Stripe_blurple = __webpack_require__(15110);
;// ./react/portal/payment/Payment/index.tsx














function Payment() {
  var _formProgress$payment3, _formProgress$payment4, _formProgress$drop_of;
  const stripe = (0,react_stripe_umd.useStripe)();
  const elements = (0,react_stripe_umd.useElements)();
  const {
    formProgress,
    navigateNext,
    setFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    preview
  } = exchange_useExchangePreview();
  const publicApi = (0,public_api/* default */.Ay)();
  const [isLoading, setIsLoading] = (0,react.useState)(false);
  const [showLoader, setShowLoader] = (0,react.useState)(false);
  const [errorMessage, setErrorMessage] = (0,react.useState)(null);
  const [handleCreateTicket, isCreatingTicket] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    setIsLoading(true);
    try {
      setFormProgress(await publicApi.PortalFormProgressCreateTicketApi.create({
        id: formProgress.id
      }));
      PostMessageApi.ticketCreated(); // for SkipPay
      setTimeout(navigateNext); // wait for setFormProgress to finish
    } finally {
      setIsLoading(false);
    }
  });
  const handleSubmit = async e => {
    var _window$appState$pare, _formProgress$custome, _formProgress$custome2;
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const elementsValidationResult = await elements.submit();
    if (elementsValidationResult.error) {
      setErrorMessage(elementsValidationResult.error.message || gettext('An error occurred'));
      setIsLoading(false);
      return;
    }
    const result = await stripe.confirmPayment({
      elements,
      clientSecret: formProgress.payment_intent.client_secret,
      confirmParams: {
        return_url: ((_window$appState$pare = window.appState.parentLocation) === null || _window$appState$pare === void 0 ? void 0 : _window$appState$pare.href) || window.location.href,
        payment_method_data: {
          billing_details: {
            name: ((_formProgress$custome = formProgress.customer_blocks_data) === null || _formProgress$custome === void 0 ? void 0 : _formProgress$custome.customer_name) || '',
            phone: ((_formProgress$custome2 = formProgress.customer_blocks_data) === null || _formProgress$custome2 === void 0 ? void 0 : _formProgress$custome2.customer_phone) || ''
          }
        }
      },
      redirect: 'if_required'
    });
    if ('error' in result && result.error) {
      if (result.error.type === 'card_error' || result.error.type === 'validation_error') {
        setErrorMessage(result.error.message || 'An error occurred');
      } else {
        setErrorMessage(gettext('An unexpected error occurred.'));
      }
      setIsLoading(false);
      return;
    }
    if ('paymentIntent' in result && result.paymentIntent && result.paymentIntent.status === 'succeeded') {
      handleCreateTicket();
    }
  };
  (0,react.useEffect)(() => {
    var _formProgress$payment, _formProgress$payment2;
    if (stripe && (_formProgress$payment = formProgress.payment_intent) !== null && _formProgress$payment !== void 0 && _formProgress$payment.client_secret && ((_formProgress$payment2 = formProgress.payment_intent) === null || _formProgress$payment2 === void 0 ? void 0 : _formProgress$payment2.status) === 'succeeded' && !isLoading && !isCreatingTicket && !formProgress.result_ticket) {
      setShowLoader(true);
      handleCreateTicket();
    }
  }, [stripe, (_formProgress$payment3 = formProgress.payment_intent) === null || _formProgress$payment3 === void 0 ? void 0 : _formProgress$payment3.status, formProgress.result_ticket, isLoading, isCreatingTicket, handleCreateTicket, (_formProgress$payment4 = formProgress.payment_intent) === null || _formProgress$payment4 === void 0 ? void 0 : _formProgress$payment4.client_secret]);
  if (showLoader) {
    return /*#__PURE__*/react.createElement(RetinoLoader/* default */.A, null);
  }
  const hasExchangeIntent = formProgress.has_exchange_intent;
  const balance = preview ? exchangeBalance(preview) : null;
  let afterApprovalLabel = null;
  let afterApprovalAmount = null;
  if (preview && (balance === null || balance === void 0 ? void 0 : balance.kind) === 'surcharge') {
    afterApprovalLabel = pgettext('portal_i18n', 'Surcharge · payment instructions by email');
    afterApprovalAmount = (0,utils/* formatPrice */.$g)(balance.amount, preview.currency);
  } else if (preview && (balance === null || balance === void 0 ? void 0 : balance.kind) === 'refund') {
    afterApprovalLabel = pgettext('portal_i18n', 'Refund to you');
    afterApprovalAmount = "\u2212".concat((0,utils/* formatPrice */.$g)(balance.amount, preview.currency));
  } else if (preview && (balance === null || balance === void 0 ? void 0 : balance.kind) === 'even') {
    afterApprovalLabel = pgettext('portal_i18n', 'Nothing more to pay');
    afterApprovalAmount = (0,utils/* formatPrice */.$g)(0, preview.currency);
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Summary'),
      substepProgress: 0.5
    }),
    footer: /*#__PURE__*/react.createElement("div", null, formProgress.form.ticket_type_slug === 'TYPE_RETURN' && /*#__PURE__*/react.createElement("div", {
      className: "mb-1 text-center leading-none"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-xs text-gray-500"
    }, pgettext('portal_i18n', 'By clicking the button below, I withdraw from the contract.'))), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      icon: "lock-closed",
      form: "payment-form",
      primary: true,
      fluid: true,
      submit: true,
      size: "large",
      disabled: !stripe || isLoading || isCreatingTicket,
      loading: isLoading || isCreatingTicket
    }, pgettext('portal_i18n', 'Pay'), ' ', formProgress.payment_intent ? (0,utils/* formatPrice */.$g)(formProgress.payment_intent.amount, formProgress.payment_intent.currency, true) : ''))
  }, !hasExchangeIntent && /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Credit card payment'),
    description: pgettext('portal_i18n', 'Please fill in the credit card to pay for the ordered services.')
  }), hasExchangeIntent && formProgress.payment_intent && formProgress.shipping_route && /*#__PURE__*/react.createElement("div", {
    className: "mb-4 divide-y divide-gray-950/5 border-y border-gray-200 bg-white"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3 px-5 py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, pgettext('portal_i18n', 'Now · Return shipping')), /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, [(0,utils/* currentLanguage */.aS)(formProgress.shipping_route.name), (_formProgress$drop_of = formProgress.drop_off_branch) === null || _formProgress$drop_of === void 0 ? void 0 : _formProgress$drop_of.name].filter(Boolean).join(' · '))), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-sm font-medium tabular-nums text-gray-900"
  }, (0,utils/* formatPrice */.$g)(formProgress.payment_intent.amount, formProgress.payment_intent.currency, true))), afterApprovalLabel && afterApprovalAmount && /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3 px-5 py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, pgettext('portal_i18n', 'After approval')), /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, afterApprovalLabel)), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 text-sm font-medium tabular-nums text-gray-900"
  }, afterApprovalAmount))), /*#__PURE__*/react.createElement("div", {
    className: "space-y-4 border-t border-b bg-white px-5 py-6"
  }, formProgress.payment_intent && /*#__PURE__*/react.createElement("form", {
    id: "payment-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("div", {
    className: "grid gap-2"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Field, null, /*#__PURE__*/react.createElement(react_stripe_umd.PaymentElement, {
    id: "payment-element",
    options: {
      layout: 'tabs'
    }
  })))), errorMessage && /*#__PURE__*/react.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/react.createElement(react_ui/* Message */.QB, {
    error: true
  }, errorMessage)), /*#__PURE__*/react.createElement("p", {
    className: "mt-1.5 text-xs text-gray-700"
  }, gettext('Retino does not store your credit card information. The payment is provided by Stripe.')), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement("img", {
    src: Powered_by_Stripe_blurple/* default */.A,
    alt: "Powered by Stripe",
    height: 24,
    width: "auto",
    className: "h-6 w-auto"
  })))));
}
/* harmony default export */ const payment_Payment = (Payment);
;// ./react/portal/exchange/ExchangeChoice.tsx






function ExchangeChoice(_ref) {
  var _wizard$options$varia, _wizard$options;
  let {
    orderItemId,
    product,
    onPickVariants,
    onPickCatalog,
    onPickRefund,
    onVisibilityChange
  } = _ref;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const actions = (0,react.useMemo)(() => new PortalExchangeActions(publicApi), [publicApi]);
  const [wizard, setWizard] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    let cancelled = false;
    setWizard(null);
    actions.loadWizard(formProgress.id, orderItemId).then(response => {
      if (!cancelled) {
        setWizard(response);
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(response.is_enabled);
      }
    }).catch(() => {
      if (!cancelled) {
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [actions, formProgress.id, onVisibilityChange, orderItemId]);
  if (!wizard || !wizard.is_enabled) {
    return null;
  }
  const swapVariants = ((_wizard$options$varia = (_wizard$options = wizard.options) === null || _wizard$options === void 0 ? void 0 : _wizard$options.variants) !== null && _wizard$options$varia !== void 0 ? _wizard$options$varia : []).filter(variant => variant.is_orderable);
  return /*#__PURE__*/react.createElement("div", {
    className: "pt-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-5 pb-2 text-sm font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'What about this item?')), wizard.exclusion && /*#__PURE__*/react.createElement("div", {
    className: "mx-5 mb-3 rounded-md bg-amber-50 px-4 py-3 text-sm text-amber-800"
  }, pgettext('portal_i18n', 'This item cannot be exchanged, but we can refund it.')), /*#__PURE__*/react.createElement("div", {
    className: "divide-y divide-gray-950/5 border-y border-gray-950/10 bg-white"
  }, !wizard.exclusion && swapVariants.length > 0 && /*#__PURE__*/react.createElement(ChoiceRow, {
    icon: "switch-horizontal",
    iconPrimary: true,
    title: pgettext('portal_i18n', 'Choose another variant'),
    selected: product.exchange_type === codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.SWAP,
    onClick: onPickVariants
  }), !wizard.exclusion && wizard.catalog_enabled && /*#__PURE__*/react.createElement(ChoiceRow, {
    icon: "shopping-bag",
    title: pgettext('portal_i18n', 'Choose another product'),
    selected: product.exchange_type === codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.CREDIT,
    onClick: onPickCatalog
  }), /*#__PURE__*/react.createElement(ChoiceRow, {
    icon: "cash",
    title: pgettext('portal_i18n', 'Return item'),
    selected: false,
    onClick: onPickRefund
  })), /*#__PURE__*/react.createElement("p", {
    className: "px-5 pt-3 text-center text-sm text-gray-500"
  }, pgettext('portal_i18n', 'You can change your choice anytime in the summary.')));
}
/* harmony default export */ const exchange_ExchangeChoice = (ExchangeChoice);
// EXTERNAL MODULE: ./react/portal/products/components/ProductBlock.tsx
var ProductBlock = __webpack_require__(39512);
;// ./react/portal/products/components/ProductFormFields.tsx
function ProductFormFields_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProductFormFields_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProductFormFields_ownKeys(Object(t), !0).forEach(function (r) { ProductFormFields_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProductFormFields_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProductFormFields_defineProperty(obj, key, value) { key = ProductFormFields_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ProductFormFields_toPropertyKey(t) { var i = ProductFormFields_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function ProductFormFields_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




function ProductFormFields(_ref) {
  let {
    blocks,
    currentOrderItem,
    product,
    setProduct,
    setProducts,
    errors
  } = _ref;
  const orderItemAmount = currentOrderItem ? Number(currentOrderItem.amount) : null;
  const showAmountButtons = orderItemAmount !== null && Number.isInteger(orderItemAmount) && orderItemAmount > 1 && orderItemAmount <= 5;
  const showAmountInput = orderItemAmount !== null && orderItemAmount > 1 && !showAmountButtons;
  return /*#__PURE__*/react.createElement(react.Fragment, null, showAmountButtons && /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Field, {
    label: pgettext('portal_i18n', 'Choose the number of pieces'),
    error: errors === null || errors === void 0 ? void 0 : errors.amount
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex gap-2"
  }, [...Array(orderItemAmount).keys()].map(amount => /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    key: amount,
    fluid: false,
    primary: Number(product.amount) === amount + 1,
    onClick: () => {
      if (setProduct) {
        setProduct(old => ProductFormFields_objectSpread(ProductFormFields_objectSpread({}, old), {}, {
          amount: amount + 1
        }));
      } else if (setProducts) {
        setProducts(old => {
          const index = old.findIndex(p => p.id === product.id);
          const p = ProductFormFields_objectSpread(ProductFormFields_objectSpread({}, old[index]), {}, {
            amount: amount + 1
          });
          const newProducts = [...old];
          newProducts.splice(index, 1, p);
          return newProducts;
        });
      }
    }
  }, amount + 1, " ", pgettext('portal_i18n', 'pcs'))))), showAmountInput && /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    label: pgettext('portal_i18n', 'Number of pieces'),
    type: "number",
    name: "amount",
    max: orderItemAmount,
    min: 1,
    value: product.amount,
    error: errors === null || errors === void 0 ? void 0 : errors.amount,
    onChange: amount => {
      if (setProduct) {
        setProduct(old => ProductFormFields_objectSpread(ProductFormFields_objectSpread({}, old), {}, {
          amount: Number(amount)
        }));
      } else if (setProducts) {
        setProducts(old => {
          const index = old.findIndex(p => p.id === product.id);
          const p = ProductFormFields_objectSpread(ProductFormFields_objectSpread({}, old[index]), {}, {
            amount: Number(amount)
          });
          const newProducts = [...old];
          newProducts.splice(index, 1, p);
          return newProducts;
        });
      }
    }
  }), blocks.map(block => /*#__PURE__*/react.createElement(ProductBlock/* default */.A, {
    key: "".concat(product.id, "-").concat(block.id),
    block: block,
    value: product,
    onChange: p => {
      if (setProduct) {
        setProduct(p);
      } else if (setProducts) {
        setProducts(old => {
          const index = old.findIndex(pt => pt.id === p.id);
          const newProducts = [...old];
          newProducts.splice(index, 1, p);
          return newProducts;
        });
      }
    },
    errors: errors
  })));
}
/* harmony default export */ const components_ProductFormFields = (ProductFormFields);
;// ./react/portal/products/ProductDetails/index.tsx
function ProductDetails_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProductDetails_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProductDetails_ownKeys(Object(t), !0).forEach(function (r) { ProductDetails_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProductDetails_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProductDetails_defineProperty(obj, key, value) { key = ProductDetails_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ProductDetails_toPropertyKey(t) { var i = ProductDetails_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function ProductDetails_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
















function getCurrentIndex(orderItemId, formProgress) {
  var _formProgress$order_i, _formProgress$immutab;
  if ((_formProgress$order_i = formProgress.order_items) !== null && _formProgress$order_i !== void 0 && _formProgress$order_i.length) {
    return formProgress.order_items.indexOf(orderItemId);
  }
  return ((_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.items.findIndex(item => item.id === orderItemId)) || 0;
}
function ProductDetailsForm(_ref) {
  var _formProgress$immutab5, _formProgress$order_i5, _formProgress$immutab6, _formProgress$immutab7;
  let {
    currentOrderItem
  } = _ref;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    formProgressId,
    orderItemId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [errors, setErrors] = (0,react.useState)({});
  const currentIndex = getCurrentIndex(orderItemId, formProgress);
  const [product, setProduct] = (0,react.useState)(() => ({
    id: orderItemId,
    name: currentOrderItem.name,
    amount: 1,
    custom_fields: {},
    immutable_order_item: currentOrderItem.id
  }));
  const [openZeroProductsWarning, setOpenZeroProductsWarning] = (0,react.useState)(false);
  // When the exchange choice rows render, they are the primary actions of the
  // screen — the generic continue button hides and the refund row submits.
  const [exchangeChoicesVisible, setExchangeChoicesVisible] = (0,react.useState)(false);
  const [submitRef, submit] = useSubmitRef();
  (0,react.useEffect)(() => {
    const currentProduct = formProgress.products.find(p => p.immutable_order_item === currentOrderItem.id);
    if (currentProduct) {
      setProduct(ProductDetails_objectSpread(ProductDetails_objectSpread({}, currentProduct), {}, {
        id: orderItemId
      }));
    } else {
      setProduct({
        id: orderItemId,
        name: currentOrderItem.name,
        amount: currentOrderItem.amount,
        custom_fields: {},
        immutable_order_item: currentOrderItem.id
      });
    }
  }, [currentOrderItem]);
  const navigateNextOrderItem = (payload, updatedFormProgress) => {
    var _formProgress$order_i2;
    const {
      products
    } = payload;
    let nextOrderItemId;
    if ((_formProgress$order_i2 = formProgress.order_items) !== null && _formProgress$order_i2 !== void 0 && _formProgress$order_i2.length) {
      nextOrderItemId = formProgress.order_items[currentIndex + 1];
    } else {
      var _formProgress$immutab2;
      nextOrderItemId = (_formProgress$immutab2 = formProgress.immutable_order.items[currentIndex + 1]) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.id;
    }
    if (nextOrderItemId) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
        companyId,
        formProgressId,
        orderItemId: nextOrderItemId,
        lang
      }));
    } else if (products.length === 0) {
      setOpenZeroProductsWarning(true);
    } else {
      navigateNext(updatedFormProgress);
    }
  };

  // Purchases are bought with the credit pool; without any CREDIT item the pool is
  // gone and leftover purchases would silently inflate the money math.
  const patchPayload = products => {
    const hasCreditItem = products.some(p => p.exchange_type === codegen/* BackendPublicEnums */.C.ExchangeTypeEnum.CREDIT);
    return {
      products,
      exchange_purchases: hasCreditItem ? formProgress.exchange_purchases : []
    };
  };
  const submitProduct = async productToSubmit => {
    const products = [...formProgress.products.filter(p => p.immutable_order_item !== currentOrderItem.id), productToSubmit];
    const payload = patchPayload(products);
    try {
      const updatedFormProgress = await updateFormProgress(payload);
      setErrors({});
      navigateNextOrderItem(payload, updatedFormProgress);
    } catch (responseError) {
      if (isResponse(responseError) && responseError.response.status === 400) {
        setErrors(await getErrors(responseError));
      }
    }
  };
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(() => submitProduct(product));

  // Variant/catalog pickers live on their own screens; the item form must be saved
  // before leaving so the choice lands on an up-to-date product entry. Backend
  // validation of required blocks is deliberately weak (products are patched
  // incrementally), so browser validation here is the only gate — same as Continue.
  const saveAndNavigate = async to => {
    var _submitRef$current;
    if ((_submitRef$current = submitRef.current) !== null && _submitRef$current !== void 0 && _submitRef$current.form && !submitRef.current.form.reportValidity()) {
      return;
    }
    const products = [...formProgress.products.filter(p => p.immutable_order_item !== currentOrderItem.id), product];
    try {
      await updateFormProgress(patchPayload(products));
      setErrors({});
      navigate(to);
    } catch (responseError) {
      if (isResponse(responseError) && responseError.response.status === 400) {
        setErrors(await getErrors(responseError));
      }
    }
  };
  const handlePickVariants = () => saveAndNavigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemIdExchangeVariants({
    companyId,
    formProgressId,
    orderItemId,
    lang
  }));
  const handlePickCatalog = () => saveAndNavigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemIdExchangeCatalog({
    companyId,
    formProgressId,
    orderItemId,
    lang
  }));
  const [handlePickRefund] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    var _submitRef$current2;
    if ((_submitRef$current2 = submitRef.current) !== null && _submitRef$current2 !== void 0 && _submitRef$current2.form && !submitRef.current.form.reportValidity()) {
      return;
    }
    const refundProduct = ProductDetails_objectSpread(ProductDetails_objectSpread({}, product), {}, {
      exchange_type: null,
      exchange_code: ''
    });
    setProduct(refundProduct);
    await submitProduct(refundProduct);
  });
  const [handleSkipItem, isSkipping] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const products = formProgress.products.filter(p => p.immutable_order_item !== currentOrderItem.id);
    const payload = patchPayload(products);
    const updatedFormProgress = await updateFormProgress(payload);
    navigateNextOrderItem(payload, updatedFormProgress);
  });
  const getSubstepProgress = () => {
    var _formProgress$order_i3, _formProgress$order_i4, _formProgress$immutab3, _formProgress$immutab4;
    const substepNumber = Math.max((_formProgress$order_i3 = (_formProgress$order_i4 = formProgress.order_items) === null || _formProgress$order_i4 === void 0 ? void 0 : _formProgress$order_i4.length) !== null && _formProgress$order_i3 !== void 0 ? _formProgress$order_i3 : 0, (_formProgress$immutab3 = (_formProgress$immutab4 = formProgress.immutable_order) === null || _formProgress$immutab4 === void 0 ? void 0 : _formProgress$immutab4.items.length) !== null && _formProgress$immutab3 !== void 0 ? _formProgress$immutab3 : 0);
    if (substepNumber) {
      const step = 1 / substepNumber;
      return currentIndex * step;
    }
    return 0;
  };
  const substepProgress = (0,react.useMemo)(getSubstepProgress, [currentIndex, (_formProgress$immutab5 = formProgress.immutable_order) === null || _formProgress$immutab5 === void 0 ? void 0 : _formProgress$immutab5.items.length, (_formProgress$order_i5 = formProgress.order_items) === null || _formProgress$order_i5 === void 0 ? void 0 : _formProgress$order_i5.length]);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: (0,utils/* currentLanguage */.aS)(formProgress.form.strings.products_choose_order_items),
      allowBack: substepProgress !== 0,
      substepProgress: substepProgress
    }),
    footer: /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-5"
    }, formProgress.exchange_enabled && /*#__PURE__*/react.createElement(BalanceBar, null), ((_formProgress$immutab6 = (_formProgress$immutab7 = formProgress.immutable_order) === null || _formProgress$immutab7 === void 0 ? void 0 : _formProgress$immutab7.items.length) !== null && _formProgress$immutab6 !== void 0 ? _formProgress$immutab6 : 0) > 1 && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      link: true,
      fluid: true,
      onClick: handleSkipItem,
      loading: isSkipping
    }, (0,utils/* currentLanguage */.aS)(formProgress.form.strings.products_dont_use_this_item)), !exchangeChoicesVisible && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: submit,
      loading: isSubmitting
    }, (0,utils/* currentLanguage */.aS)(formProgress.form.strings.products_continue_button)))
  }, /*#__PURE__*/react.createElement("div", null, currentOrderItem.image_url && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-52 w-52 items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-white"
  }, /*#__PURE__*/react.createElement("img", {
    className: "h-full w-full object-contain",
    src: currentOrderItem.image_url,
    alt: currentOrderItem.name
  }))), /*#__PURE__*/react.createElement("div", {
    className: "px-5 py-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(currentOrderItem.image_url ? 'flex flex-col items-center justify-center' : '')
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "".concat(currentOrderItem.image_url ? 'text-center' : '', " text-base font-medium text-gray-900 line-clamp-2")
  }, currentOrderItem.name)), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500 line-clamp-2"
  }, [currentOrderItem.variant, formProgress.form.show_product_manufacturer && currentOrderItem.manufacturer].filter(Boolean).join(', ')), formProgress.form.show_product_code && currentOrderItem.code && /*#__PURE__*/react.createElement("div", {
    className: "font-mono text-xs text-gray-500"
  }, currentOrderItem.code), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-700"
  }, (0,utils/* formatPrice */.$g)(currentOrderItem.unit_price_with_vat, formProgress.immutable_order.currency)))), /*#__PURE__*/react.createElement(react_ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    hidden: true,
    type: "submit",
    ref: submitRef
  }), /*#__PURE__*/react.createElement("div", {
    className: "space-y-4 px-5"
  }, /*#__PURE__*/react.createElement(components_ProductFormFields, {
    blocks: formProgress.form.blocks.filter(block => block.product_custom_field_type || block.product_field),
    currentOrderItem: currentOrderItem,
    product: product,
    setProduct: setProduct,
    errors: ((_errors$products$leng, _errors$products) => {
      const productIndex = ((_errors$products$leng = errors === null || errors === void 0 || (_errors$products = errors.products) === null || _errors$products === void 0 ? void 0 : _errors$products.length) !== null && _errors$products$leng !== void 0 ? _errors$products$leng : 0) - 1;
      if (productIndex !== undefined && productIndex >= 0) {
        var _errors$products$prod, _errors$products2;
        return (_errors$products$prod = errors === null || errors === void 0 || (_errors$products2 = errors.products) === null || _errors$products2 === void 0 ? void 0 : _errors$products2[productIndex]) !== null && _errors$products$prod !== void 0 ? _errors$products$prod : {};
      }
      return {};
    })()
  }))), formProgress.exchange_enabled && /*#__PURE__*/react.createElement(exchange_ExchangeChoice, {
    orderItemId: orderItemId,
    product: product,
    onPickVariants: handlePickVariants,
    onPickCatalog: handlePickCatalog,
    onPickRefund: handlePickRefund,
    onVisibilityChange: setExchangeChoicesVisible
  })), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF, {
    open: openZeroProductsWarning,
    onClose: () => setOpenZeroProductsWarning(false)
  }, /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Header, null, pgettext('portal_i18n', 'You have not selected any products')), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Content, null, pgettext('portal_i18n', 'You need to select at least one product you want to return.')), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Footer, {
    gray: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true,
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdProductSelectList({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Select items'))))));
}
function ProductDetails() {
  const {
    companyId,
    formProgressId,
    orderItemId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const currentOrderItem = getOrderItem(orderItemId, formProgress);
  if (!currentOrderItem) {
    return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
      replace: true,
      to: portalRoutes/* default */.A.formProgressFormProgressIdProducts({
        companyId,
        formProgressId,
        lang
      })
    });
  }
  return /*#__PURE__*/react.createElement(ProductDetailsForm, {
    currentOrderItem: currentOrderItem
  });
}
/* harmony default export */ const products_ProductDetails = (ProductDetails);
;// ./react/portal/products/Products/OldOrderWarning.tsx
/* provided dependency */ var OldOrderWarning_moment = __webpack_require__(95093);



function OldOrderWarning() {
  var _formProgress$immutab, _formProgress$immutab2;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const comparisonDate = ((_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.delivery_date) || ((_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.order_date);
  return /*#__PURE__*/react.createElement("div", {
    className: "flex w-full bg-yellow-50 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "h-full w-1 bg-yellow-500"
  }), /*#__PURE__*/react.createElement("div", {
    className: "p-5 pl-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-yellow-500"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "exclamation",
    solid: true,
    size: "large"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-yellow-700"
  }, interpolate(pgettext('portal_i18n', 'This order is dated %(order_date)s, the deadline for creating a ticket was %(deadline)s.'), {
    order_date: OldOrderWarning_moment(comparisonDate).format('LL'),
    deadline: OldOrderWarning_moment(comparisonDate).add(formProgress.form.orders_max_age_days, 'day').format('LL')
  }, true))))));
}
/* harmony default export */ const Products_OldOrderWarning = (OldOrderWarning);
// EXTERNAL MODULE: ./react/routes/codegen/clientRoutes.ts
var clientRoutes = __webpack_require__(82085);
;// ./react/portal/products/Products/TicketBoundWarning.tsx
/* provided dependency */ var TicketBoundWarning_moment = __webpack_require__(95093);






function TicketBoundWarning() {
  var _formProgress$immutab;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const tickets = (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.bound_tickets;
  const {
    companyId
  } = (0,dist/* useParams */.g)();
  return /*#__PURE__*/react.createElement("div", {
    className: "flex w-full bg-yellow-50 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "h-full w-1 bg-yellow-500"
  }), /*#__PURE__*/react.createElement("div", {
    className: "p-5 pl-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-yellow-500"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "duplicate",
    solid: true,
    size: "huge"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-yellow-700 flex items-center gap-2"
  }, gettext('Ticket was already created for this order')), /*#__PURE__*/react.createElement("div", {
    className: "space-y-2 mt-2"
  }, tickets === null || tickets === void 0 ? void 0 : tickets.map(ticket => /*#__PURE__*/react.createElement("div", {
    key: ticket.id,
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react.createElement("a", {
    className: "flex items-center",
    href: clientRoutes/* default */.A.ticketTicketDetail({
      lang: window.appState.lang,
      companyId,
      ticketId: ticket.id
    }),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    icon: "external-link",
    link: true
  }, gettext('Ticket'), " ", ticket.code)), /*#__PURE__*/react.createElement("div", {
    className: "text-yellow-700 text-sm"
  }, TicketBoundWarning_moment(ticket.created_at).fromNow())))))))));
}
/* harmony default export */ const Products_TicketBoundWarning = (TicketBoundWarning);
;// ./react/portal/products/Products/WarningContainer.tsx





function WarningContainer(_ref) {
  let {
    children,
    oldOrder,
    ticketBound
  } = _ref;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId
  } = (0,dist/* useParams */.g)();
  const handleSubmit = () => {
    if (formProgress.immutable_order) {
      if (formProgress.immutable_order.items.length < 4) {
        navigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
          lang: window.appState.lang,
          companyId,
          formProgressId: formProgress.id,
          orderItemId: formProgress.immutable_order.items[0].id
        }));
      } else {
        navigate(portalRoutes/* default */.A.formProgressFormProgressIdProductSelectList({
          lang: window.appState.lang,
          companyId,
          formProgressId: formProgress.id
        }));
      }
    }
  };
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Select an order'),
      substepProgress: -0.25
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      onClick: handleSubmit
    }, pgettext('portal_i18n', 'Use the order'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Warning'),
    description: ""
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-4"
  }, children), /*#__PURE__*/react.createElement("div", {
    className: "p-5 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'You can continue with this ticket, but we might reject it.'), ' ', pgettext('portal_i18n', 'If you need to create a new ticket for the same order, click the "Use the order" button below.')));
}
/* harmony default export */ const Products_WarningContainer = (WarningContainer);
;// ./react/portal/products/Products/index.tsx
/* provided dependency */ var Products_moment = __webpack_require__(95093);







function Products() {
  var _formProgress$immutab, _formProgress$immutab2;
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    navigatedFromSummary
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  if (!formProgress.immutable_order) {
    if (formProgress.products.length > 0) {
      return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
        replace: true,
        to: portalRoutes/* default */.A.formProgressFormProgressIdProductCustom({
          companyId,
          formProgressId: formProgress.id,
          lang
        })
      });
    }
    return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
      replace: true,
      to: portalRoutes/* default */.A.formProgressFormProgressIdProductCustom({
        companyId,
        formProgressId: formProgress.id,
        lang
      })
    });
  }
  const comparisonDate = ((_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.delivery_date) || ((_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.order_date);
  const isOrderOutdated = !Products_moment(comparisonDate).isAfter(Products_moment().subtract(formProgress.form.orders_max_age_days, 'days'));
  const isTicketBound = formProgress.immutable_order.bound_tickets.length > 0;
  if ((isOrderOutdated || isTicketBound) && !navigatedFromSummary) {
    return /*#__PURE__*/react.createElement(Products_WarningContainer, {
      oldOrder: isOrderOutdated,
      ticketBound: isTicketBound
    }, isOrderOutdated && /*#__PURE__*/react.createElement(Products_OldOrderWarning, null), isTicketBound && /*#__PURE__*/react.createElement(Products_TicketBoundWarning, null));
  }
  if (formProgress.immutable_order.items.length === 1) {
    return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
      replace: true,
      to: portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
        companyId,
        formProgressId: formProgress.id,
        orderItemId: formProgress.immutable_order.items[0].id,
        lang
      })
    });
  }
  return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
    replace: true,
    to: portalRoutes/* default */.A.formProgressFormProgressIdProductSelectList({
      companyId,
      formProgressId: formProgress.id,
      lang
    })
  });
}
/* harmony default export */ const products_Products = (Products);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(33829);
;// ./react/portal/products/ProductsCustom/ProductForm.tsx
function ProductForm_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProductForm_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProductForm_ownKeys(Object(t), !0).forEach(function (r) { ProductForm_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProductForm_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProductForm_defineProperty(obj, key, value) { key = ProductForm_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ProductForm_toPropertyKey(t) { var i = ProductForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function ProductForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




function ProductForm(_ref) {
  let {
    product,
    setProducts,
    errors
  } = _ref;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    required: true,
    name: "product-name",
    label: pgettext('portal_i18n', 'Item name'),
    value: product.name,
    error: errors === null || errors === void 0 ? void 0 : errors.name,
    onChange: name => setProducts(old => {
      const index = old.findIndex(p => p.id === product.id);
      const p = ProductForm_objectSpread(ProductForm_objectSpread({}, old[index]), {}, {
        name
      });
      const newProducts = [...old];
      newProducts.splice(index, 1, p);
      return newProducts;
    })
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    required: true,
    name: "product-amount",
    label: pgettext('portal_i18n', 'Quantity'),
    value: product.amount,
    error: errors === null || errors === void 0 ? void 0 : errors.amount,
    onChange: amount => setProducts(old => {
      const index = old.findIndex(p => p.id === product.id);
      const p = ProductForm_objectSpread(ProductForm_objectSpread({}, old[index]), {}, {
        amount: Number(amount)
      });
      const newProducts = [...old];
      newProducts.splice(index, 1, p);
      return newProducts;
    }),
    type: "number",
    min: 1
  }), /*#__PURE__*/react.createElement(components_ProductFormFields, {
    product: product,
    setProducts: setProducts,
    blocks: formProgress.form.blocks.filter(block => block.product_custom_field_type || block.product_field),
    errors: errors
  }));
}
/* harmony default export */ const ProductsCustom_ProductForm = (ProductForm);
;// ./react/portal/products/ProductsCustom/index.tsx








const getDefaultProduct = productId => ({
  id: productId,
  name: '',
  amount: 1,
  custom_fields: {}
});
function ProductsCustom() {
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [products, setProducts] = (0,react.useState)(formProgress.products.length > 0 ? formProgress.products : [getDefaultProduct((0,v4/* default */.A)())]);
  const [errors, setErrors] = (0,react.useState)([]);
  const [submitRef, clickSubmitForm] = useSubmitRef();
  const handleAddClick = () => {
    setProducts(old => [...old, getDefaultProduct((0,v4/* default */.A)())]);
  };
  const handleRemoveClick = id => {
    setProducts(old => old.filter(p => p.id !== id));
  };
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      await updateFormProgress({
        products
      });
      navigateNext();
    } catch (errResponse) {
      if (isResponse(errResponse)) {
        setErrors(await getErrors(errResponse));
      }
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Add order items'),
      allowBack: false
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      onClick: clickSubmitForm,
      primary: true,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Add item'),
    description: pgettext('portal_i18n', 'Please fill in your order item information below.')
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    type: "submit",
    hidden: true,
    ref: submitRef
  }), products.map((product, index) => {
    var _errors$products;
    return /*#__PURE__*/react.createElement("div", {
      key: product.id
    }, /*#__PURE__*/react.createElement("div", {
      className: "px-5"
    }, /*#__PURE__*/react.createElement(ProductsCustom_ProductForm, {
      product: product,
      errors: (_errors$products = errors.products) === null || _errors$products === void 0 ? void 0 : _errors$products[index],
      setProducts: setProducts
    }), /*#__PURE__*/react.createElement("div", {
      className: "mt-6 flex justify-between"
    }, /*#__PURE__*/react.createElement("div", null, index === products.length - 1 && /*#__PURE__*/react.createElement("div", {
      className: "mb-6"
    }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      link: true,
      onClick: handleAddClick
    }, pgettext('portal_i18n', 'Add another item')))), /*#__PURE__*/react.createElement("div", null, products.length > 1 && /*#__PURE__*/react.createElement("div", {
      className: "mb-6"
    }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      link: true,
      onClick: () => handleRemoveClick(product.id)
    }, pgettext('portal_i18n', 'Remove item')))))), index < products.length - 1 && /*#__PURE__*/react.createElement("div", {
      className: "mb-6 h-px w-full bg-gray-200"
    }));
  })));
}
/* harmony default export */ const products_ProductsCustom = (ProductsCustom);
;// ./react/portal/products/ProductsSelectList/index.tsx







function ProductSelectList() {
  var _formProgress$product, _formProgress$product2;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [selectedItems, setSelectedItems] = (0,react.useState)((_formProgress$product = (_formProgress$product2 = formProgress.products) === null || _formProgress$product2 === void 0 ? void 0 : _formProgress$product2.map(p => p.id)) !== null && _formProgress$product !== void 0 ? _formProgress$product : []);
  const toggleSelect = itemId => () => {
    setSelectedItems(old => (0,utils/* toggleItem */.g6)(old, itemId));
  };
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    var _formProgress$immutab, _formProgress$product3;
    const orderedItems = [];
    (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 || _formProgress$immutab.items.forEach(item => {
      if (selectedItems.includes(item.id)) {
        orderedItems.push(item.id);
      }
    });
    await updateFormProgress({
      order_items: orderedItems,
      products: (_formProgress$product3 = formProgress.products) === null || _formProgress$product3 === void 0 ? void 0 : _formProgress$product3.filter(p => orderedItems.includes(p.id))
    });
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail({
      companyId,
      formProgressId: formProgress.id,
      orderItemId: orderedItems[0],
      lang
    }));
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Select order items'),
      allowBack: false,
      substepProgress: -0.15
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      disabled: selectedItems.length === 0,
      primary: true,
      onClick: handleSubmit,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Select items'),
    description: (0,utils/* currentLanguage */.aS)(formProgress.form.strings.products_list_text)
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1"
  }, formProgress.immutable_order.items.map(item => /*#__PURE__*/react.createElement(ui/* default */.A.Card.Label, {
    key: item.id
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Checkbox, {
      value: selectedItems.includes(item.id),
      onChange: toggleSelect(item.id)
    })
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-x-4 "
  }, item.image_url && /*#__PURE__*/react.createElement("div", {
    className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded bg-white"
  }, /*#__PURE__*/react.createElement("img", {
    src: item.image_url,
    alt: ""
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium leading-6 text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, Number(item.amount), "\xD7 ", item.name)), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, /*#__PURE__*/react.createElement("span", null, [item.variant, formProgress.form.show_product_manufacturer && item.manufacturer].filter(Boolean).join(', '))), formProgress.form.show_product_code && item.code && /*#__PURE__*/react.createElement("div", {
    className: "font-mono text-xs text-gray-500"
  }, item.code))))))));
}
/* harmony default export */ const ProductsSelectList = (ProductSelectList);
;// ./react/portal/refunds/refundAmount.ts
function plainReturnedItemsRefundAmount(formProgress) {
  var _formProgress$immutab, _formProgress$immutab2;
  const orderItemsById = new Map(((_formProgress$immutab = (_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.items) !== null && _formProgress$immutab !== void 0 ? _formProgress$immutab : []).map(item => [item.id, item]));
  return formProgress.products.reduce((total, product) => {
    var _product$immutable_or, _orderItem$unit_price;
    if (product.exchange_type) {
      return total;
    }
    const orderItem = orderItemsById.get((_product$immutable_or = product.immutable_order_item) !== null && _product$immutable_or !== void 0 ? _product$immutable_or : '');
    return total + product.amount * Number((_orderItem$unit_price = orderItem === null || orderItem === void 0 ? void 0 : orderItem.unit_price_with_vat) !== null && _orderItem$unit_price !== void 0 ? _orderItem$unit_price : 0);
  }, 0);
}
;// ./react/portal/refunds/RefundSelect/index.tsx












const refundOptionsAttributes = new Map();
refundOptionsAttributes.set('TO_BANK_ACCOUNT', {
  bgColor: 'bg-orange-500',
  icon: 'office-building'
});
refundOptionsAttributes.set('VOUCHER', {
  bgColor: 'bg-indigo-500',
  icon: 'receipt-refund'
});
refundOptionsAttributes.set('CUSTOM', {
  bgColor: 'bg-green-500',
  icon: 'cash'
});
function RefundTotalBox(_ref) {
  let {
    returnedItemsAmount,
    overpaymentAmount,
    currency
  } = _ref;
  const formattedReturnedItems = (0,utils/* formatPrice */.$g)(returnedItemsAmount, currency);
  const formattedOverpayment = (0,utils/* formatPrice */.$g)(overpaymentAmount, currency);
  const showBreakdown = returnedItemsAmount > 0 && overpaymentAmount > 0;
  const isOverpaymentOnly = returnedItemsAmount === 0 && overpaymentAmount > 0;
  const isPlainReturnOnly = returnedItemsAmount > 0 && overpaymentAmount === 0;
  return /*#__PURE__*/react.createElement("div", {
    className: "mx-5 mb-4 rounded-md bg-gray-50 px-4 py-3.5 ring-1 ring-inset ring-gray-200"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-xs font-semibold uppercase tracking-wide text-gray-500"
  }, pgettext('portal_i18n', 'We will refund you')), /*#__PURE__*/react.createElement("div", {
    className: "text-2xl font-bold tabular-nums text-gray-900"
  }, (0,utils/* formatPrice */.$g)(returnedItemsAmount + overpaymentAmount, currency)), showBreakdown && /*#__PURE__*/react.createElement("dl", {
    className: "mt-2 space-y-1 border-t border-gray-200 pt-2 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex justify-between gap-3"
  }, /*#__PURE__*/react.createElement("dt", {
    className: "text-gray-500"
  }, pgettext('portal_i18n', 'For the items you return for a refund')), /*#__PURE__*/react.createElement("dd", {
    className: "shrink-0 tabular-nums text-gray-700"
  }, formattedReturnedItems)), /*#__PURE__*/react.createElement("div", {
    className: "flex justify-between gap-3"
  }, /*#__PURE__*/react.createElement("dt", {
    className: "text-gray-500"
  }, pgettext('portal_i18n', 'The exchange — your returned goods cost more than the new ones')), /*#__PURE__*/react.createElement("dd", {
    className: "shrink-0 tabular-nums text-green-700"
  }, "+ ", formattedOverpayment))), isOverpaymentOnly && /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm text-gray-500"
  }, interpolate(pgettext('portal_i18n', 'The goods you return cost %(amount)s more than the new goods from the exchange — we will return the difference to you.'), {
    amount: formattedOverpayment
  }, true)), isPlainReturnOnly && /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'For the items you return for a refund — the exchanged items are not part of it.')));
}
function RefundSelect() {
  var _formProgress$immutab, _preview$refund_due;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    preview
  } = exchange_useExchangePreview();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [loadingRefundOption, setLoadingRefundOption] = (0,react.useState)();
  const currency = (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.currency;
  const showRefundContext = hasExchangeDecision(formProgress) && !!currency;
  const [handleSubmit] = (0,hooks/* useAsyncFunction */.m_)(async refundOptionId => {
    setLoadingRefundOption(refundOptionId);
    try {
      await updateFormProgress({
        refund_option: refundOptionId
      });
    } finally {
      setLoadingRefundOption(null);
    }
    navigateNext();
  });
  const handleRefundOptionClick = refundOption => {
    if (loadingRefundOption) return;
    if (refundOption.type === codegen/* BackendPublicEnums */.C.RefundOptionTypeEnum.TO_BANK_ACCOUNT) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdRefundAccount({
        companyId,
        formProgressId: formProgress.id,
        lang
      }));
    } else {
      handleSubmit(refundOption.id);
    }
  };
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Refund options')
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Choose a refund option'),
    description: pgettext('portal_i18n', 'Please select your preferred refund method below.')
  }), showRefundContext && /*#__PURE__*/react.createElement(RefundTotalBox, {
    returnedItemsAmount: plainReturnedItemsRefundAmount(formProgress),
    overpaymentAmount: Number((_preview$refund_due = preview === null || preview === void 0 ? void 0 : preview.refund_due) !== null && _preview$refund_due !== void 0 ? _preview$refund_due : 0),
    currency: currency
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, formProgress.form.refund_options.map(refundOption => {
    const refundOptionsAttrs = refundOptionsAttributes.get(refundOption.type);
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
      key: refundOption.id,
      rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
      onClick: () => handleRefundOptionClick(refundOption),
      loading: loadingRefundOption === refundOption.id
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex items-center gap-5"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ".concat(refundOptionsAttrs === null || refundOptionsAttrs === void 0 ? void 0 : refundOptionsAttrs.bgColor, " text-white")
    }, refundOptionsAttrs && /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
      name: refundOptionsAttrs.icon,
      size: "huge",
      fitted: true
    })), /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex gap-2"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-sm font-medium leading-5 text-gray-900 line-clamp-2 sm:text-base sm:leading-7"
    }, (0,utils/* currentLanguage */.aS)(refundOption.name))), /*#__PURE__*/react.createElement("span", {
      className: "text-sm text-gray-500"
    }, (0,utils/* currentLanguage */.aS)(refundOption.description)))));
  })));
}
/* harmony default export */ const refunds_RefundSelect = (RefundSelect);
;// ./react/portal/refunds/RefundSelectAccount/index.tsx












function RefundSelectAccount() {
  var _ref, _ref2, _formProgress$refund_;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [accountNumber, setAccountNumber] = (0,react.useState)((_ref = (_ref2 = (_formProgress$refund_ = formProgress.refund_account_iban) !== null && _formProgress$refund_ !== void 0 ? _formProgress$refund_ : formProgress.refund_account_czech_bank) !== null && _ref2 !== void 0 ? _ref2 : formProgress.refund_account_hungarian_bank) !== null && _ref !== void 0 ? _ref : '');
  const [errors, setErrors] = (0,react.useState)({});
  const [submitRef, clickSubmitRef] = useSubmitRef();
  const refundOption = formProgress.form.refund_options.find(option => option.type === codegen/* BackendPublicEnums */.C.RefundOptionTypeEnum.TO_BANK_ACCOUNT);
  const refundOptionsAttrs = refundOption ? refundOptionsAttributes.get(refundOption.type) : null;
  const handleBack = () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdRefund({
    companyId,
    formProgressId: formProgress.id,
    lang
  }));
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      await updateFormProgress({
        refund_option: refundOption === null || refundOption === void 0 ? void 0 : refundOption.id,
        refund_account: accountNumber
      });
      setErrors({});
      navigateNext();
    } catch (errorResponse) {
      if (isResponse(errorResponse) && errorResponse.response.status === 400) {
        setErrors(await getErrors(errorResponse));
      }
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Refund options'),
      substepProgress: 0.5
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: clickSubmitRef,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Choose a refund option'),
    description: pgettext('portal_i18n', 'Please select your preferred refund method below.')
  }), refundOption && /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    leftAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, {
      left: true
    }),
    onClick: handleBack
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ".concat(refundOptionsAttrs === null || refundOptionsAttrs === void 0 ? void 0 : refundOptionsAttrs.bgColor, " text-white")
  }, refundOptionsAttrs && /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: refundOptionsAttrs.icon,
    size: "large",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-base font-medium leading-7 text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(refundOption.name))), /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(refundOption.description))))), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    ref: submitRef,
    type: "submit",
    className: "hidden"
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    autoFocus: true,
    name: "bank-account",
    value: accountNumber,
    onChange: v => setAccountNumber(v),
    label: pgettext('portal_i18n', 'Bank account number'),
    helpText: pgettext('portal_i18n', 'We will refund you to this bank account.'),
    error: errors === null || errors === void 0 ? void 0 : errors.refund_account
  }))));
}
/* harmony default export */ const refunds_RefundSelectAccount = (RefundSelectAccount);
// EXTERNAL MODULE: ./react/components/Coupon/Coupon.tsx
var Coupon = __webpack_require__(38037);
;// ./react/portal/Result/CallRequestModal.tsx






function CallRequestModal(_ref) {
  let {
    remarketingSettingsId,
    open,
    onClose,
    onSuccess
  } = _ref;
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [phoneNumber, setPhoneNumber] = (0,react.useState)('');
  const [error, setError] = (0,react.useState)();
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      await publicApi.MarketplaceRemarketingCallRequestApi.create({
        settings_id: remarketingSettingsId,
        request: {
          ticket_id: formProgress.result_ticket,
          phone_number: phoneNumber
        }
      });
      onSuccess(phoneNumber);
    } catch (e) {
      if (isResponse(e) && e.response.status === 400) {
        setError(await getErrors(e));
      }
    }
  });
  return /*#__PURE__*/react.createElement(react_ui/* Modal */.aF, {
    size: "md",
    open: open,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Content, null, /*#__PURE__*/react.createElement(react_ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Input, {
    label: pgettext('portal_i18n', 'Fill in your phone number'),
    type: "tel",
    name: "phone",
    value: phoneNumber,
    onChange: setPhoneNumber,
    error: error === null || error === void 0 ? void 0 : error.phone_number
  }), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    loading: isSubmitting,
    primary: true,
    fluid: true,
    submit: true,
    icon: "phone",
    iconSolid: true
  }, pgettext('portal_i18n', 'Call me'))))));
}
/* harmony default export */ const Result_CallRequestModal = (CallRequestModal);
;// ./react/portal/Result/Remarketing.tsx











function Remarketing() {
  var _formProgress$voucher, _getTicketVoucherSett, _getTicketVoucherSett2;
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const [settings, setSettings] = (0,react.useState)();
  const [callRequested, setCallRequested] = (0,react.useState)(formProgress.call_requested);
  const [phoneNumber, setPhoneNumber] = (0,react.useState)(formProgress.ticket_phone_number);
  const [callRequestModalOpen, setCallRequestModalOpen] = (0,react.useState)(false);
  const [loadRemarketing] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (formProgress.result_ticket) {
      setSettings(await publicApi.MarketplaceRemarketingSettingsApi.retrieve({
        ticket_id: formProgress.result_ticket
      }));
    }
  });
  const [requestCall, isLoadingRequestCall] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    var _formProgress$custome;
    if ((_formProgress$custome = formProgress.customer_blocks_data) !== null && _formProgress$custome !== void 0 && _formProgress$custome.customer_phone && settings) {
      await publicApi.MarketplaceRemarketingCallRequestApi.create({
        settings_id: settings.id,
        request: {
          ticket_id: formProgress.result_ticket
        }
      });
      setCallRequested(true);
    } else {
      setCallRequestModalOpen(true);
    }
  });
  (0,react.useEffect)(() => {
    loadRemarketing();
  }, []);
  if (!settings) {
    return null;
  }
  const getTicketVoucherSettings = () => {
    var _settings$voucher_set;
    if (!formProgress.ticket_currency) {
      return null;
    }
    return (settings === null || settings === void 0 || (_settings$voucher_set = settings.voucher_settings) === null || _settings$voucher_set === void 0 ? void 0 : _settings$voucher_set[formProgress.ticket_currency]) || null;
  };
  const getExpirationDate = () => {
    if (formProgress.voucher) {
      return formProgress.voucher.valid_to ? new Date(formProgress.voucher.valid_to) : null;
    }
    const voucherSettings = getTicketVoucherSettings();
    if (!(voucherSettings !== null && voucherSettings !== void 0 && voucherSettings.expiration_days)) {
      return null;
    }
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + voucherSettings.expiration_days);
    return expirationDate;
  };
  const displayCallRequest = settings.call_request_in_portal && settings.call_request_text;
  const displayBanner = settings.banner_in_portal && settings.banner_url && settings.banner_image;
  const displayVoucher = formProgress.voucher || settings.can_create_voucher;
  return /*#__PURE__*/react.createElement(react.Fragment, null, displayVoucher && /*#__PURE__*/react.createElement("div", {
    className: "mx-5"
  }, /*#__PURE__*/react.createElement(Coupon/* default */.A, {
    ticketId: formProgress.result_ticket,
    remarketingSettingsId: settings.id,
    shopName: formProgress.company_name,
    color: theme.colors.primary.default,
    textColor: theme.colors.button.default,
    voucherCode: (_formProgress$voucher = formProgress.voucher) === null || _formProgress$voucher === void 0 ? void 0 : _formProgress$voucher.code,
    value: formProgress.voucher ? formProgress.voucher.amount : parseFloat((_getTicketVoucherSett = getTicketVoucherSettings()) === null || _getTicketVoucherSett === void 0 ? void 0 : _getTicketVoucherSett.value),
    currency: formProgress.voucher ? formProgress.voucher.currency : formProgress.ticket_currency,
    expirationDate: getExpirationDate(),
    min_price: formProgress.voucher && 'min_price' in formProgress.voucher ? formProgress.voucher.min_price : (_getTicketVoucherSett2 = getTicketVoucherSettings()) === null || _getTicketVoucherSett2 === void 0 ? void 0 : _getTicketVoucherSett2.min_order_value
  })), displayCallRequest && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium leading-7 text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Should we call you?'))), !callRequested && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(settings.call_request_text)), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: requestCall,
    fluid: true,
    icon: "phone",
    iconSolid: true,
    loading: isLoadingRequestCall
  }, pgettext('portal_i18n', 'Call me')))), callRequested && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 flex items-center text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mr-2 flex h-4 w-4 items-center  text-green-600"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "check",
    size: "tiny",
    fitted: true
  })), /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'We have received your request and our agents will contact you soon on this phone number'), ":", /*#__PURE__*/react.createElement("span", {
    className: "ml-1 font-bold"
  }, phoneNumber)))), /*#__PURE__*/react.createElement(Result_CallRequestModal, {
    remarketingSettingsId: settings.id,
    open: callRequestModalOpen,
    onClose: () => setCallRequestModalOpen(false),
    onSuccess: phone => {
      setPhoneNumber(phone);
      setCallRequested(true);
      setCallRequestModalOpen(false);
    }
  })), displayBanner && /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement("a", {
    href: clientRoutes/* default */.A.marketplaceBanner({
      remarketingSettingsId: settings.id,
      source: 'portal'
    }),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react.createElement("img", {
    src: settings.banner_image_url,
    alt: "banner"
  }))));
}
/* harmony default export */ const Result_Remarketing = (Remarketing);
;// ./react/portal/Result/ShippingAddress.tsx


function ShippingAddress(_ref) {
  let {
    address
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "max-w-min select-text whitespace-nowrap rounded-md border bg-gray-50 py-4 px-5 text-base"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, address.name, ", ", address.company_name), /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-700"
  }, address.street, " ", address.house_number), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-700"
  }, address.city, ", ", address.postal_code), address.country && /*#__PURE__*/react.createElement("div", {
    className: "text-gray-700"
  }, constants/* allCountries */.mn[address.country])));
}
/* harmony default export */ const Result_ShippingAddress = (ShippingAddress);
;// ./react/portal/Result/WhatsNext.tsx




function WhatsNext() {
  var _formProgress$new_shi, _formProgress$immutab, _formProgress$immutab2, _formProgress$shippin, _formProgress$shippin2;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const customerCountry = ((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.country) || ((_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.shipping_address_country) || ((_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.billing_address_country);
  const address = formProgress.form.shipping_addresses.filter(item => item.country === customerCountry)[0];
  const noShippingSelected = !formProgress.shipping_route && !formProgress.shipping_route;
  if (!formProgress.form.show_whats_next) return null;
  if (noShippingSelected && formProgress.form.show_shipping_address_in_result && address) {
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
      className: "text-base font-medium leading-7 text-gray-900"
    }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', "What's next?"))), /*#__PURE__*/react.createElement("div", {
      className: "mt-1 text-sm text-gray-500"
    }, pgettext('portal_i18n', 'Please pack the goods, mark the package with the order code'), ' ', /*#__PURE__*/react.createElement("strong", {
      style: {
        color: 'black'
      }
    }, formProgress.customer_blocks_data.order_id), ' ', pgettext('portal_i18n', 'and send it to this address:')), /*#__PURE__*/react.createElement("div", {
      className: "mt-4"
    }, /*#__PURE__*/react.createElement(Result_ShippingAddress, {
      address: address
    })));
  }
  const isDropOff = ((_formProgress$shippin = formProgress.shipping_route) === null || _formProgress$shippin === void 0 ? void 0 : _formProgress$shippin.provider_config.submit_type) === 'DROP_OFF';
  if (isDropOff) {
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
      className: "text-base font-medium leading-7 text-gray-900"
    }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', "What's next?"))), /*#__PURE__*/react.createElement("div", {
      className: "mt-1 text-sm text-gray-500"
    }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', "Wait until you receive the carrier's return label, pack the goods, and take them to the selected branch."))));
  }
  const isPickup = ((_formProgress$shippin2 = formProgress.shipping_route) === null || _formProgress$shippin2 === void 0 ? void 0 : _formProgress$shippin2.provider_config.submit_type) === 'PICKUP';
  if (isPickup) {
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
      className: "text-base font-medium leading-7 text-gray-900"
    }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', "What's next?"))), /*#__PURE__*/react.createElement("div", {
      className: "mt-1 text-sm text-gray-500"
    }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Properly pack the package and wait for the courier to pick it up.'))));
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium leading-7 text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', "What's next?"))), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'We will send you information about your case by email within a few minutes.'))));
}
/* harmony default export */ const Result_WhatsNext = (WhatsNext);
;// ./react/portal/Result/index.tsx












function Result() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const handleClose = () => {
    PostMessageApi.displayModal(false);
    PostMessageApi.setUrl(null);
    navigate(portalRoutes/* default */.A.index({
      companyId,
      lang
    }));
  };
  if (!formProgress.result_ticket) {
    return /*#__PURE__*/react.createElement(dist/* Navigate */.C5, {
      to: portalRoutes/* default */.A.formProgressFormProgressIdSummary({
        companyId,
        formProgressId: formProgress.id,
        lang
      })
    });
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleClose
    }, pgettext('portal_i18n', 'Close'))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "relative mt-4 text-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "absolute top-0 -left-10 flex h-6 w-6 items-center justify-center rounded-full bg-green-600 p-0.5 shadow-lg"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "check",
    color: "white",
    fitted: true
  })), /*#__PURE__*/react.createElement("span", {
    className: "text-lg font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(formProgress.form.strings.result_title))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 w-64 text-center"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-500"
  }, (0,utils/* nl2br */.HA)((0,utils/* currentLanguage */.aS)(formProgress.form.strings.result_description)))), formProgress.result_ticket && /*#__PURE__*/react.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: clientRoutes/* default */.A.ticketTicketDetail({
      companyId,
      ticketId: formProgress.result_ticket,
      lang: window.appState.lang
    }),
    target: "_blank",
    className: "text-sm"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    link: true,
    icon: "external-link"
  }, pgettext('portal_i18n', 'Track the current status here'))))), /*#__PURE__*/react.createElement(Result_WhatsNext, null), /*#__PURE__*/react.createElement(Result_Remarketing, null), /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium leading-7 text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Was everything alright?'))), formProgress.survey_completed && /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Thank you for taking the survey.')), !formProgress.survey_completed && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Help us make the self-checkout process even better')), /*#__PURE__*/react.createElement("div", {
    className: "mt-4 flex justify-between gap-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdSurveyLiked({
      formProgressId: formProgress.id,
      companyId,
      liked: 0,
      lang
    })),
    icon: "thumb-down",
    iconSolid: true
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdSurveyLiked({
      formProgressId: formProgress.id,
      companyId,
      liked: 1,
      lang
    })),
    icon: "thumb-up",
    iconSolid: true
  }))))));
}
/* harmony default export */ const portal_Result = (Result);
;// ./react/portal/shipping/Shipping/index.tsx




function Shipping() {
  var _formProgress$new_shi2;
  const {
    companyId,
    formProgressId,
    lang
  } = (0,dist/* useParams */.g)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  (0,react.useEffect)(() => {
    var _formProgress$new_shi;
    if ((_formProgress$new_shi = formProgress.new_shipping_address) !== null && _formProgress$new_shi !== void 0 && _formProgress$new_shi.country) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingType({
        companyId,
        formProgressId,
        lang
      }), {
        replace: true
      });
    } else {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingCountry({
        companyId,
        formProgressId,
        lang
      }), {
        replace: true
      });
    }
  }, [companyId, (_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.country, formProgressId, navigate]);
  return null;
}
/* harmony default export */ const shipping_Shipping = (Shipping);
// EXTERNAL MODULE: ./react/helpers/toast.tsx
var toast = __webpack_require__(15072);
;// ./react/portal/shipping/ShippingCountry/index.tsx












function ShippingCountry() {
  var _formProgress$new_shi;
  const publicApi = (0,public_api/* default */.Ay)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [selectedCountry, setSelectedCountry] = (0,react.useState)((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.country);
  const [submitRef, submit] = useSubmitRef();
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      if (selectedCountry === 'other') {
        navigateNext();
      } else {
        await updateFormProgress({
          new_shipping_address: {
            country: selectedCountry
          }
        });
        navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingType({
          companyId,
          formProgressId: formProgress.id,
          lang
        }));
      }
    } catch (errorResponse) {
      toast/* default */.A.error();
    }
  });
  const getGeoData = async (latitude, longitude) => {
    try {
      const response = await publicApi.PortalGeoDataByCoordsApi.retrieve({
        lat: latitude,
        lng: longitude,
        lang: window.appState.lang
      });
      if (response.errors.length > 0) {
        return formProgress.form.default_country;
      }
      if (formProgress.form.shipping_countries.some(c => c === response.result.country_code)) {
        return response.result.country_code;
      }
      return formProgress.form.default_country;
    } catch (_unused) {
      return formProgress.form.default_country;
    }
  };
  (0,react.useEffect)(() => {
    if (!selectedCountry) {
      setSelectedCountry(formProgress.form.default_country);
      getGeolocationPosition(async (latitude, longitude) => setSelectedCountry(await getGeoData(latitude, longitude)));
    }
  }, []);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping')
    }),
    footer: selectedCountry && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      fluid: true,
      primary: true,
      size: "large",
      onClick: submit,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Your country'),
    description: pgettext('portal_i18n', 'To order return shipping, we need to know from which country you will be sending the package.')
  }), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement(react_ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    hidden: true,
    type: "submit",
    ref: submitRef
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Select, {
    choices: formProgress.form.shipping_countries.map(c => ({
      key: c,
      value: c,
      label: constants/* allCountries */.mn[c]
    })).concat({
      key: 'other',
      value: 'other',
      label: pgettext('portal_i18n', 'Other country')
    }),
    value: selectedCountry,
    onChange: setSelectedCountry,
    separatorIndexes: [formProgress.form.countries.length, formProgress.form.shipping_countries.length]
  }))));
}
/* harmony default export */ const shipping_ShippingCountry = (ShippingCountry);
// EXTERNAL MODULE: ./react/shipping/utils.ts
var shipping_utils = __webpack_require__(2413);
;// ./react/portal/shipping/MultipleShippings.tsx




function MultipleShippings() {
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [showAmountButtons, setShowAmountButtons] = (0,react.useState)(formProgress !== null && formProgress !== void 0 && formProgress.amount_of_shippings ? formProgress.amount_of_shippings > 1 : false);
  const [updateAmount, isUpdating] = (0,hooks/* useAsyncFunction */.m_)(async amount => {
    await updateFormProgress({
      amount_of_shippings: amount
    });
  });
  return /*#__PURE__*/react.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-base text-gray-900"
  }, pgettext('portal_i18n', 'If you are returning items which do not fit in one package, you can order multiple packages.')), !showAmountButtons ? /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => setShowAmountButtons(true)
  }, pgettext('portal_i18n', 'I need multiple packages'))) : /*#__PURE__*/react.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Select how many packages you need:')), /*#__PURE__*/react.createElement("div", {
    className: "flex gap-2"
  }, [1, 2, 3, 4, 5].map(amount => /*#__PURE__*/react.createElement("div", {
    key: amount,
    className: "w-24"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => updateAmount(amount),
    primary: formProgress.amount_of_shippings === amount,
    loading: isUpdating,
    fluid: true
  }, amount))))))));
}
/* harmony default export */ const shipping_MultipleShippings = (MultipleShippings);
;// ./react/img/icons/ruler.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M23.04 7.978a1.69 1.69 0 0 1-.508 1.147L9.085 22.562a1.615 1.615 0 0 1-2.295 0L1.438 17.21a1.615 1.615 0 0 1 0-2.295l2.224-2.225a.406.406 0 0 1 .569 0l3.534 3.545c.157.147.364.23.579.233a.81.81 0 0 0 .62-.284.843.843 0 0 0-.061-1.127l-3.525-3.514a.406.406 0 0 1 0-.57l1.94-1.939a.406.406 0 0 1 .569 0l3.534 3.545c.157.147.364.23.58.233a.81.81 0 0 0 .619-.284.84.84 0 0 0-.061-1.128L9.035 7.887a.406.406 0 0 1 0-.568l1.94-1.94a.406.406 0 0 1 .568 0l3.535 3.544c.157.148.363.231.579.234a.81.81 0 0 0 .62-.284.844.844 0 0 0-.062-1.128L12.691 4.23a.406.406 0 0 1 0-.569l2.224-2.224a1.635 1.635 0 0 1 2.295 0l5.353 5.353a1.62 1.62 0 0 1 .477 1.188"
  })));
};

/* harmony default export */ const ruler = ("https://cdn.retino.com/dist/files/react/img/icons/ruler.svg");
;// ./react/img/icons/weight.svg
var weight_path;
function weight_extends() { weight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return weight_extends.apply(this, arguments); }

var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", weight_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), weight_path || (weight_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M9.625 4.125a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0M14.89 5.5a4.126 4.126 0 1 0-8.014-1.375c0 .481.082.945.236 1.375H5.156c-.945 0-1.77.645-2.002 1.564L.06 19.44A2.058 2.058 0 0 0 2.062 22h17.876a2.06 2.06 0 0 0 1.998-2.565L18.842 7.06a2.06 2.06 0 0 0-1.998-1.56z"
  })));
};

/* harmony default export */ const weight = ("https://cdn.retino.com/dist/files/react/img/icons/weight.svg");
;// ./react/portal/shipping/ProviderPackageInfo.tsx





function PackagingInfoRow(_ref) {
  let {
    iconName,
    text,
    additionalText,
    image
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gray-200"
  }, iconName && /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: iconName,
    solid: true,
    fitted: true,
    size: "large"
  }), image && /*#__PURE__*/react.createElement("img", {
    src: image.src,
    alt: image.alt
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, text), additionalText && /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500 whitespace-pre-line"
  }, additionalText)));
}
function ProviderPackageInfo(_ref2) {
  let {
    providerConfig,
    labelType,
    branch
  } = _ref2;
  // Check if branch has specific max dimensions, otherwise use provider config
  const branchMaxDimensionsFormatted = branch && branch.max_dimensions_formatted;
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, labelType === codegen/* BackendPublicEnums */.C.LabelTypeEnum.PRINT_LABEL && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    iconName: "printer",
    text: pgettext('portal_i18n', 'You need to print a label')
  }), labelType === codegen/* BackendPublicEnums */.C.LabelTypeEnum.QR_CODE && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    iconName: "code",
    text: pgettext('portal_i18n', 'Printer is not required.')
  }), labelType === codegen/* BackendPublicEnums */.C.LabelTypeEnum.DROP_OFF_CODE && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    iconName: "key",
    text: pgettext('portal_i18n', 'You will receive a drop-off code to hand over the package.')
  }), providerConfig.submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.PICKUP && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    iconName: "clock",
    text: pgettext('portal_i18n', 'A courier will pick up the package at your address')
  }), /*#__PURE__*/react.createElement(PackagingInfoRow, {
    iconName: "exclamation",
    text: pgettext('portal_i18n', 'The shipment must be properly packed')
  }), providerConfig.packing.weight && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    image: {
      src: weight,
      alt: 'weight'
    },
    text: interpolate(pgettext('portal_i18n', 'The maximum weight of the package is %(weight)s kg'), {
      weight: providerConfig.packing.weight
    }, true)
  }), providerConfig.packing.max_size && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    image: {
      src: ruler,
      alt: 'ruler'
    },
    text: "".concat(pgettext('portal_i18n', 'Maximum package dimensions'), " (").concat(pgettext('portal_i18n', 'incl. packaging'), ")"),
    additionalText: "".concat(interpolate(pgettext('portal_i18n', 'Longest side %(length)s cm'), {
      length: providerConfig.packing.max_size.longest_side_length
    }, true), ", ").concat(interpolate(pgettext('portal_i18n', 'the sum of the lengths of all three sides of the parcel max. %(sum)s cm'), {
      sum: providerConfig.packing.max_size.max_combined_sizes
    }, true))
  }), providerConfig.packing.max_dimensions && /*#__PURE__*/react.createElement(PackagingInfoRow, {
    image: {
      src: ruler,
      alt: 'ruler'
    },
    text: "".concat(pgettext('portal_i18n', 'Maximum package dimensions'), " (").concat(pgettext('portal_i18n', 'incl. packaging'), ")"),
    additionalText: branchMaxDimensionsFormatted || "{width}x{height}x{depth} ".concat(pgettext('portal_i18n', 'cm')).concat(providerConfig.packing.max_dimensions.circumference ? ", ".concat(interpolate(pgettext('portal_i18n', 'maximum girth is %(girth)s cm'), {
      girth: providerConfig.packing.max_dimensions.circumference
    }, true)).concat(providerConfig.packing.max_dimensions.circumference_hint ? "\n".concat(interpolate(pgettext('portal_i18n', 'Girth calculation: %(hint)s.'), {
      hint: providerConfig.packing.max_dimensions.circumference_hint
    }, true)) : '') : '').replace('{width}', "".concat(providerConfig.packing.max_dimensions.width)).replace('{height}', "".concat(providerConfig.packing.max_dimensions.height)).replace('{depth}', "".concat(providerConfig.packing.max_dimensions.depth))
  }));
}
/* harmony default export */ const shipping_ProviderPackageInfo = (ProviderPackageInfo);
;// ./react/portal/shipping/ShippingDropOffBranch/index.tsx












function ShippingDropOffBranch() {
  var _formProgress$shippin, _formProgress$shippin2, _formProgress$shippin3;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [branch, setBranch] = (0,react.useState)();
  const [shippingRoute, setShippingRoute] = (0,react.useState)();
  const goToMap = () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffMap({
    companyId,
    formProgressId: formProgress.id,
    lang
  }));
  const loadShippingType = async () => {
    if (formProgress.shipping_route) {
      const response = await publicApi.PortalFormProgressShippingRouteApi.retrieve({
        id: formProgress.id,
        shipping_route_id: formProgress.shipping_route.id
      });
      setShippingRoute(response);
    } else goToMap();
  };
  const loadDropOffBranch = async () => {
    if (formProgress.drop_off_branch) {
      const response = await publicApi.ShippingDropOffBranchApi.retrieve({
        id: formProgress.drop_off_branch.id
      });
      setBranch(response);
    } else goToMap();
  };
  (0,react.useEffect)(() => {
    loadDropOffBranch();
    loadShippingType();
  }, []);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.75
    })
  }, branch && shippingRoute ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    onClick: goToMap,
    leftAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, {
      left: true
    })
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-8 w-20 items-center justify-center"
  }, /*#__PURE__*/react.createElement("img", {
    src: shippingRoute.provider_config.logo_url,
    alt: ""
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-lg font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(shippingRoute.name)))), /*#__PURE__*/react.createElement("span", {
    className: "text-lg font-medium text-gray-900"
  }, getLowestRoutePrice([shippingRoute])))), /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-lg font-medium"
  }, branch.name), /*#__PURE__*/react.createElement("span", {
    className: "shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800"
  }, pgettext('portal_i18n', 'Selected'))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 text-gray-600"
  }, branch.address.street, " ", branch.address.house_number), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-600"
  }, branch.address.city), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-600"
  }, branch.address.postal_code)), /*#__PURE__*/react.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium"
  }, pgettext('portal_i18n', 'Opening hours')), /*#__PURE__*/react.createElement("table", {
    className: "mt-2 border-separate border-spacing-y-1 text-sm"
  }, /*#__PURE__*/react.createElement("tbody", null, (0,shipping_utils/* condensateOpenHours */.QJ)(formProgress.drop_off_branch).map(item => {
    const closedClass = item.openHours === gettext('closed') ? 'text-red-600' : '';
    return /*#__PURE__*/react.createElement("tr", {
      key: item.day
    }, /*#__PURE__*/react.createElement("td", {
      className: "whitespace-nowrap p-0 align-baseline font-medium"
    }, item.day), /*#__PURE__*/react.createElement("td", {
      className: "p-0 pl-3 text-gray-500 ".concat(closedClass)
    }, item.openHours));
  })))))), /*#__PURE__*/react.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement(shipping_ProviderPackageInfo, {
    providerConfig: (_formProgress$shippin = formProgress.shipping_route) === null || _formProgress$shippin === void 0 ? void 0 : _formProgress$shippin.provider_config,
    labelType: (_formProgress$shippin2 = (_formProgress$shippin3 = formProgress.shipping_route) === null || _formProgress$shippin3 === void 0 ? void 0 : _formProgress$shippin3.label_type) !== null && _formProgress$shippin2 !== void 0 ? _formProgress$shippin2 : null,
    branch: branch
  })), /*#__PURE__*/react.createElement(shipping_MultipleShippings, null)), /*#__PURE__*/react.createElement("div", {
    className: "sticky bottom-0 z-10 mt-5 border-t border-gray-200 bg-gray-50 px-5 pb-2 pt-3"
  }, shippingRoute.paid_by_customer && /*#__PURE__*/react.createElement("div", {
    className: "mb-1 text-center leading-none"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-xs text-gray-500"
  }, interpolate(pgettext('portal_i18n', 'In the last step of the ticket creation process, we will ask you to pay %(price)s for the shipping'), {
    price: getShippingTypePrice(shippingRoute, formProgress.amount_of_shippings)
  }, true))), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    fluid: true,
    primary: true,
    size: "large",
    onClick: () => navigateNext()
  }, pgettext('portal_i18n', 'Confirm branch and continue')))) : /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null));
}
/* harmony default export */ const shipping_ShippingDropOffBranch = (ShippingDropOffBranch);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(65848);
;// ./react/components/ScriptLoader.tsx



function ScriptLoader(_ref) {
  let {
    children,
    scripts
  } = _ref;
  const [loaded, setLoaded] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const fetchData = async () => {
      const results = await Promise.all(scripts.map(url => (0,utils/* loadScript */.k0)(url, encodeURI(url))));
      setLoaded(!results.some(result => !result.successful));
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return loaded ? children : /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
}
/* harmony default export */ const components_ScriptLoader = (ScriptLoader);
;// ./react/components/StyleLoader.tsx


function StyleLoader(_ref) {
  let {
    children,
    styles
  } = _ref;
  const [loaded, setLoaded] = (0,react.useState)(false);
  const loadStyle = (src, id) => new Promise((resolve, reject) => {
    const linkElement = document.getElementById(id);
    if (!linkElement) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = src;
      link.id = id;
      const handleLoadSuccess = () => resolve({
        successful: true
      });
      const handleLoadFail = event => reject(new Error(event));
      link.addEventListener('load', handleLoadSuccess, {
        once: true
      });
      link.addEventListener('error', handleLoadFail, {
        once: true
      });
      document.head.appendChild(link);
    } else {
      resolve({
        successful: true
      });
    }
  });
  (0,react.useEffect)(() => {
    const fetchData = async () => {
      const results = await Promise.all(styles.map(url => loadStyle(url, encodeURI(url))));
      setLoaded(!results.some(result => !result.successful));
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return loaded ? children : /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
}
/* harmony default export */ const components_StyleLoader = (StyleLoader);
;// ./react/portal/shipping/ShippingDropOffMap/HereMap/index.tsx
function HereMap_extends() { HereMap_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return HereMap_extends.apply(this, arguments); }





function isWebGLAvailable() {
  try {
    const canvas = document.createElement('canvas');
    return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
  } catch (e) {
    return false;
  }
}
function HereMapWrapped(_ref) {
  let {
    center,
    markers,
    onCenterChanged,
    onInfoBubbleClick,
    webglAvailable
  } = _ref;
  const mapElementRef = (0,react.useRef)(null);
  const mapRef = (0,react.useRef)();
  const uiRef = (0,react.useRef)();
  const mapControlledByUserRef = (0,react.useRef)(false);
  const zoomRef = (0,react.useRef)(15);
  const closestMarkerRef = (0,react.useRef)('');
  const mapMarkersRef = (0,react.useRef)([]);
  const iconsRef = (0,react.useRef)({});
  const loadAndCacheIcon = url => {
    if (iconsRef.current && url in iconsRef.current) {
      return iconsRef.current[url];
    }
    const icon = new window.H.map.Icon(url, {
      size: {
        w: 82 / 3,
        h: 131 / 3
      }
    });
    iconsRef.current[url] = icon;
    return icon;
  };
  const closeAllInfoBubbles = () => {
    if (uiRef.current) uiRef.current.getBubbles().forEach(bub => uiRef.current.removeBubble(bub));
  };
  const addedDataPointIds = (0,react.useRef)(new Set());
  const addMarkersToClustering = mapMarkers => {
    if (mapRef.current) {
      const H = window.H;
      const layer = mapRef.current.getLayers().asArray().find(l => {
        const isObjLayer = l instanceof H.map.layer.ObjectLayer;
        return isObjLayer && l.getProvider() instanceof H.clustering.Provider;
      });
      const provider = layer.getProvider();
      const dataPoints = mapMarkers.filter(item => !addedDataPointIds.current.has(item.id)).map(item => {
        addedDataPointIds.current.add(item.id);
        return new H.clustering.DataPoint(item.lat, item.lng, null, item);
      });
      provider.addDataPoints(dataPoints);
      window.onInfoBubbleClick = branchId => {
        onInfoBubbleClick(branchId);
      };
      mapMarkersRef.current = dataPoints;
    }
  };
  const startClustering = (map, data) => {
    var _data$map;
    const H = window.H;
    const dataPoints = (_data$map = data === null || data === void 0 ? void 0 : data.map(item => new H.clustering.DataPoint(item.lat, item.lng, null, item))) !== null && _data$map !== void 0 ? _data$map : [];
    mapMarkersRef.current = dataPoints;
    const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
      clusteringOptions: {
        // Maximum radius of the neighbourhood
        eps: 32,
        // minimum weight of points required to form a cluster
        minWeight: 2
      }
    });
    const defaultTheme = clusteredDataProvider.getTheme();
    const customTheme = {
      getClusterPresentation: cluster => defaultTheme.getClusterPresentation.call(defaultTheme, cluster),
      getNoisePresentation: noisePoint => {
        const H = window.H;
        const pointData = noisePoint.getData();
        const icon = loadAndCacheIcon(pointData.img);
        const noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
          min: noisePoint.getMinZoom(),
          icon
        });
        noiseMarker.addEventListener('tap', () => {
          pointData.onClick(pointData.lat, pointData.lng);
          closeAllInfoBubbles();
          if (uiRef.current) {
            const bubble = new window.H.ui.InfoBubble(noiseMarker.getGeometry(), {
              content: pointData.infoBubble()
            });
            bubble.addClass('map-info-bubble');
            uiRef.current.addBubble(bubble);
          }
        });
        noiseMarker.setData(pointData);
        return noiseMarker;
      }
    };
    clusteredDataProvider.setTheme(customTheme);
    clusteredDataProvider.addEventListener('tap', event => {
      if (mapRef.current) {
        if (event.target.getData().getPosition) {
          const position = event.target.getData().getPosition();
          zoomRef.current = Math.min(mapRef.current.getZoom() + 1, 21);
          mapRef.current.getViewModel().setLookAtData({
            position: {
              lat: position.lat,
              lng: position.lng
            },
            zoom: zoomRef.current
          }, true);
        }
      }
    });
    window.onInfoBubbleClick = branchId => {
      onInfoBubbleClick(branchId);
    };
    const clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);
    map.addLayer(clusteringLayer);
  };
  (0,react.useLayoutEffect)(() => {
    if (!mapElementRef.current) return () => {};
    const H = window.H;
    const platform = new H.service.Platform({
      apikey: window.appState.hereAPIKey
    });
    const defaultLayers = platform.createDefaultLayers();
    let baseLayer;
    const mapOptions = {
      zoom: zoomRef.current,
      center: {
        lat: 52.5,
        lng: 13.4
      },
      pixelRatio: window.devicePixelRatio || 1
    };
    if (webglAvailable) {
      baseLayer = defaultLayers.vector.normal.map;
    } else {
      const rasterTileService = platform.getRasterTileService({
        format: 'png',
        queryParams: {
          style: 'explore.day',
          ppi: 100
        }
      });
      const rasterTileProvider = new H.service.rasterTile.Provider(rasterTileService, {
        tileSize: 256
      });
      baseLayer = new H.map.layer.TileLayer(rasterTileProvider);
      mapOptions.engineType = H.map.render.RenderEngine.EngineType.P2D;
    }
    const map = new H.Map(mapElementRef.current, baseLayer, mapOptions);
    mapRef.current = map;
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
    const ui = H.ui.UI.createDefault(map, defaultLayers);
    uiRef.current = ui;
    ui.getControl('mapsettings').setVisibility(false);
    map.addEventListener('tap', evt => {
      if (!evt.target.getGeometry) closeAllInfoBubbles();
    });

    // listener for setting the cursor over map markers
    map.addEventListener('pointermove', evt => {
      if (evt.target instanceof H.map.Marker) {
        map.getViewPort().element.style.cursor = 'pointer';
      } else {
        map.getViewPort().element.style.cursor = 'auto';
      }
    });
    map.addEventListener('mapviewchangeend', evt => {
      if (evt.currentTarget.getZoom() !== zoomRef.current) {
        mapControlledByUserRef.current = true;
        zoomRef.current = evt.currentTarget.getZoom();
      }
      if (onCenterChanged) {
        onCenterChanged(map.getCenter());
      }
    });
    map.addEventListener('pointerdown', evt => {
      mapControlledByUserRef.current = true;
    });
    startClustering(map, markers);
    map.setCenter(center);

    // setup resizing, in timeout to prevent multiple rerenders during animation
    let timeout;
    const mapResizeObserver = new ResizeObserver_es/* default */.A(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        map.getViewPort().resize();
      }, 100);
    });
    mapResizeObserver.observe(mapElementRef.current);
    return () => {
      clearTimeout(timeout);
      mapResizeObserver.disconnect();

      // stop possible animation caused by previous animated setLookAtData call
      map.getViewModel().setLookAtData({}, false);

      // wait before disposing as there might still run some
      // debounced functions in HERE code caused by previous animated setLookAtData call
      setTimeout(() => {
        map.dispose();
      }, 200);
    };
  }, [mapElementRef]);
  const getBoundingBoxIncludingLocation = (lat, lng) => {
    if (!mapRef.current) return null;
    const oldBoundingBox = mapRef.current.getViewModel().getLookAtData().bounds.getBoundingBox();
    const c = oldBoundingBox.getCenter();
    let top = oldBoundingBox.getTop();
    let left = oldBoundingBox.getLeft();
    let bottom = oldBoundingBox.getBottom();
    let right = oldBoundingBox.getRight();
    if (lat >= c.lat) {
      top = c.lat + (lat - c.lat) * 1.3;
      bottom = c.lat - (top - c.lat);
    } else {
      bottom = c.lat - (c.lat - lat) * 1.3;
      top = c.lat + (c.lat - bottom);
    }
    if (lng >= c.lng) {
      right = c.lng + (lng - c.lng) * 1.3;
      left = c.lng - (right - c.lng);
    } else {
      left = c.lng - (c.lng - lng) * 1.3;
      right = c.lng + (c.lng - left);
    }
    return new window.H.geo.Rect(top, left, bottom, right);
  };
  const {
    lat,
    lng
  } = center;
  (0,react.useEffect)(() => {
    if (mapRef.current) {
      const oldCenter = mapRef.current.getCenter();
      const animate = getDistanceFromLatLngInKm(lat, lng, oldCenter.lat, oldCenter.lng) < 20;
      zoomRef.current = Math.max(15, mapRef.current.getZoom());
      const getLatitudeOfsset = () => 0.0035 / 2 ** (zoomRef.current - 15);
      mapRef.current.getViewModel().setLookAtData({
        position: {
          lat: lat + getLatitudeOfsset(),
          lng
        },
        zoom: zoomRef.current
      }, animate);
      mapControlledByUserRef.current = false;
    }
  }, [lat, lng]);
  (0,react.useEffect)(() => {
    if (markers && markers.length > 0) {
      addMarkersToClustering(markers);
      if (!mapControlledByUserRef.current && markers[0].id !== closestMarkerRef.current && mapRef.current) {
        const boundingBox = mapRef.current.getViewModel().getLookAtData().bounds.getBoundingBox();
        if (!boundingBox.containsLatLng(markers[0].lat, markers[0].lng)) {
          // zoom out so the closest marker is visible
          const bounds = getBoundingBoxIncludingLocation(markers[0].lat, markers[0].lng);
          if (bounds) {
            mapRef.current.getViewModel().setLookAtData({
              bounds
            }, true);
          }
        }
      }
      closestMarkerRef.current = markers[0].id;
    }
  }, [markers]);
  return /*#__PURE__*/react.createElement("div", {
    className: "map -mb-5 flex-1",
    ref: mapElementRef
  });
}
function HereMap(props) {
  const webglAvailable = (0,react.useMemo)(() => {
    const available = isWebGLAvailable();
    if (!available && window.Sentry) {
      window.Sentry.captureMessage('HereMap: WebGL unavailable, falling back to raster P2D', {
        level: 'warning'
      });
    }
    return available;
  }, []);
  const modules = /*#__PURE__*/react.createElement(components_ScriptLoader, {
    scripts: ['https://js.api.here.com/v3/3.1/mapsjs-ui.js', 'https://js.api.here.com/v3/3.1/mapsjs-mapevents.js', 'https://js.api.here.com/v3/3.1/mapsjs-clustering.js']
  }, /*#__PURE__*/react.createElement(HereMapWrapped, HereMap_extends({}, props, {
    webglAvailable: webglAvailable
  })));
  const service = /*#__PURE__*/react.createElement(components_ScriptLoader, {
    scripts: ['https://js.api.here.com/v3/3.1/mapsjs-service.js']
  }, webglAvailable ? modules : /*#__PURE__*/react.createElement(components_ScriptLoader, {
    scripts: ['https://js.api.here.com/v3/3.1/mapsjs-service-legacy.js']
  }, modules));
  return /*#__PURE__*/react.createElement(components_StyleLoader, {
    styles: ['https://js.api.here.com/v3/3.1/mapsjs-ui.css']
  }, /*#__PURE__*/react.createElement(components_ScriptLoader, {
    scripts: ['https://js.api.here.com/v3/3.1/mapsjs-core.js']
  }, webglAvailable ? service : /*#__PURE__*/react.createElement(components_ScriptLoader, {
    scripts: ['https://js.api.here.com/v3/3.1/mapsjs-core-legacy.js']
  }, service)));
}
/* harmony default export */ const ShippingDropOffMap_HereMap = (HereMap);
;// ./react/portal/shipping/ShippingDropOffMap/ProviderSelectModal.tsx





function ProviderSelectModal(_ref) {
  let {
    branch,
    routes,
    onConfirm,
    onClose
  } = _ref;
  const [branchShippingTypes, setBranchShippingTypes] = (0,react.useState)([]);
  (0,react.useEffect)(() => {
    if (branch && routes) {
      setBranchShippingTypes(routes.filter(t => branch === null || branch === void 0 ? void 0 : branch.shipping_providers.includes(t.provider_config.type)));
    } else {
      setBranchShippingTypes([]);
    }
  }, [branch, routes]);
  return /*#__PURE__*/react.createElement(react_ui/* Modal */.aF, {
    size: "md",
    open: !!branch,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center space-y-4 align-middle"
  }, /*#__PURE__*/react.createElement("h1", {
    className: "text-center text-lg font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Available carriers')), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px w-full"
  }, branchShippingTypes.map(route => /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    key: route.id,
    onClick: () => onConfirm(route.id),
    rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null)
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-8 w-14 flex-shrink-0 items-center justify-center"
  }, /*#__PURE__*/react.createElement("img", {
    src: route.provider_config.logo_url,
    alt: ""
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(route.name)))), /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-900"
  }, getLowestRoutePrice([route])))))))));
}
/* harmony default export */ const ShippingDropOffMap_ProviderSelectModal = (ProviderSelectModal);
;// ./react/portal/shipping/ShippingDropOffMap/index.tsx














const INITIAL_COORDS = {
  latitude: 50.0833,
  longitude: 14.4667
};
function ShippingDropOffMap() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const get_init_coords = () => {
    if (formProgress.shipping_latitude && formProgress.shipping_longitude) {
      return {
        latitude: formProgress.shipping_latitude,
        longitude: formProgress.shipping_longitude
      };
    }
    return INITIAL_COORDS;
  };
  const [userCoords, setUserCoords] = (0,react.useState)();
  const [centerCoords, setCenterCoords] = (0,react.useState)(get_init_coords());
  const [initialCoords, setInitialCoords] = (0,react.useState)(get_init_coords());
  const [routes, setRoutes] = (0,react.useState)();
  const [branches, setBranches] = (0,react.useState)();
  const [search, setSearch] = (0,react.useState)('');
  const [hereApiError, setHereApiError] = (0,react.useState)(false);
  const [submittingBranch, setSubmittingBranch] = (0,react.useState)();
  const [openProviderSelectModal, setOpenProviderSelectModal] = (0,react.useState)();
  const menuRef = (0,react.useRef)(null);
  const menuStartingY = (0,react.useRef)();
  const menuStartingHeight = (0,react.useRef)();
  const fetchTimeout = (0,react.useRef)();
  const isSubmitting = (0,react.useRef)(false);
  const [providerConfigs, setProviderConfigs] = (0,react.useState)();
  (0,react.useEffect)(() => {
    (async () => {
      const reponse = await publicApi.ShippingProvidersConfigApi.list({
        include_internal: true
      });
      setProviderConfigs(reponse);
    })();
  }, []);
  const [fetchDropOffBranches] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    var _formProgress$new_shi;
    const response = await publicApi.ShippingDropOffBranchNearestFromCenterApi.list({
      shipping_providers: routes === null || routes === void 0 ? void 0 : routes.map(type => type.provider_config.type),
      lat: centerCoords.latitude,
      lng: centerCoords.longitude,
      country: ((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.country) || ''
    });
    setBranches(response);
  });
  const debouncedFetchDropOffBranches = () => {
    if (fetchTimeout.current) {
      clearTimeout(fetchTimeout.current);
    }
    fetchTimeout.current = window.setTimeout(() => {
      fetchDropOffBranches();
    }, 1000);
  };
  const [searchDropOffBranches, isSearching] = (0,hooks/* useAsyncFunction */.m_)(async queryStreetHouseNumber => {
    var _formProgress$new_shi2;
    const response = await publicApi.PortalGeoDataByQueryApi.retrieve({
      street: queryStreetHouseNumber.trim(),
      house_number: '',
      city: '',
      postal_code: '',
      country: ((_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.country) || '',
      lang: window.appState.lang
    });
    if (response.errors.length > 0) {
      setHereApiError(true);
      return;
    }
    if (response.results.length > 0) {
      setInitialCoords({
        latitude: Number(response.results[0].latitude),
        longitude: Number(response.results[0].longitude)
      });
    }
    setHereApiError(false);
  });
  const [loadShippingTypes] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormProgressShippingRoutesApi.list({
      id: formProgress.id
    });
    setRoutes(response);
  });
  const getDistanceFromUserString = (latitude, longitude) => {
    if (!userCoords) return '';
    const km = getDistanceFromLatLngInKm(latitude, longitude, userCoords.latitude, userCoords.longitude);
    if (km < 1) return "".concat((km * 1000).toFixed(0), " ").concat(pgettext('portal_i18n', 'm'));
    return "".concat(km.toFixed(2), " ").concat(pgettext('portal_i18n', 'km'));
  };
  const handleSearch = () => {
    searchDropOffBranches(search);
  };
  const submit = async (branch, route) => {
    isSubmitting.current = true;
    setSubmittingBranch(branch.id);
    setOpenProviderSelectModal(null);
    try {
      await updateFormProgress({
        drop_off_branch_id: branch.id,
        shipping_route_id: route
      });
    } finally {
      setSubmittingBranch(null);
      isSubmitting.current = false;
    }
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffBranch({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  };
  const selectBranch = branch => {
    const branchRoutes = routes === null || routes === void 0 ? void 0 : routes.filter(t => branch.shipping_providers.includes(t.provider_config.type));
    if (branchRoutes) {
      if (branchRoutes.length === 1) {
        submit(branch, branchRoutes[0].id);
      } else if (branchRoutes.length > 1) {
        setOpenProviderSelectModal(branch);
      }
    }
  };
  const onMenuHeaderTouchStart = e => {
    if (menuRef.current) {
      menuStartingHeight.current = menuRef.current.clientHeight;
      menuStartingY.current = e.touches[0].clientY;
      const classes = menuRef.current.className.split(' ');
      menuRef.current.className = classes.filter(c => !c.includes('basis')).join(' ');
      menuRef.current.style.height = "".concat(menuStartingHeight.current, "px");
      menuRef.current.style.transitionProperty = '';
      menuRef.current.style.transitionDuration = '';
    }
  };
  const onMenuHeaderTouchMove = e => {
    if (menuRef.current && menuStartingHeight.current && menuStartingY.current) {
      var _menuRef$current$pare, _menuRef$current, _menuRef$current$pare2, _menuRef$current2;
      const minHeight = ((_menuRef$current$pare = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 || (_menuRef$current = _menuRef$current.parentElement) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.clientHeight) !== null && _menuRef$current$pare !== void 0 ? _menuRef$current$pare : 0) * (2 / 5);
      const maxHeight = ((_menuRef$current$pare2 = (_menuRef$current2 = menuRef.current) === null || _menuRef$current2 === void 0 || (_menuRef$current2 = _menuRef$current2.parentElement) === null || _menuRef$current2 === void 0 ? void 0 : _menuRef$current2.clientHeight) !== null && _menuRef$current$pare2 !== void 0 ? _menuRef$current$pare2 : 0) * (5 / 6);
      let height = menuStartingHeight.current + (menuStartingY.current - e.touches[0].clientY);
      if (height > maxHeight) {
        height = maxHeight;
      } else if (height < minHeight) {
        height = minHeight;
      }
      menuRef.current.style.height = "".concat(height, "px");
    }
  };
  const onMenuHeaderTouchEnd = () => {
    if (menuRef.current) {
      var _menuRef$current$pare3, _menuRef$current3, _menuRef$current$pare4, _menuRef$current4, _menuRef$current$clie, _menuRef$current5;
      const minHeight = ((_menuRef$current$pare3 = (_menuRef$current3 = menuRef.current) === null || _menuRef$current3 === void 0 || (_menuRef$current3 = _menuRef$current3.parentElement) === null || _menuRef$current3 === void 0 ? void 0 : _menuRef$current3.clientHeight) !== null && _menuRef$current$pare3 !== void 0 ? _menuRef$current$pare3 : 0) * (2 / 5);
      const maxHeight = ((_menuRef$current$pare4 = (_menuRef$current4 = menuRef.current) === null || _menuRef$current4 === void 0 || (_menuRef$current4 = _menuRef$current4.parentElement) === null || _menuRef$current4 === void 0 ? void 0 : _menuRef$current4.clientHeight) !== null && _menuRef$current$pare4 !== void 0 ? _menuRef$current$pare4 : 0) * (5 / 6);
      const height = (_menuRef$current$clie = (_menuRef$current5 = menuRef.current) === null || _menuRef$current5 === void 0 ? void 0 : _menuRef$current5.clientHeight) !== null && _menuRef$current$clie !== void 0 ? _menuRef$current$clie : 0;
      const threshold = (minHeight + maxHeight) / 2;
      const classes = menuRef.current.className.split(' ');
      if (height > threshold) {
        menuRef.current.style.height = "".concat(maxHeight, "px");
      } else {
        menuRef.current.style.height = "".concat(minHeight, "px");
      }
      menuRef.current.style.transitionProperty = 'height';
      menuRef.current.style.transitionDuration = '150ms';
      menuRef.current.className = classes === null || classes === void 0 ? void 0 : classes.join(' ');
    }
  };
  (0,react.useEffect)(() => {
    getGeolocationPosition(async (latitude, longitude) => {
      setUserCoords({
        latitude,
        longitude
      });
      setCenterCoords({
        latitude,
        longitude
      });
      setInitialCoords({
        latitude,
        longitude
      });
    });
    loadShippingTypes();
  }, []);
  (0,react.useEffect)(() => {
    if (routes) {
      if (branches) {
        debouncedFetchDropOffBranches();
      } else {
        fetchDropOffBranches([]);
      }
    }
  }, [centerCoords, routes]);
  const handleMarkerClick = (latitude, longitude) => {
    setInitialCoords({
      latitude,
      longitude
    });
  };
  const handleInfoBubbleClick = branchId => {
    const branch = branches === null || branches === void 0 ? void 0 : branches.find(b => b.id === branchId);
    if (branch && !isSubmitting.current) {
      selectBranch(branch);
    }
  };
  const getInfoBubble = (0,react.useCallback)(branch => () => {
    const branchRoutes = routes === null || routes === void 0 ? void 0 : routes.filter(t => branch.shipping_providers.includes(t.provider_config.type));
    return "\n    <div onclick='onInfoBubbleClick(\"".concat(branch.id, "\")' class=\"font-xs w-60\">\n      <span class=\"font-bold\">").concat(branch.name, "</span>\n      <div class=\"text-gray-700\">\n      <div class='flex flex-wrap'>\n          <div class=\"-space-y-1 text-gray-700\">\n            <div>").concat(branch.address.street, "</div>\n            <div>\n              ").concat(branch.address.city, ", ").concat(branch.address.postal_code, "\n            </div>\n          </div>\n          <div class='ml-auto'>").concat(getLowestRoutePrice(branchRoutes), "</div>\n        </div>\n        <table class=\"mt-2\">\n          ").concat((0,shipping_utils/* condensateOpenHours */.QJ)(branch).map(item => "<tr>\n                <td class=\"whitespace-nowrap p-0 align-baseline font-bold\">".concat(item.day, "</td>\n                <td class=\"p-0 pl-3\">").concat(item.openHours, "</td>\n                </tr>")).join(''), "\n        </table>\n        ").concat(branch.max_dimensions_formatted ? "<div class='mt-2 text-sm text-gray-700'>".concat(pgettext('portal_i18n', 'Max dimensions'), ": <span class='font-bold'>").concat(branch.max_dimensions_formatted, "</span></div>") : '', "\n        <div class='mt-2 mr-6 box-border'>\n          ").concat(server_browser.renderToString( /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
      fluid: true
    }, gettext('Select'))), "\n        </div>\n      </div>\n    </div>");
  }, [routes]);
  const getMarkerImageCallback = (0,react.useCallback)(shippingProvider => {
    var _ref, _providerConfigs$find;
    return (_ref = providerConfigs && ((_providerConfigs$find = providerConfigs.find(item => item.type === shippingProvider)) === null || _providerConfigs$find === void 0 ? void 0 : _providerConfigs$find.dropoff_map_pin_url)) !== null && _ref !== void 0 ? _ref : '';
  }, [providerConfigs]);
  if (!providerConfigs) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      collapsed: true,
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.5
    })
  }, /*#__PURE__*/react.createElement("div", {
    className: "-my-5 flex flex-1 flex-col"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-1"
  }, /*#__PURE__*/react.createElement(ShippingDropOffMap_HereMap, {
    center: {
      lat: initialCoords.latitude,
      lng: initialCoords.longitude
    },
    markers: branches === null || branches === void 0 ? void 0 : branches.map(b => ({
      id: b.id,
      lat: b.latitude,
      lng: b.longitude,
      img: getMarkerImageCallback(b.shipping_providers.filter(p => routes === null || routes === void 0 ? void 0 : routes.map(type => type.provider_config.type).includes(p))[0]),
      onClick: handleMarkerClick,
      infoBubble: getInfoBubble(b)
    })),
    onInfoBubbleClick: handleInfoBubbleClick,
    onCenterChanged: center => setCenterCoords({
      latitude: Number(center.lat.toFixed(7)),
      longitude: Number(center.lng.toFixed(7))
    })
  })), /*#__PURE__*/react.createElement("div", {
    ref: menuRef,
    className: "z-10 flex w-full basis-2/5 flex-col rounded-t-3xl bg-white",
    style: {
      boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.15)',
      transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "basis-4 rounded-t-3xl bg-gray-50",
    onTouchStart: onMenuHeaderTouchStart,
    onTouchMove: onMenuHeaderTouchMove,
    onTouchEnd: onMenuHeaderTouchEnd,
    onTouchCancel: onMenuHeaderTouchEnd
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form, null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center pt-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "h-1.5 w-24 rounded-full bg-gray-500 sm:hidden"
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex px-5 pb-4 pt-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    id: "map-input",
    value: search,
    onChange: setSearch,
    placeholder: pgettext('portal_i18n', 'Search'),
    icon: "search",
    roundedFull: true,
    attached: "right",
    error: hereApiError && pgettext('portal_i18n', 'Search is currently unavailable')
  })), /*#__PURE__*/react.createElement("div", {
    className: "mt-1"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    size: "medium",
    submit: true,
    roundedFull: true,
    attached: "left",
    onClick: handleSearch,
    loading: isSearching
  }, pgettext('portal_i18n', 'Search')))))), /*#__PURE__*/react.createElement("div", {
    className: "max-h-full flex-1 basis-0 -space-y-px overflow-y-scroll"
  }, branches === null || branches === void 0 ? void 0 : branches.slice(0, 99).map(b => {
    const branchRoutes = routes === null || routes === void 0 ? void 0 : routes.filter(t => b.shipping_providers.includes(t.provider_config.type));
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
      key: b.id,
      onClick: () => {
        if (!submittingBranch) selectBranch(b);
      },
      rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
      loading: submittingBranch === b.id
    }, /*#__PURE__*/react.createElement("div", {
      className: "-my-2 flex gap-6"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex flex-shrink-0 items-center"
    }, /*#__PURE__*/react.createElement("img", {
      src: getMarkerImageCallback(b.shipping_providers.filter(p => routes === null || routes === void 0 ? void 0 : routes.map(type => type.provider_config.type).includes(p))[0]),
      alt: b.name2,
      width: 20
    })), /*#__PURE__*/react.createElement("div", {
      className: "flex w-full items-center justify-between"
    }, /*#__PURE__*/react.createElement("div", {
      className: ""
    }, /*#__PURE__*/react.createElement("div", {
      className: "line-clamp-2 font-medium"
    }, b.name), /*#__PURE__*/react.createElement("div", {
      className: "text-xs"
    }, b.address.city, ", ", b.address.street), userCoords && /*#__PURE__*/react.createElement("div", {
      className: "text-xs text-gray-500"
    }, getDistanceFromUserString(b.latitude, b.longitude))), /*#__PURE__*/react.createElement("div", {
      className: "mr-2 text-sm"
    }, getLowestRoutePrice(branchRoutes)))));
  })))), /*#__PURE__*/react.createElement(ShippingDropOffMap_ProviderSelectModal, {
    branch: openProviderSelectModal,
    routes: routes,
    onClose: () => setOpenProviderSelectModal(null),
    onConfirm: shippingTypeId => {
      if (openProviderSelectModal) {
        submit(openProviderSelectModal, shippingTypeId);
      }
    }
  }));
}
/* harmony default export */ const shipping_ShippingDropOffMap = (ShippingDropOffMap);
// EXTERNAL MODULE: ./react/parcelshops/utils.ts
var parcelshops_utils = __webpack_require__(96013);
// EXTERNAL MODULE: ./react/parcelshops/components/BranchPhoto.tsx
var BranchPhoto = __webpack_require__(36543);
// EXTERNAL MODULE: ./react/parcelshops/components/OpeningHoursTable.tsx
var OpeningHoursTable = __webpack_require__(18696);
;// ./react/parcelshops/components/BranchInfo.tsx






function BranchMapLink(_ref) {
  let {
    url
  } = _ref;
  return /*#__PURE__*/react.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "-mx-1 -my-0.5 inline-flex items-center gap-1 rounded px-1 py-0.5 text-xs font-medium text-indigo-700 hover:text-indigo-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-current"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "map",
    size: "tiny",
    fitted: true
  }), pgettext('portal_i18n', 'Show on map'));
}

/**
 * Standardised "branch info" body used across portal, summary, ticket detail and selectors.
 *
 * Pass display flags to opt into opening hours, contact info, and map link. The wrapping card
 * (clickable, hover, etc.) is the caller's responsibility - this only renders the inner layout.
 */
function BranchInfo(_ref2) {
  var _branch$address, _branch$address2, _branch$address3, _branch$address4;
  let {
    branch,
    photoSize = 'md',
    showOpeningHours = false,
    showContacts = false,
    showMapLink = false,
    stackOnMobile = false,
    className
  } = _ref2;
  const mapUrl = showMapLink ? (0,parcelshops_utils/* default */.A)(branch) : null;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('flex items-start gap-4', stackOnMobile && 'flex-col sm:flex-row', className)
  }, /*#__PURE__*/react.createElement(BranchPhoto/* default */.A, {
    src: branch.photo_url,
    alt: branch.name,
    size: photoSize,
    className: stackOnMobile ? 'h-48 w-full sm:h-32 sm:w-32' : undefined
  }), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 flex-1 space-y-2"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-semibold text-gray-900 sm:text-base"
  }, branch.name), branch.address && /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, branch.address.street, branch.address.house_number ? " ".concat(branch.address.house_number) : '', branch.address.street ? ', ' : '', branch.address.postal_code, " ", branch.address.city)), showOpeningHours && /*#__PURE__*/react.createElement(OpeningHoursTable/* default */.A, {
    openingHours: branch.opening_hours
  }), showContacts && (((_branch$address = branch.address) === null || _branch$address === void 0 ? void 0 : _branch$address.phone) || ((_branch$address2 = branch.address) === null || _branch$address2 === void 0 ? void 0 : _branch$address2.email)) && /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-1 text-sm text-gray-500 sm:flex-row sm:flex-wrap sm:gap-x-4"
  }, ((_branch$address3 = branch.address) === null || _branch$address3 === void 0 ? void 0 : _branch$address3.phone) && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1.5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "phone",
    size: "tiny",
    fitted: true,
    solid: true,
    color: "gray",
    colorIntensity: 400
  }), /*#__PURE__*/react.createElement("span", {
    className: "truncate"
  }, branch.address.phone)), ((_branch$address4 = branch.address) === null || _branch$address4 === void 0 ? void 0 : _branch$address4.email) && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1.5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "mail",
    size: "tiny",
    fitted: true,
    solid: true,
    color: "gray",
    colorIntensity: 400
  }), /*#__PURE__*/react.createElement("span", {
    className: "truncate"
  }, branch.address.email))), mapUrl && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(BranchMapLink, {
    url: mapUrl
  }))));
}
/* harmony default export */ const components_BranchInfo = (BranchInfo);
;// ./react/portal/shipping/ShippingInPersonBranch/index.tsx








function inPersonBranchEntries(routes) {
  const byBranch = routes.filter(route => route.provider_config.submit_type === 'IN_PERSON').flatMap(route => route.customer_parcel_shops.map(branch => ({
    route,
    branch
  }))).reduce((map, entry) => map.has(entry.branch.id) ? map : map.set(entry.branch.id, entry), new Map());
  return Array.from(byBranch.values());
}
function ShippingInPersonBranch() {
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [entries, setEntries] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    (async () => {
      const routes = await publicApi.PortalFormProgressShippingRoutesApi.list({
        id: formProgress.id
      });
      setEntries(inPersonBranchEntries(routes));
    })();
  }, []);
  const [handleSelectBranch, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async entry => {
    await updateFormProgress({
      shipping_route_id: entry.route.id,
      customer_parcel_shop_id: entry.branch.id,
      drop_off_branch_id: null
    });
    navigateNext();
  });
  if (entries === null) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.5
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Select a branch'),
    description: pgettext('portal_i18n', 'Choose the branch where you would like to return the products.')
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, entries.map(entry => {
    const mapUrl = (0,parcelshops_utils/* default */.A)(entry.branch);
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
      key: entry.branch.id,
      rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
      footer: mapUrl && /*#__PURE__*/react.createElement(BranchMapLink, {
        url: mapUrl
      }),
      onClick: () => handleSelectBranch(entry),
      loading: isSubmitting
    }, /*#__PURE__*/react.createElement(components_BranchInfo, {
      branch: entry.branch,
      photoSize: "lg",
      showOpeningHours: true
    }));
  })));
}
/* harmony default export */ const shipping_ShippingInPersonBranch = (ShippingInPersonBranch);
;// ./react/portal/shipping/ShippingPickup/DaySelect.tsx
/* provided dependency */ var DaySelect_moment = __webpack_require__(95093);




function DaySelect(_ref) {
  let {
    days,
    selectedDay,
    onSelect
  } = _ref;
  const [showMoreDays, setShowMoreDays] = (0,react.useState)(false);
  return !showMoreDays ? /*#__PURE__*/react.createElement("div", {
    className: "flex max-w-full flex-wrap gap-2"
  }, days.slice(0, 4).map(day => /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    key: day.toISOString(),
    onClick: () => onSelect(day),
    primary: day.isSame(selectedDay)
  }, getDayName(day), ", ", day.format('D. M.'))), /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    grayLink: true,
    onClick: () => setShowMoreDays(true)
  }, pgettext('portal_i18n', 'Later...'))) : /*#__PURE__*/react.createElement(ui/* default */.A.Form.Select, {
    value: selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.toISOString(),
    onChange: value => {
      var _moment;
      return onSelect((_moment = DaySelect_moment(value)) !== null && _moment !== void 0 ? _moment : null);
    },
    choices: days.map(day => ({
      key: day.toISOString(),
      label: "".concat(getDayName(day), ", ").concat(day.format('D. M.')),
      value: day.toISOString()
    }))
  });
}
/* harmony default export */ const ShippingPickup_DaySelect = (DaySelect);
// EXTERNAL MODULE: ./react/portal/ui/Button.tsx
var Button = __webpack_require__(31453);
;// ./react/portal/shipping/ShippingPickup/ShippingProviderRow.tsx
/* provided dependency */ var ShippingProviderRow_moment = __webpack_require__(95093);







const renderInterval = interval => "".concat(ShippingProviderRow_moment(interval.start, 'HH:mm').format('H:mm'), " - ").concat(ShippingProviderRow_moment(interval.end, 'HH:mm').format('H:mm'));
function ShippingProviderRow(_ref) {
  var _shippingRoute$label_;
  let {
    isSelected,
    day,
    shippingRoute,
    pickupInterval,
    onClick,
    onIntervalSelect
  } = _ref;
  const intervals = shippingRoute.pickup_intervals.filter(interval => ShippingProviderRow_moment(interval.date).date() === day.date());
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    onClick: onClick,
    leftAction: isSelected && /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, {
      left: true
    }),
    rightAction: !isSelected && /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null)
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-8 w-14 flex-shrink-0 items-center justify-center"
  }, /*#__PURE__*/react.createElement("img", {
    src: shippingRoute.provider_config.logo_url,
    alt: ""
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(shippingRoute.name)), (intervals === null || intervals === void 0 ? void 0 : intervals.length) === 1 && /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, renderInterval(intervals[0])))), /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-900"
  }, /*#__PURE__*/react.createElement(react_ui/* Label */.JU, {
    rounded: true,
    size: "large",
    color: Number(shippingRoute.customer_amount) === 0 ? 'green' : 'blue'
  }, Number(shippingRoute.customer_amount) === 0 ? pgettext('portal_i18n', 'free') : (0,utils/* formatPrice */.$g)(shippingRoute.customer_amount, shippingRoute.customer_currency))))), isSelected && intervals.length > 1 && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-start justify-center gap-2"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium"
  }, pgettext('portal_i18n', 'Please select the pickup window:'))), intervals.map(item => /*#__PURE__*/react.createElement(Button/* default */.A, {
    key: item.id,
    primary: (pickupInterval === null || pickupInterval === void 0 ? void 0 : pickupInterval.id) === item.id,
    size: "small",
    fluid: true,
    onClick: () => onIntervalSelect(item)
  }, renderInterval(item))))), isSelected && pickupInterval && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("p", {
    className: "mb-4 text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(shippingRoute.description)), /*#__PURE__*/react.createElement(shipping_ProviderPackageInfo, {
    providerConfig: shippingRoute.provider_config,
    labelType: (_shippingRoute$label_ = shippingRoute.label_type) !== null && _shippingRoute$label_ !== void 0 ? _shippingRoute$label_ : null
  })), /*#__PURE__*/react.createElement(shipping_MultipleShippings, null)));
}
/* harmony default export */ const ShippingPickup_ShippingProviderRow = (ShippingProviderRow);
;// ./react/portal/shipping/ShippingPickup/index.tsx
/* provided dependency */ var ShippingPickup_moment = __webpack_require__(95093);













function ShippingPickup() {
  var _formProgress$new_shi, _formProgress$new_shi2;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [shippingRoutes, setShippingRoutes] = (0,react.useState)(null);
  const [days, setDays] = (0,react.useState)([]);
  const [selectedDay, setSelectedDay] = (0,react.useState)(ShippingPickup_moment());
  const [handleLoadShippingRoutes] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormProgressShippingRoutesApi.list({
      id: formProgress.id
    });
    const pickupRoutes = response.filter(type => type.provider_config.submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.PICKUP);
    setShippingRoutes(pickupRoutes);
  });
  (0,react.useEffect)(() => {
    handleLoadShippingRoutes();
  }, []);
  const [selectedShippingRoute, setSelectedShippingRoute] = (0,react.useState)(null);
  const [selectedPickupInterval, setSelectedPickupInterval] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    if (selectedShippingRoute) {
      const intervals = selectedShippingRoute.pickup_intervals.filter(interval => ShippingPickup_moment(interval.date).date() === selectedDay.date());
      if (intervals.length === 1) {
        const firstInterval = intervals[0];
        setSelectedPickupInterval(firstInterval);
        // triggers useEffect below
      }
    }
  }, [selectedShippingRoute, selectedDay]);
  (0,react.useEffect)(() => {
    if (shippingRoutes) {
      const sortMomentTimes = (a, b) => a.isAfter(b) ? 1 : -1;
      const computedDays = [...new Set(shippingRoutes.flatMap(type => type.pickup_intervals.map(interval => interval.date)))].map(value => ShippingPickup_moment(value)).sort(sortMomentTimes);
      setDays(computedDays);
      setSelectedDay(computedDays[0]);
    }
  }, [shippingRoutes]);
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (selectedShippingRoute && selectedPickupInterval) {
      await updateFormProgress({
        shipping_route_id: selectedShippingRoute.id,
        pickup_interval: selectedPickupInterval.id
      });
      navigateNext();
    } else {
      react_ui/* toast */.oR.error();
    }
  });
  (0,react.useEffect)(() => {
    setSelectedShippingRoute(null);
    setSelectedPickupInterval(null);
  }, [selectedDay]);
  const bottomRef = (0,react.useRef)(null);
  const scrollToBottom = () => {
    var _bottomRef$current;
    (_bottomRef$current = bottomRef.current) === null || _bottomRef$current === void 0 || _bottomRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  };
  (0,react.useEffect)(() => {
    scrollToBottom();
  }, [selectedPickupInterval]);
  const handlePlaceClick = () => {
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingZipCode({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  };
  const filterShippingTypesForDate = (items, date) => items.filter(item => item.pickup_intervals.map(interval => interval.date).includes(date.format('YYYY-MM-DD')));
  const shippingTypesForDay = filterShippingTypesForDate(shippingRoutes !== null && shippingRoutes !== void 0 ? shippingRoutes : [], selectedDay !== null && selectedDay !== void 0 ? selectedDay : ShippingPickup_moment());
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.75
    }),
    footer: /*#__PURE__*/react.createElement("div", null, (selectedShippingRoute === null || selectedShippingRoute === void 0 ? void 0 : selectedShippingRoute.paid_by_customer) && /*#__PURE__*/react.createElement("div", {
      className: "mb-1 text-center leading-none"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-xs text-gray-500"
    }, interpolate(pgettext('portal_i18n', 'In the last step of the ticket creation process, we will ask you to pay %(price)s for the shipping'), {
      price: getShippingTypePrice(selectedShippingRoute, formProgress.amount_of_shippings)
    }, true))), /*#__PURE__*/react.createElement(react_ui/* Popup */.zD, {
      fluid: true,
      position: "top center",
      on: "hover",
      disabled: selectedPickupInterval !== null && selectedShippingRoute !== null,
      trigger: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
        disabled: !selectedPickupInterval || !selectedShippingRoute,
        fluid: true,
        primary: true,
        size: "large",
        onClick: handleSubmit,
        loading: isSubmitting
      }, pgettext('portal_i18n', 'Continue'))
    }, /*#__PURE__*/react.createElement("p", {
      className: "text-center text-sm text-gray-500"
    }, "Please select shipping type and pickup time.")), /*#__PURE__*/react.createElement("div", {
      ref: bottomRef
    }))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "mb-1 px-5"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-600"
  }, pgettext('portal_i18n', 'Selected city'))), /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    onClick: handlePlaceClick,
    gray: true,
    leftAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, {
      left: true
    })
  }, /*#__PURE__*/react.createElement("div", {
    className: "ml-2 flex items-center gap-4"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "location-marker",
    fitted: true,
    colorIntensity: 400,
    solid: true,
    color: "gray"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-900"
  }, ((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.city) && /*#__PURE__*/react.createElement("span", null, formProgress.new_shipping_address.city, ", "), (_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.postal_code))))), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mb-1"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-600"
  }, pgettext('portal_i18n', 'Select a pickup day'))), /*#__PURE__*/react.createElement(ShippingPickup_DaySelect, {
    days: days,
    selectedDay: selectedDay,
    onSelect: setSelectedDay
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "mb-1 px-5"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-600"
  }, pgettext('portal_i18n', 'Available carriers'))), shippingRoutes === null ? /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null) : /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, selectedShippingRoute ? /*#__PURE__*/react.createElement(ShippingPickup_ShippingProviderRow, {
    key: selectedShippingRoute.id,
    shippingRoute: selectedShippingRoute,
    pickupInterval: selectedPickupInterval,
    day: selectedDay,
    isSelected: true,
    onClick: () => setSelectedShippingRoute(null),
    onIntervalSelect: setSelectedPickupInterval
  }) : shippingTypesForDay.map(shippingRoute => /*#__PURE__*/react.createElement(ShippingPickup_ShippingProviderRow, {
    key: shippingRoute.id,
    shippingRoute: shippingRoute,
    pickupInterval: selectedPickupInterval,
    day: selectedDay,
    isSelected: false,
    onClick: () => setSelectedShippingRoute(shippingRoute),
    onIntervalSelect: setSelectedPickupInterval
    // availableFrom={
    //   unavailableShippingTypes.includes(type.id)
    //     ? moment(type.shipping_provider_data.time_availability[0][1])
    //     : undefined
    // }
  }))))));
}
/* harmony default export */ const shipping_ShippingPickup = (ShippingPickup);
;// ./react/portal/shipping/ShippingTypeList/OwnShippingModal.tsx


function OwnShippingModal(_ref) {
  let {
    open,
    onConfirm,
    onClose
  } = _ref;
  return /*#__PURE__*/react.createElement(react_ui/* Modal */.aF, {
    size: "md",
    open: open,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(react_ui/* Form */.lV, {
    onSubmit: onConfirm
  }, /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center space-y-4 align-middle"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-12 w-12 items-center justify-center rounded-full bg-red-100"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    fitted: true,
    size: "large",
    color: "red",
    name: "exclamation"
  })), /*#__PURE__*/react.createElement("h1", {
    className: "text-center text-lg font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Do you want to arrange the shipping yourself?')), /*#__PURE__*/react.createElement("p", {
    className: "text-center"
  }, pgettext('portal_i18n', 'To resolve the ticket, it is necessary to deliver the goods to our store.')), /*#__PURE__*/react.createElement("p", {
    className: "text-center"
  }, pgettext('portal_i18n', 'The shipping ordered through our system is linked to your case and thanks to this we can resolve your case faster.')))), /*#__PURE__*/react.createElement(react_ui/* Modal */.aF.Footer, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    fluid: true,
    negative: true,
    submit: true
  }, pgettext('portal_i18n', "I'll arrange the shipping myself")), /*#__PURE__*/react.createElement(react_ui/* Button */.$n, {
    fluid: true,
    onClick: onClose
  }, pgettext('portal_i18n', 'Choose from our offer'))))));
}
/* harmony default export */ const ShippingTypeList_OwnShippingModal = (OwnShippingModal);
;// ./react/portal/shipping/ShippingTypeList/ShippingTypeCard.tsx



/**
 * Shared row card for the portal shipping type selection screen.
 *
 * Used by Pickup, Drop-off, In-person and Custom variants. Either ``description`` (text)
 * or ``logoUrls`` (carrier logo strip) can be passed; not both.
 */
function ShippingTypeCard(_ref) {
  let {
    iconName,
    iconBgClassName,
    title,
    description,
    logoUrls,
    price,
    priceNeutral,
    loading,
    onClick
  } = _ref;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
    onClick: onClick,
    loading: loading
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-white shadow-lg ".concat(iconBgClassName)
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: iconName,
    size: "large",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium text-gray-900 sm:text-base"
  }, title), description && /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, description), logoUrls && logoUrls.length > 0 && /*#__PURE__*/react.createElement("div", {
    className: "flex gap-2"
  }, logoUrls.slice(0, 2).map(logoUrl => /*#__PURE__*/react.createElement("img", {
    key: logoUrl,
    src: logoUrl,
    alt: "",
    className: "h-5"
  })), logoUrls.length > 2 && /*#__PURE__*/react.createElement(react_ui/* Popup */.zD, {
    on: "hover",
    trigger: /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-center p-0.5 text-gray-400"
    }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
      name: "dots-horizontal",
      size: "tiny"
    }))
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex w-max flex-col items-center gap-2 p-2"
  }, logoUrls.slice(2).map(logoUrl => /*#__PURE__*/react.createElement("img", {
    key: logoUrl,
    src: logoUrl,
    alt: "",
    className: "h-5"
  }))))))), price !== undefined && /*#__PURE__*/react.createElement("div", {
    className: "shrink-0 pr-1"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium ".concat(priceNeutral ? 'text-gray-900' : 'text-green-700')
  }, price))));
}
/* harmony default export */ const ShippingTypeList_ShippingTypeCard = (ShippingTypeCard);
;// ./react/portal/shipping/ShippingTypeList/index.tsx














function ShippingTypeList() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [shippingRoutes, setShippingRoutes] = (0,react.useState)(null);
  const [providersConfig, handleLoadProvidersConfig] = useShippingProviderConfig();
  const [modalOpen, setModalOpen] = (0,react.useState)(false);
  const [handleLoadRetinoShippingTypes] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const response = await publicApi.PortalFormProgressShippingRoutesApi.list({
      id: formProgress.id
    });
    setShippingRoutes(response);
  });
  (0,react.useEffect)(() => {
    handleLoadRetinoShippingTypes();
    handleLoadProvidersConfig();
  }, []);
  const handleDropOffClick = () => {
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffMap({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  };
  const handlePickupClick = () => {
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingZipCode({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  };
  const handleInPersonClick = () => {
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingInPersonBranch({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  };
  const [handleCustomClick, isCustomSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async shippingRoute => {
    await updateFormProgress({
      shipping_route_id: shippingRoute.id,
      drop_off_branch_id: null
    });
    navigateNext();
  });
  const [handleDontWant, isDontWantSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    await updateFormProgress({
      shipping_route_id: null,
      drop_off_branch_id: null
    });
    navigateNext();
  });
  const getSubmitTypeLogosUrls = submitType => [...new Set(Object.values(providersConfig !== null && providersConfig !== void 0 ? providersConfig : {}).filter(c => c.submit_type === submitType).filter(c => shippingRoutes === null || shippingRoutes === void 0 ? void 0 : shippingRoutes.some(r => r.provider === c.type)).map(conf => conf.logo_url))];
  if (shippingRoutes === null || providersConfig === null) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  const hasExchange = formProgress.has_complete_exchange;
  const clicksDisabled = isCustomSubmitting || isDontWantSubmitting;
  const pickupShippingTypes = shippingRoutes.filter(route => providersConfig[route.provider].submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.PICKUP);
  const dropoffShippingTypes = shippingRoutes.filter(route => providersConfig[route.provider].submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.DROP_OFF);
  const customShippingTypes = shippingRoutes.filter(route => providersConfig[route.provider].submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.CUSTOM);
  const inPersonShippingTypes = shippingRoutes.filter(route => providersConfig[route.provider].submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.IN_PERSON);
  const defaultShippingTitle = pgettext('portal_i18n', 'Select a shipping type');
  const defaultShippingDescription = pgettext('portal_i18n', 'We will need you to send us the selected products. For the fastest resolution of the ticket, we recommend that you order from the shipping service listed below.');
  const configuredShippingTitle = (0,utils/* currentLanguage */.aS)(formProgress.form.strings.shipping_type_selection_title);
  const configuredShippingDescription = (0,utils/* currentLanguage */.aS)(formProgress.form.strings.shipping_type_selection_description);
  const shippingTitle = hasExchange && (!configuredShippingTitle || configuredShippingTitle === defaultShippingTitle) ? pgettext('portal_i18n', 'How will you send the return?') : configuredShippingTitle || defaultShippingTitle;
  const shippingDescription = hasExchange && (!configuredShippingDescription || configuredShippingDescription === defaultShippingDescription) ? pgettext('portal_i18n', 'This is only for the returned item. Delivery of the new product is chosen later.') : configuredShippingDescription || defaultShippingDescription;
  const dropOffLogoUrls = getSubmitTypeLogosUrls(codegen/* BackendPublicEnums */.C.SubmitTypeEnum.DROP_OFF);
  const pickupLogosUrls = getSubmitTypeLogosUrls(codegen/* BackendPublicEnums */.C.SubmitTypeEnum.PICKUP);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.25
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: shippingTitle,
    description: /*#__PURE__*/react.createElement("div", null, shippingDescription)
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, dropoffShippingTypes.length > 0 && /*#__PURE__*/react.createElement(ShippingTypeList_ShippingTypeCard, {
    iconName: "home",
    iconBgClassName: "bg-red-600",
    title: pgettext('portal_i18n', "I'll bring the package to a branch"),
    logoUrls: dropOffLogoUrls,
    price: getLowestRoutePrice(dropoffShippingTypes),
    priceNeutral: hasExchange,
    onClick: () => {
      if (!clicksDisabled) handleDropOffClick();
    }
  }), pickupShippingTypes.length > 0 && /*#__PURE__*/react.createElement(ShippingTypeList_ShippingTypeCard, {
    iconName: "truck",
    iconBgClassName: "bg-blue-600",
    title: pgettext('portal_i18n', "I'll order a pickup"),
    logoUrls: pickupLogosUrls,
    price: getLowestRoutePrice(pickupShippingTypes),
    priceNeutral: hasExchange,
    onClick: () => {
      if (!clicksDisabled) handlePickupClick();
    }
  }), inPersonShippingTypes.length > 0 && /*#__PURE__*/react.createElement(ShippingTypeList_ShippingTypeCard, {
    iconName: "home",
    iconBgClassName: "bg-teal-600",
    title: pgettext('portal_i18n', "I'll return it in person"),
    description: pgettext('portal_i18n', 'Bring the package to one of our store branches.'),
    price: getLowestRoutePrice(inPersonShippingTypes),
    priceNeutral: hasExchange,
    onClick: () => {
      if (!clicksDisabled) handleInPersonClick();
    }
  }), customShippingTypes.map(type => /*#__PURE__*/react.createElement(ShippingTypeList_ShippingTypeCard, {
    key: type.id,
    iconName: "cube",
    iconBgClassName: "bg-gray-600",
    title: (0,utils/* currentLanguage */.aS)(type.name),
    description: (0,utils/* currentLanguage */.aS)(type.description),
    price: getLowestRoutePrice([type]),
    priceNeutral: hasExchange,
    loading: isCustomSubmitting,
    onClick: () => {
      if (!clicksDisabled) handleCustomClick(type);
    }
  })), /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
    gray: true,
    rightAction: /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
    onClick: () => {
      if (!clicksDisabled) setModalOpen(true);
    },
    loading: isDontWantSubmitting
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-sm font-medium leading-7 text-gray-900 sm:text-base"
  }, pgettext('portal_i18n', "I'll arrange the shipping myself")), /*#__PURE__*/react.createElement("span", {
    className: "text-xs text-gray-500"
  }, pgettext('portal_i18n', "I don't want to use your shipping offer."))))), /*#__PURE__*/react.createElement("div", {
    className: "shrink-0 pr-1"
  }))), /*#__PURE__*/react.createElement(ShippingTypeList_OwnShippingModal, {
    onClose: () => setModalOpen(false),
    onConfirm: handleDontWant,
    open: modalOpen
  })));
}
/* harmony default export */ const shipping_ShippingTypeList = (ShippingTypeList);
;// ./react/portal/shipping/ShippingZipCode/ZipCodeWithoutPlacesApi.tsx








function ZipCodeWithoutPlacesApi() {
  var _formProgress$new_shi, _formProgress$new_shi2, _errors$new_shipping_;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [postalCode, setPostalCode] = (0,react.useState)((_formProgress$new_shi = (_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.postal_code) !== null && _formProgress$new_shi !== void 0 ? _formProgress$new_shi : '');
  const [errors, setErrors] = (0,react.useState)({});
  const [submitRef, submit] = useSubmitRef();
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      await updateFormProgress({
        new_shipping_address: {
          postal_code: postalCode,
          city: undefined
        }
      });
      setErrors({});
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingPickup({
        companyId,
        formProgressId: formProgress.id,
        lang
      }));
    } catch (errorResponse) {
      if (isResponse(errorResponse) && errorResponse.response.status === 400) {
        setErrors(await getErrors(errorResponse));
      }
    }
  });
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.5
    }),
    footer: postalCode.length >= 3 && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      fluid: true,
      primary: true,
      size: "large",
      onClick: submit,
      loading: isSubmitting
    }, pgettext('portal_i18n', 'Continue'))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'What city do you ship from?'),
    description: pgettext('portal_i18n', 'Please fill in the zip code of the city from which you will be sending the package, so that we can offer you the most convenient method of shipping.')
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    hidden: true,
    type: "submit",
    ref: submitRef
  }), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    name: "zip-code",
    required: true,
    value: postalCode,
    onChange: setPostalCode,
    label: pgettext('portal_i18n', 'Enter the zip code'),
    error: (_errors$new_shipping_ = errors.new_shipping_address) === null || _errors$new_shipping_ === void 0 ? void 0 : _errors$new_shipping_.postal_code
  })))));
}
/* harmony default export */ const ShippingZipCode_ZipCodeWithoutPlacesApi = (ZipCodeWithoutPlacesApi);
;// ./react/portal/shipping/ShippingZipCode/index.tsx












function ShippingZipCode() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const [providersConfig, handleLoadProvidersConfig] = useShippingProviderConfig();
  const getPrefilledLocation = () => {
    var _formProgress$new_shi;
    if ((_formProgress$new_shi = formProgress.new_shipping_address) !== null && _formProgress$new_shi !== void 0 && _formProgress$new_shi.postal_code) {
      var _formProgress$new_shi3;
      if (formProgress.new_shipping_address.city) {
        var _formProgress$new_shi2;
        return "".concat(formProgress.new_shipping_address.city, ", ").concat((_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.postal_code);
      }
      return (_formProgress$new_shi3 = formProgress.new_shipping_address) === null || _formProgress$new_shi3 === void 0 ? void 0 : _formProgress$new_shi3.postal_code;
    }
    return '';
  };
  const [postalCodeOrCity, setPostalCodeOrCity] = (0,react.useState)(getPrefilledLocation);
  const [cityChoices, setCityChoices] = (0,react.useState)();
  const [hereApiError, setHereApiError] = (0,react.useState)(false);
  const [supportedCountries, setSupportedCountries] = (0,react.useState)([]);
  const refTimeout = (0,react.useRef)(null);
  const getGeoData = async (latitude, longitude) => {
    try {
      const response = await publicApi.PortalGeoDataByCoordsApi.retrieve({
        lat: latitude,
        lng: longitude,
        lang: window.appState.lang
      });
      if (response.errors.length > 0) {
        setHereApiError(true);
        return '';
      }
      return "".concat(response.result.city, ", ").concat(response.result.postal_code);
    } catch (_unused) {
      return '';
    }
  };
  const [searchCities] = (0,hooks/* useAsyncFunction */.m_)(async queryStreetHouseNumber => {
    var _formProgress$new_shi4, _formProgress$new_shi5;
    const response = await publicApi.PortalGeoDataByQueryApi.retrieve({
      street: queryStreetHouseNumber.trim(),
      house_number: '',
      city: '',
      postal_code: '',
      country: (_formProgress$new_shi4 = (_formProgress$new_shi5 = formProgress.new_shipping_address) === null || _formProgress$new_shi5 === void 0 ? void 0 : _formProgress$new_shi5.country) !== null && _formProgress$new_shi4 !== void 0 ? _formProgress$new_shi4 : 'CZ',
      lang: window.appState.lang
    });
    if (response.errors.length > 0) {
      setHereApiError(true);
    } else {
      setCityChoices(response.results);
    }
  });
  const [handleCitySelect, isSelectingCity] = (0,hooks/* useAsyncFunction */.m_)(async place => {
    if (!supportedCountries.includes(place.country)) {
      return;
    }
    await updateFormProgress({
      new_shipping_address: {
        postal_code: place.postal_code,
        country: place.country,
        city: place.city
      },
      shipping_latitude: Number(place.latitude),
      shipping_longitude: Number(place.longitude)
    });
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdShippingPickup({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  });
  (0,react.useEffect)(() => {
    if (postalCodeOrCity.length >= 3) {
      if (refTimeout.current) {
        clearTimeout(refTimeout.current);
      }
      refTimeout.current = setTimeout(() => searchCities(postalCodeOrCity), 300);
    }
  }, [postalCodeOrCity]);
  const [handleLoadSupportedCountries] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (providersConfig === null) return;
    const response = await publicApi.PortalFormProgressShippingRoutesApi.list({
      id: formProgress.id
    });
    const pickupShippingTypes = response.filter(type => providersConfig[type.provider].submit_type === codegen/* BackendPublicEnums */.C.SubmitTypeEnum.PICKUP);
    const countries = pickupShippingTypes.flatMap(type => type.country_from);
    setSupportedCountries(countries);
  });
  (0,react.useEffect)(() => {
    if (postalCodeOrCity.trim().length >= 3) {
      searchCities(postalCodeOrCity);
    }
    if (!postalCodeOrCity) {
      getGeolocationPosition(async (latitude, longitude) => setPostalCodeOrCity(await getGeoData(latitude, longitude)));
    }
    handleLoadProvidersConfig();
  }, []);
  (0,react.useEffect)(() => {
    handleLoadSupportedCountries();
  }, [providersConfig]);
  if (hereApiError) {
    return /*#__PURE__*/react.createElement(ShippingZipCode_ZipCodeWithoutPlacesApi, null);
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Return shipping'),
      substepProgress: 0.5
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'What city do you ship from?'),
    description: pgettext('portal_i18n', 'Please fill in the address, city, or zip code of the city from which you will be sending the package, so that we can offer you the most convenient method of shipping.')
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Input, {
    value: postalCodeOrCity,
    onChange: setPostalCodeOrCity,
    label: pgettext('portal_i18n', 'Address, city or zip code'),
    readOnly: isSelectingCity
  })), /*#__PURE__*/react.createElement("div", {
    className: "mt-4 -space-y-px"
  }, (cityChoices === null || cityChoices === void 0 ? void 0 : cityChoices.length) === 0 && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-2 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-7 w-7 items-center justify-center rounded-full bg-gray-200 "
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "search",
    size: "tiny",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "font-medium"
  }, pgettext('portal_i18n', "We couldn't find the city"))), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-500"
  }, pgettext('portal_i18n', 'In the input above, fill in the address, or just the city from which you will send the package.')), /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-500"
  }, pgettext('portal_i18n', 'For example: Prague or 120 00.')))), cityChoices === null || cityChoices === void 0 ? void 0 : cityChoices.map(city => {
    const inSupportedCountry = supportedCountries.includes(city.country);
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, {
      key: city.place_id,
      rightAction: inSupportedCountry && /*#__PURE__*/react.createElement(ui/* default */.A.Card.Chevron, null),
      onClick: inSupportedCountry ? () => handleCitySelect(city) : undefined,
      loading: isSelectingCity,
      gray: !inSupportedCountry
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex items-center gap-4"
    }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
      name: "location-marker",
      fitted: true,
      colorIntensity: 400,
      solid: true,
      color: "gray"
    }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
      className: "text-sm font-medium ".concat(inSupportedCountry ? 'text-gray-900' : 'text-gray-400')
    }, city.title), !inSupportedCountry && /*#__PURE__*/react.createElement("div", {
      className: "text-sm font-medium text-red-500"
    }, pgettext('portal_i18n', "We don't support pickup shipping from this country.")))));
  }))));
}
/* harmony default export */ const shipping_ShippingZipCode = (ShippingZipCode);
;// ./react/portal/summary/BackwardsNavigation/index.tsx








function BackwardsNavigation() {
  var _formProgress$shippin;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    navigateFromSummary
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    preview
  } = exchange_useExchangePreview();
  const submitType = (_formProgress$shippin = formProgress.shipping_route) === null || _formProgress$shippin === void 0 ? void 0 : _formProgress$shippin.provider_config.submit_type;
  const exchangeHasSurcharge = preview ? exchangeBalance(preview).kind === 'surcharge' : Boolean(formProgress.exchange_payment_method_external_id);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Summary')
    }),
    footer: /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      fluid: true,
      primary: true,
      size: "large",
      onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdSummary({
        companyId,
        formProgressId: formProgress.id,
        lang
      }))
    }, pgettext('portal_i18n', "I don't want to change anything"))
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Header, {
    header: pgettext('portal_i18n', 'Select what you want to change'),
    description: pgettext('portal_i18n', "Something's wrong or you've forgotten something?")
  }), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-1"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'Order items')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => {
      var _formProgress$immutab, _formProgress$immutab2;
      if (((_formProgress$immutab = (_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.items.length) !== null && _formProgress$immutab !== void 0 ? _formProgress$immutab : 0) > 1) {
        navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdProductSelectList({
          companyId,
          formProgressId: formProgress.id,
          lang
        }));
      } else {
        navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
          companyId,
          formProgressId: formProgress.id,
          lang
        }));
      }
    }
  }, pgettext('portal_i18n', 'Edit products information')))), formProgress.has_complete_exchange && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'Exchange')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdExchangeSummaryShipping({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change delivery of the new goods')), exchangeHasSurcharge && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdExchangeSummaryPayment({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change surcharge payment')))), formProgress.states.includes(codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.SHIPPING) && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'Return shipping')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdShippingType({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change the type of shipping')), submitType === 'PICKUP' && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdShippingPickup({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change pickup time')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdCustomerInfo({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change pickup address'))), submitType === 'DROP_OFF' && /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffMap({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change branch')))), formProgress.states.includes(codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.REFUNDS) && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'Refund option')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdRefund({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Change the refund option')))), /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-gray-900"
  }, pgettext('portal_i18n', 'Your details')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: () => navigateFromSummary(portalRoutes/* default */.A.formProgressFormProgressIdCustomerInfo({
      companyId,
      formProgressId: formProgress.id,
      lang
    }))
  }, pgettext('portal_i18n', 'Edit your details'))))));
}
/* harmony default export */ const summary_BackwardsNavigation = (BackwardsNavigation);
;// ./react/portal/summary/Summary/utils.ts
/* provided dependency */ var Summary_utils_moment = __webpack_require__(95093);

function getFormattedShippingAddress(formProgress) {
  if (formProgress.new_shipping_address) {
    return "".concat(formProgress.new_shipping_address.street, " ").concat(formProgress.new_shipping_address.house_number, ",\n      ").concat(formProgress.new_shipping_address.city, " ").concat(formProgress.new_shipping_address.postal_code);
  }
  return '';
}
function getFormattedPickupTime(formProgress) {
  var _formProgress$shippin;
  const interval = (_formProgress$shippin = formProgress.shipping_route) === null || _formProgress$shippin === void 0 ? void 0 : _formProgress$shippin.pickup_intervals.find(item => item.id === formProgress.pickup_interval);
  if (!interval) {
    return '';
  }
  const pickupDate = Summary_utils_moment(interval.date);
  const intervalStart = Summary_utils_moment(interval.start, 'HH:mm').format('H:mm');
  const intervalEnd = Summary_utils_moment(interval.end, 'HH:mm').format('H:mm');
  const day = "".concat(getDayName(pickupDate), " ").concat(pickupDate.format('D. M.'));
  return interpolate(pgettext('portal_i18n', '%(day)s between %(interval_start)s and %(interval_end)s'), {
    day,
    interval_start: intervalStart,
    interval_end: intervalEnd
  }, true);
}
;// ./react/portal/summary/Summary/CustomerInfo.tsx





function CustomerInfo_CustomerInfo() {
  var _formProgress$new_shi;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-base font-medium text-gray-900"
  }, formProgress.customer_blocks_data.customer_name)), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 space-y-1 text-sm text-gray-500"
  }, formProgress.customer_blocks_data.customer_email && /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "flex w-5 shrink-0 justify-center pt-0.5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "mail",
    solid: true,
    color: "gray",
    colorIntensity: 400,
    fitted: true,
    size: "tiny"
  })), /*#__PURE__*/react.createElement("span", {
    className: "min-w-0 break-words"
  }, formProgress.customer_blocks_data.customer_email)), formProgress.customer_blocks_data.customer_phone && /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "flex w-5 shrink-0 justify-center pt-0.5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "phone",
    solid: true,
    color: "gray",
    colorIntensity: 400,
    fitted: true,
    size: "tiny"
  })), /*#__PURE__*/react.createElement("span", {
    className: "min-w-0 break-words"
  }, formProgress.customer_blocks_data.customer_phone)), ((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.city) && /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "flex w-5 shrink-0 justify-center pt-0.5"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "location-marker",
    solid: true,
    color: "gray",
    colorIntensity: 400,
    fitted: true,
    size: "tiny"
  })), /*#__PURE__*/react.createElement("span", {
    className: "min-w-0 break-words"
  }, getFormattedShippingAddress(formProgress))))));
}
/* harmony default export */ const Summary_CustomerInfo = (CustomerInfo_CustomerInfo);
;// ./react/portal/summary/Summary/Exchange.tsx






function ProductVisual(_ref) {
  let {
    image,
    fallbackIcon,
    compact = false
  } = _ref;
  const sizeClass = compact ? 'size-10 rounded-md' : 'size-14 rounded-lg';
  return /*#__PURE__*/react.createElement("div", {
    className: "flex shrink-0 items-center justify-center overflow-hidden bg-white ring-1 ring-gray-950/10 ".concat(sizeClass)
  }, image ? /*#__PURE__*/react.createElement("img", {
    src: image,
    alt: "",
    className: "size-full object-contain"
  }) : /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: fallbackIcon,
    color: "gray",
    colorIntensity: 400,
    fitted: true
  }));
}
function MoneySummary(_ref2) {
  let {
    value,
    timing
  } = _ref2;
  if (!value) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "shrink-0 text-right"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium tabular-nums text-gray-900"
  }, value), timing && /*#__PURE__*/react.createElement("div", {
    className: "whitespace-nowrap text-xs text-gray-500"
  }, timing));
}
function itemCountLabel(items) {
  const count = items.reduce((total, item) => total + item.amount, 0);
  const label = count === 1 ? pgettext('portal_i18n', '%(count)s item') : pgettext('portal_i18n', '%(count)s items');
  return interpolate(label, {
    count
  }, true);
}
function ProductStack(_ref3) {
  let {
    items,
    fallbackIcon
  } = _ref3;
  const visibleItems = items.slice(0, 3);
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-14 items-center justify-center"
  }, visibleItems.map((item, index) => /*#__PURE__*/react.createElement("div", {
    key: item.key,
    className: "flex size-12 items-center justify-center overflow-hidden rounded-lg bg-white ring-1 ring-gray-950/10 ".concat(index > 0 ? '-ml-5' : '')
  }, item.image ? /*#__PURE__*/react.createElement("img", {
    src: item.image,
    alt: "",
    className: "size-full object-contain"
  }) : /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: fallbackIcon,
    color: "gray",
    colorIntensity: 400,
    fitted: true
  }))), items.length > visibleItems.length && /*#__PURE__*/react.createElement("div", {
    className: "-ml-3 flex size-7 items-center justify-center rounded-full bg-white text-xs font-medium text-gray-600 ring-1 ring-gray-950/10"
  }, "+", items.length - visibleItems.length));
}
function ProductList(_ref4) {
  let {
    items,
    fallbackIcon
  } = _ref4;
  const [expanded, setExpanded] = (0,react.useState)(false);
  const visibleItems = expanded ? items : items.slice(0, 3);
  const hiddenCount = items.length - visibleItems.length;
  return /*#__PURE__*/react.createElement("div", {
    className: "mt-3 grid gap-2"
  }, visibleItems.map(item => /*#__PURE__*/react.createElement("div", {
    key: item.key,
    className: "flex items-center gap-3"
  }, /*#__PURE__*/react.createElement(ProductVisual, {
    image: item.image,
    fallbackIcon: fallbackIcon,
    compact: true
  }), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "line-clamp-2 text-sm font-medium text-gray-900"
  }, item.amount, "\xD7 ", item.name), item.variant && /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, item.variant)))), items.length > 3 && /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "flex min-h-9 items-center gap-1 text-sm font-medium text-[var(--colors-primary)]",
    onClick: () => setExpanded(value => !value)
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: expanded ? 'chevron-up' : 'chevron-down',
    solid: true,
    fitted: true
  }), expanded ? pgettext('portal_i18n', 'Show less') : interpolate(pgettext('portal_i18n', '%(count)s more'), {
    count: hiddenCount
  }, true)));
}
function RouteDiagram(_ref5) {
  let {
    data
  } = _ref5;
  return /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "grid grid-cols-[1fr_auto_1fr] items-start gap-2 pb-4 pt-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 text-center"
  }, /*#__PURE__*/react.createElement(ProductStack, {
    items: data.returnedItems,
    fallbackIcon: "reply"
  }), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Return')), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, itemCountLabel(data.returnedItems))), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1 pt-4 text-gray-300"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "arrow-right",
    fitted: true
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center gap-1 text-[var(--colors-primary)]"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "check-circle",
    solid: true,
    fitted: true
  }), /*#__PURE__*/react.createElement("span", {
    className: "text-xs font-medium"
  }, pgettext('portal_i18n', 'Approval'))), /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "arrow-right",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 text-center"
  }, /*#__PURE__*/react.createElement(ProductStack, {
    items: data.purchasedItems,
    fallbackIcon: "shopping-bag"
  }), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm font-medium text-gray-900"
  }, pgettext('portal_i18n', 'New order')), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, itemCountLabel(data.purchasedItems)))), /*#__PURE__*/react.createElement("section", {
    className: "-mx-5 border-t border-gray-950/5 px-5 py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start justify-between gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Returned goods')), /*#__PURE__*/react.createElement(MoneySummary, {
    value: data.returnAmount,
    timing: pgettext('portal_i18n', 'now')
  })), /*#__PURE__*/react.createElement(ProductList, {
    items: data.returnedItems,
    fallbackIcon: "reply"
  }), /*#__PURE__*/react.createElement("div", {
    className: "-mx-5 mt-3 flex items-start gap-3 border-t border-gray-950/5 px-5 pt-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mt-0.5 flex w-10 shrink-0 justify-center text-gray-400"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "truck",
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, pgettext('portal_i18n', 'Return shipping')), /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, data.returnShippingName), data.returnShippingDetail && /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, data.returnShippingDetail)))), /*#__PURE__*/react.createElement("section", {
    className: "-mx-5 border-t border-gray-950/5 px-5 pb-1 pt-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start justify-between gap-3"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, pgettext('portal_i18n', 'New order')), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, pgettext('portal_i18n', 'After approval'))), /*#__PURE__*/react.createElement(MoneySummary, {
    value: data.settlementValue,
    timing: data.settlementTiming
  })), /*#__PURE__*/react.createElement(ProductList, {
    items: data.purchasedItems,
    fallbackIcon: "shopping-bag"
  }), /*#__PURE__*/react.createElement("div", {
    className: "-mx-5 mt-3 grid grid-cols-2 gap-3 border-t border-gray-950/5 px-5 pt-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex w-10 shrink-0 justify-center"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "truck",
    color: "gray",
    colorIntensity: 400,
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-500"
  }, pgettext('portal_i18n', 'Delivery')), /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, data.newShippingName), data.newDeliveryAddress && /*#__PURE__*/react.createElement("div", {
    className: "text-gray-500"
  }, data.newDeliveryAddress))), data.newPaymentName && /*#__PURE__*/react.createElement("div", {
    className: "flex items-start gap-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex w-10 shrink-0 justify-center"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "credit-card",
    color: "gray",
    colorIntensity: 400,
    fitted: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "min-w-0 text-sm"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-500"
  }, pgettext('portal_i18n', 'Payment')), /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-900"
  }, data.newPaymentName))))));
}
function Exchange(_ref6) {
  var _preview$shipping$nam, _preview$shipping, _preview$payment$name, _preview$payment;
  let {
    preview,
    note,
    onNoteChange,
    onNoteSave
  } = _ref6;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const [noteOpen, setNoteOpen] = (0,react.useState)(Boolean(note));
  const currency = preview.currency;
  const balance = exchangeBalance(preview);
  const surcharge = balance.kind === 'surcharge';
  const returnShippingName = formProgress.shipping_route ? (0,utils/* currentLanguage */.aS)(formProgress.shipping_route.name) : pgettext('portal_i18n', 'Not selected');
  let returnShippingDetail;
  if (formProgress.drop_off_branch) {
    returnShippingDetail = "".concat(formProgress.drop_off_branch.name, " \xB7 ").concat(formProgress.drop_off_branch.address.street, ", ").concat(formProgress.drop_off_branch.address.city);
  } else if (formProgress.shipping_route) {
    returnShippingDetail = (0,utils/* currentLanguage */.aS)(formProgress.shipping_route.description);
  }
  const returnAmount = formProgress.payment_intent ? (0,utils/* formatPrice */.$g)(formProgress.payment_intent.amount, formProgress.payment_intent.currency, true) : undefined;
  let settlementValue = pgettext('portal_i18n', 'No surcharge');
  let settlementTiming;
  if (balance.kind === 'surcharge') {
    settlementValue = (0,utils/* formatPrice */.$g)(balance.amount, currency);
    settlementTiming = pgettext('portal_i18n', 'surcharge');
  } else if (balance.kind === 'refund') {
    settlementValue = (0,utils/* formatPrice */.$g)(balance.amount, currency);
    settlementTiming = pgettext('portal_i18n', 'refund');
  }
  const storyData = {
    returnedItems: preview.returns.map((line, index) => ({
      key: "return-".concat(index),
      name: line.name,
      variant: line.variant,
      image: line.image_url,
      amount: Number(line.amount)
    })),
    purchasedItems: preview.purchases.map((line, index) => ({
      key: "".concat(line.code, "-").concat(index),
      name: line.name,
      variant: line.variant,
      image: line.image_url,
      amount: Number(line.amount)
    })),
    returnShippingName,
    returnShippingDetail,
    returnAmount,
    newShippingName: (_preview$shipping$nam = (_preview$shipping = preview.shipping) === null || _preview$shipping === void 0 ? void 0 : _preview$shipping.name) !== null && _preview$shipping$nam !== void 0 ? _preview$shipping$nam : pgettext('portal_i18n', 'Not selected'),
    newDeliveryAddress: formProgress.exchange_delivery_address ? [formProgress.exchange_delivery_address.street, formProgress.exchange_delivery_address.city, formProgress.exchange_delivery_address.zip].filter(Boolean).join(', ') : undefined,
    newPaymentName: surcharge ? (_preview$payment$name = (_preview$payment = preview.payment) === null || _preview$payment === void 0 ? void 0 : _preview$payment.name) !== null && _preview$payment$name !== void 0 ? _preview$payment$name : pgettext('portal_i18n', 'Not selected') : undefined,
    settlementValue,
    settlementTiming
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Exchange')), /*#__PURE__*/react.createElement(RouteDiagram, {
    data: storyData
  })), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, noteOpen ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("label", {
    className: "text-sm font-medium text-gray-900",
    htmlFor: "exchange-note"
  }, pgettext('portal_i18n', 'Note to the order')), /*#__PURE__*/react.createElement("textarea", {
    id: "exchange-note",
    name: "exchange-note",
    rows: 2,
    value: note,
    autoFocus: true,
    onChange: event => onNoteChange(event.target.value),
    onBlur: () => onNoteSave().catch(() => undefined),
    placeholder: pgettext('portal_i18n', 'Optional — the shop will see it with your exchange.'),
    className: "mt-1.5 block w-full rounded-md border-0 bg-white px-3 py-2 text-base text-gray-900 ring-1 ring-inset ring-gray-950/10 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--colors-primary)] sm:text-sm"
  })) : /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: () => setNoteOpen(true),
    className: "inline-flex min-h-11 items-center gap-1.5 text-sm font-medium text-[var(--colors-primary)] hover:text-[var(--colors-primary-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--colors-primary)]"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "plus",
    fitted: true,
    size: "tiny"
  }), pgettext('portal_i18n', 'Add a note to the order'))));
}
/* harmony default export */ const Summary_Exchange = (Exchange);
;// ./react/portal/summary/Summary/PaymentInfo.tsx





function getCarrierCompany(provider) {
  switch (provider) {
    case 'MY_PPL_PICKUP':
    case 'MY_PPL_CPL_DROPOFF':
    case 'MY_PPL_CPL_PICKUP':
      return 'PPL CZ s.r.o.';
    case 'PPL_RETURN_CONNECT_DROPOFF':
    case 'PPL_RETURN_CONNECT_PICKUP':
      return 'PPL CZ s.r.o. and DHL International GmbH.';
    case 'GLS_PICKUP':
    case 'GLS_ISRS':
    case 'MY_GLS_DROP_OFF_CZ':
    case 'MY_GLS_PICKUP_CZ':
      return 'General Logistics Systems Czech Republic s.r.o.';
    case 'MY_GLS_DROP_OFF_SK':
    case 'MY_GLS_PICKUP_SK':
      return 'GLS General Logistics Systems Slovakia s.r.o.';
    case 'MY_GLS_DROP_OFF_HU':
    case 'MY_GLS_PICKUP_HU':
      return 'GLS General Logistics Systems Hungary Csomag-Logisztikai Kft.';
    case 'LIFTAGO':
      return 'Liftago, a.s.';
    case 'DPD_GEO_API_DROPOFF':
    case 'DPD_GEO_API_PICKUP':
      return 'Direct Parcel Distribution CZ s.r.o.';
    default:
      return null;
  }
}
function shortPaymentDeadlineText(days) {
  const message = ngettext('Follow the payment instructions within %(count)s day or the request continues without an exchange.', 'Follow the payment instructions within %(count)s days or the request continues without an exchange.', days);
  return interpolate(message, {
    count: days
  }, true);
}
function paymentDeadlineText(days) {
  const message = ngettext('Complete the payment within %(count)s day after approval. Otherwise, the request continues without an exchange.', 'Complete the payment within %(count)s days after approval. Otherwise, the request continues without an exchange.', days);
  return interpolate(message, {
    count: days
  }, true);
}
function PaymentRow(_ref) {
  let {
    timing,
    label,
    amount
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-start justify-between gap-4 py-2"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-900"
  }, timing), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, label)), /*#__PURE__*/react.createElement("div", {
    className: "shrink-0 text-sm font-medium tabular-nums text-gray-900"
  }, amount));
}
function PaymentInfo(_ref2) {
  let {
    exchangePreview,
    detailsOnly = false
  } = _ref2;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const paymentIntent = formProgress.payment_intent;
  const shippingRoute = formProgress.shipping_route;
  const carrierCompany = shippingRoute ? getCarrierCompany(shippingRoute.provider_config.type) : null;
  if (!exchangePreview) {
    if (!(shippingRoute !== null && shippingRoute !== void 0 && shippingRoute.paid_by_customer) || !paymentIntent) {
      return null;
    }
    return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
      className: "flex items-start justify-between"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-base font-medium text-gray-900"
    }, pgettext('portal_i18n', 'Now you pay')), /*#__PURE__*/react.createElement("span", {
      className: "shrink-0 text-base font-medium text-gray-900"
    }, (0,utils/* formatPrice */.$g)(paymentIntent.amount, paymentIntent.currency, true))), /*#__PURE__*/react.createElement("div", {
      className: "mt-2 text-sm text-gray-500"
    }, pgettext('portal_i18n', "You'll pay the amount for the return shipping now by card. Shipping is provided by Retino.cz s.r.o. in cooperation with"), ' ', carrierCompany));
  }
  const balance = exchangeBalance(exchangePreview);
  const choicesComplete = Boolean(exchangePreview.shipping) && (balance.kind !== 'surcharge' || Boolean(exchangePreview.payment));
  if (!paymentIntent && (!choicesComplete || balance.kind === 'even')) {
    return null;
  }
  const nowAmount = paymentIntent ? (0,utils/* convertDecimal */.l7)(paymentIntent.amount, paymentIntent.currency) : 0;
  const sameCurrency = !paymentIntent || paymentIntent.currency.toUpperCase() === exchangePreview.currency.toUpperCase();
  const showTotal = Boolean(paymentIntent) && choicesComplete && balance.kind === 'surcharge' && sameCurrency;
  if (detailsOnly) {
    const showCarrier = (shippingRoute === null || shippingRoute === void 0 ? void 0 : shippingRoute.paid_by_customer) && carrierCompany;
    if (!choicesComplete || balance.kind !== 'surcharge' && !showCarrier) {
      return null;
    }
    return /*#__PURE__*/react.createElement("div", {
      className: "px-5 text-gray-500"
    }, balance.kind === 'surcharge' && /*#__PURE__*/react.createElement("p", {
      className: "text-sm"
    }, shortPaymentDeadlineText(exchangePreview.payment_due_days)), showCarrier && /*#__PURE__*/react.createElement("p", {
      className: "mt-2 text-xs"
    }, pgettext('portal_i18n', 'Return shipping is provided by Retino.cz s.r.o. in cooperation with'), ' ', carrierCompany));
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium text-gray-900"
  }, pgettext('portal_i18n', 'Payment')), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 divide-y divide-gray-950/5"
  }, paymentIntent && /*#__PURE__*/react.createElement(PaymentRow, {
    timing: pgettext('portal_i18n', 'Now'),
    label: pgettext('portal_i18n', 'Return shipping'),
    amount: (0,utils/* formatPrice */.$g)(paymentIntent.amount, paymentIntent.currency, true)
  }), choicesComplete && balance.kind === 'surcharge' && /*#__PURE__*/react.createElement(PaymentRow, {
    timing: pgettext('portal_i18n', 'After approval'),
    label: pgettext('portal_i18n', 'Surcharge · payment instructions by email'),
    amount: (0,utils/* formatPrice */.$g)(balance.amount, exchangePreview.currency)
  }), choicesComplete && balance.kind === 'refund' && /*#__PURE__*/react.createElement(PaymentRow, {
    timing: pgettext('portal_i18n', 'After approval'),
    label: pgettext('portal_i18n', 'Refund to you'),
    amount: "\u2212".concat((0,utils/* formatPrice */.$g)(balance.amount, exchangePreview.currency))
  }), choicesComplete && balance.kind === 'even' && paymentIntent && /*#__PURE__*/react.createElement(PaymentRow, {
    timing: pgettext('portal_i18n', 'After approval'),
    label: pgettext('portal_i18n', 'Nothing more to pay'),
    amount: (0,utils/* formatPrice */.$g)(0, exchangePreview.currency)
  })), showTotal && /*#__PURE__*/react.createElement("div", {
    className: "mt-1 flex items-center justify-between border-t border-gray-950/10 pt-3 text-sm font-medium text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, pgettext('portal_i18n', 'Exchange total')), /*#__PURE__*/react.createElement("span", {
    className: "tabular-nums"
  }, (0,utils/* formatPrice */.$g)(nowAmount + balance.amount, exchangePreview.currency))), choicesComplete && balance.kind === 'surcharge' && /*#__PURE__*/react.createElement("p", {
    className: "mt-3 text-sm text-gray-500"
  }, paymentDeadlineText(exchangePreview.payment_due_days)), (shippingRoute === null || shippingRoute === void 0 ? void 0 : shippingRoute.paid_by_customer) && carrierCompany && /*#__PURE__*/react.createElement("p", {
    className: "mt-2 text-xs text-gray-500"
  }, pgettext('portal_i18n', 'Return shipping is provided by Retino.cz s.r.o. in cooperation with'), ' ', carrierCompany));
}
/* harmony default export */ const Summary_PaymentInfo = (PaymentInfo);
;// ./react/portal/summary/Summary/PaymentRequestButton.tsx



function PaymentRequestButton(_ref) {
  var _formProgress$immutab2, _formProgress$new_bil2, _formProgress$new_shi2;
  let {
    clientSecret,
    onSuccess
  } = _ref;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const stripe = (0,react_stripe_umd.useStripe)();
  const [paymentRequest, setPaymentRequest] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    if (stripe) {
      var _formProgress$new_bil, _formProgress$new_shi, _formProgress$immutab;
      const pr = stripe.paymentRequest({
        country: ((_formProgress$new_bil = formProgress.new_billing_address) === null || _formProgress$new_bil === void 0 ? void 0 : _formProgress$new_bil.country) || ((_formProgress$new_shi = formProgress.new_shipping_address) === null || _formProgress$new_shi === void 0 ? void 0 : _formProgress$new_shi.country) || ((_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.billing_address_country) || 'CZ',
        currency: formProgress.payment_intent.currency,
        total: {
          label: pgettext('portal_i18n', 'Return shipping'),
          amount: Number(formProgress.payment_intent.amount)
        },
        requestPayerName: false,
        requestPayerEmail: false
      });

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then(result => {
        if (result) {
          setPaymentRequest(pr);
          pr.on('paymentmethod', async ev => {
            // Confirm the PaymentIntent without handling potential next actions (yet).
            const {
              paymentIntent,
              error: confirmError
            } = await stripe.confirmCardPayment(clientSecret, {
              payment_method: ev.paymentMethod.id
            }, {
              handleActions: false
            });
            if (confirmError) {
              // Report to the browser that the payment failed, prompting it to
              // re-show the payment interface, or show an error message and close
              // the payment interface.
              ev.complete('fail');
            } else {
              // Report to the browser that the confirmation was successful, prompting
              // it to close the browser payment method collection interface.
              ev.complete('success');
              // Check if the PaymentIntent requires any actions and if so let Stripe.js
              // handle the flow. If using an API version older than "2019-02-11"
              // instead check for: `paymentIntent.status === "requires_source_action"`.
              if (paymentIntent.status === 'requires_action') {
                // Let Stripe.js handle the rest of the payment flow.
                const {
                  error
                } = await stripe.confirmCardPayment(clientSecret);
                if (error) {
                  // The payment failed -- ask your customer for a new payment method.
                } else {
                  // The payment has succeeded.
                  onSuccess();
                }
              } else {
                // The payment has succeeded.
                onSuccess();
              }
            }
          });
        }
      });
    }
  }, [clientSecret, (_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.billing_address_country, (_formProgress$new_bil2 = formProgress.new_billing_address) === null || _formProgress$new_bil2 === void 0 ? void 0 : _formProgress$new_bil2.country, (_formProgress$new_shi2 = formProgress.new_shipping_address) === null || _formProgress$new_shi2 === void 0 ? void 0 : _formProgress$new_shi2.country, formProgress.payment_intent.amount, formProgress.payment_intent.currency, onSuccess, stripe]);
  if (paymentRequest) {
    return /*#__PURE__*/react.createElement(react_stripe_umd.PaymentRequestButtonElement, {
      options: {
        paymentRequest
      }
    });
  }
  return null;
}
/* harmony default export */ const Summary_PaymentRequestButton = (PaymentRequestButton);
;// ./react/portal/summary/Summary/Products.tsx




function Products_Products() {
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const products = formProgress.products.filter(product => !product.exchange_type);
  if (products.length === 0) {
    return null;
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "text-base font-medium text-gray-900"
  }, formProgress.has_complete_exchange ? pgettext('portal_i18n', 'Returned goods') : (0,utils/* currentLanguage */.aS)(formProgress.form.strings.ticket_type_name))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 flex flex-col gap-2"
  }, products.map(product => {
    var _formProgress$immutab, _formProgress$immutab2;
    const orderItem = (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.items.find(item => item.id === product.immutable_order_item);
    return /*#__PURE__*/react.createElement("div", {
      key: product.id,
      className: "flex items-center justify-between gap-4"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex min-w-0 items-center gap-3"
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white text-gray-400 ring-1 ring-gray-950/10"
    }, orderItem !== null && orderItem !== void 0 && orderItem.image_url ? /*#__PURE__*/react.createElement("img", {
      className: "size-full object-contain",
      src: orderItem.image_url,
      alt: orderItem.name
    }) : /*#__PURE__*/react.createElement("span", {
      className: "text-sm font-semibold"
    }, product.name.charAt(0))), /*#__PURE__*/react.createElement("div", {
      className: "line-clamp-2 text-sm font-medium text-gray-900"
    }, product.amount, "\xD7 ", product.name)), /*#__PURE__*/react.createElement("div", {
      className: "shrink-0 text-sm tabular-nums text-gray-700"
    }, ((_formProgress$immutab2 = formProgress.immutable_order) === null || _formProgress$immutab2 === void 0 ? void 0 : _formProgress$immutab2.currency) && orderItem && (0,utils/* formatPrice */.$g)(orderItem.unit_price_with_vat, formProgress.immutable_order.currency)));
  }))));
}
/* harmony default export */ const Summary_Products = (Products_Products);
;// ./react/portal/summary/Summary/Refunds.tsx






function Refunds(_ref) {
  let {
    exchangePreview
  } = _ref;
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const refundOption = formProgress.form.refund_options.find(option => option.id === formProgress.refund_option);
  const getFormattedReturnValue = () => {
    var _formProgress$immutab, _exchangePreview$refu;
    if (!((_formProgress$immutab = formProgress.immutable_order) !== null && _formProgress$immutab !== void 0 && _formProgress$immutab.currency)) {
      return '';
    }
    const plainReturnAmount = plainReturnedItemsRefundAmount(formProgress);
    const exchangeRefundAmount = Number((_exchangePreview$refu = exchangePreview === null || exchangePreview === void 0 ? void 0 : exchangePreview.refund_due) !== null && _exchangePreview$refu !== void 0 ? _exchangePreview$refu : 0);
    return (0,utils/* formatPrice */.$g)(plainReturnAmount + exchangeRefundAmount, formProgress.immutable_order.currency);
  };
  if (!formProgress.states.includes(codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.REFUNDS)) {
    return null;
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start justify-between gap-2"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-base font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(refundOption === null || refundOption === void 0 ? void 0 : refundOption.name)), /*#__PURE__*/react.createElement("div", {
    className: "shrink-0"
  }, /*#__PURE__*/react.createElement("span", {
    className: "text-base font-medium tabular-nums text-gray-900"
  }, getFormattedReturnValue()))), /*#__PURE__*/react.createElement("div", {
    className: "mt-2 text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(refundOption === null || refundOption === void 0 ? void 0 : refundOption.description)));
}
/* harmony default export */ const Summary_Refunds = (Refunds);
;// ./react/portal/summary/Summary/ExchangeSummary.tsx





















function ExchangeSummary() {
  var _formProgress$exchang, _formProgress$exchang2;
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    setFormProgress,
    updateFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const ticketCreateInFlight = (0,react.useRef)(false);
  const exchangeNoteSaveQueue = (0,react.useRef)(Promise.resolve());
  const savedExchangeNote = (0,react.useRef)((_formProgress$exchang = formProgress.exchange_note) !== null && _formProgress$exchang !== void 0 ? _formProgress$exchang : '');
  const [ticketCreateError, setTicketCreateError] = (0,react.useState)(null);
  const [exchangeNote, setExchangeNote] = (0,react.useState)((_formProgress$exchang2 = formProgress.exchange_note) !== null && _formProgress$exchang2 !== void 0 ? _formProgress$exchang2 : '');
  const {
    preview,
    failed: previewFailed
  } = exchange_useExchangePreview();
  const consent = Boolean(formProgress.exchange_consent_at);
  const [handleConsentToggle] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    await updateFormProgress({
      exchange_consent: !consent
    });
  });
  const saveExchangeNote = (0,react.useCallback)(() => {
    const normalizedNote = exchangeNote.trim();
    exchangeNoteSaveQueue.current = exchangeNoteSaveQueue.current.catch(() => undefined).then(async () => {
      if (normalizedNote !== savedExchangeNote.current) {
        await updateFormProgress({
          exchange_note: normalizedNote
        });
        savedExchangeNote.current = normalizedNote;
      }
    });
    return exchangeNoteSaveQueue.current;
  }, [exchangeNote, updateFormProgress]);
  const checkWeight = (0,react.useCallback)(() => {
    if (formProgress.shipping_route && formProgress.immutable_order && (formProgress.shipping_route.min_weight || formProgress.shipping_route.max_weight)) {
      let totalWeight = 0;
      formProgress.products.forEach(product => {
        var _formProgress$immutab;
        const orderItem = (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.items.find(item => item.id === product.immutable_order_item);
        if (orderItem) {
          var _orderItem$weight;
          totalWeight += Number((_orderItem$weight = orderItem.weight) !== null && _orderItem$weight !== void 0 ? _orderItem$weight : 0) * product.amount;
        }
      });
      if (formProgress.shipping_route.min_weight && totalWeight < formProgress.shipping_route.min_weight) {
        return false;
      }
      if (formProgress.shipping_route.max_weight && totalWeight > formProgress.shipping_route.max_weight) {
        return false;
      }
    }
    return true;
  }, [formProgress]);
  const [handleTicketCreate, isCreatingTicket] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (ticketCreateInFlight.current) {
      return;
    }
    ticketCreateInFlight.current = true;
    setTicketCreateError(null);
    try {
      await saveExchangeNote();
      setFormProgress(await publicApi.PortalFormProgressCreateTicketApi.create({
        id: formProgress.id
      }));
      PostMessageApi.ticketCreated(); // for SkipPay
      setTimeout(navigateNext); // wait for setFormProgress to finish
    } catch (error) {
      const response = await getErrors(error).catch(() => null);
      if ((response === null || response === void 0 ? void 0 : response.code) === 'exchange_unavailable') {
        setTicketCreateError(pgettext('portal_i18n', 'Some of the selected items have just sold out in the e-shop. Please go back and change your selection.'));
      } else if ((response === null || response === void 0 ? void 0 : response.code) === 'exchange_check_unavailable') {
        setTicketCreateError(pgettext('portal_i18n', 'The e-shop is temporarily unavailable. Please try submitting the exchange again.'));
      } else {
        var _response$detail;
        setTicketCreateError((_response$detail = response === null || response === void 0 ? void 0 : response.detail) !== null && _response$detail !== void 0 ? _response$detail : pgettext('portal_i18n', 'We could not submit the request. Please review your choices.'));
      }
    } finally {
      ticketCreateInFlight.current = false;
    }
  });
  const termsButtonCallback = (0,react.useCallback)(() => /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    key: "terms-and-conditions",
    onClick: () => window.open('https://www.retino.com/cs/obchodni-podminky-zpetne-dopravy-pro-koncove-zakazniky/', '_blank', 'noreferrer'),
    link: true
  }, pgettext('Nominative, name of the document', 'terms and conditions')), []);
  const hasUnfinishedPaymentIntent = formProgress.payment_intent && formProgress.payment_intent.status !== 'succeeded';
  const weightOutOfLimits = !checkWeight();
  const hasPlainReturn = formProgress.products.some(product => !product.exchange_type);
  const submitLabel = hasPlainReturn ? pgettext('portal_i18n', 'Submit request') : pgettext('portal_i18n', 'Confirm exchange request');
  let exchangeBlockedReason = null;
  if (previewFailed) {
    exchangeBlockedReason = pgettext('portal_i18n', 'Some of the selected items are no longer available. Please review your choices.');
  } else if (preview) {
    if (!preview.shipping) {
      exchangeBlockedReason = pgettext('portal_i18n', 'Choose the delivery of the new goods above to continue.');
    } else if (Number(preview.surcharge) > 0 && !preview.payment) {
      exchangeBlockedReason = pgettext('portal_i18n', 'Choose the surcharge payment method above to continue.');
    } else if (!consent) {
      exchangeBlockedReason = pgettext('portal_i18n', 'Confirm the agreement to continue.');
    }
  }
  const exchangeReady = Boolean(preview) && !exchangeBlockedReason;
  let payButtonLabel = pgettext('portal_i18n', 'Pay by card');
  if (formProgress.payment_intent) {
    payButtonLabel = interpolate(pgettext('portal_i18n', 'Continue to payment · %(amount)s now'), {
      amount: (0,utils/* formatPrice */.$g)(formProgress.payment_intent.amount, formProgress.payment_intent.currency, true)
    }, true);
  }
  const [handleOpenPayment, isOpeningPayment] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    await saveExchangeNote();
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdPayment({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  });
  const [handleChangeInformation] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    await saveExchangeNote();
    navigate(portalRoutes/* default */.A.formProgressFormProgressIdBackwardsNavigation({
      companyId,
      formProgressId: formProgress.id,
      lang
    }));
  });
  const canSubmit = !weightOutOfLimits && exchangeReady && !isCreatingTicket && !isOpeningPayment;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Summary')
    }),
    footer: /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-4"
    }, preview && /*#__PURE__*/react.createElement("label", {
      className: "flex cursor-pointer items-start gap-3 text-sm leading-5 text-gray-600"
    }, /*#__PURE__*/react.createElement(react_ui/* Checkbox */.Sc, {
      value: consent,
      onChange: handleConsentToggle
    }), /*#__PURE__*/react.createElement("span", null, exchangeBalance(preview).kind === 'refund' ? interpolate(pgettext('portal_i18n', 'I agree that the value of the returned goods will be used to pay for the new order. The difference of %(amount)s will be refunded to me.'), {
      amount: (0,utils/* formatPrice */.$g)(exchangeBalance(preview).amount, preview.currency)
    }, true) : pgettext('portal_i18n', 'I agree that the value of the returned goods will be used to pay for the new order.'))), /*#__PURE__*/react.createElement("div", null, weightOutOfLimits && /*#__PURE__*/react.createElement("p", {
      className: "mb-1 text-center text-sm text-red-600"
    }, pgettext('portal_i18n', 'The weight of the goods does not meet the limits of the selected shipping. Please choose another shipping method.')), hasUnfinishedPaymentIntent && /*#__PURE__*/react.createElement("div", {
      className: "mb-1 text-center text-sm leading-5 text-gray-500"
    }, /*#__PURE__*/react.createElement("span", null, react_string_replace_default()(pgettext('portal_i18n', 'You accept our %(terms_and_conditions)s by clicking on the button below.'), '%(terms_and_conditions)s', termsButtonCallback))), ticketCreateError && /*#__PURE__*/react.createElement("p", {
      className: "mb-2 text-center text-sm text-red-600"
    }, ticketCreateError), hasUnfinishedPaymentIntent ? /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-4"
    }, formProgress.payment_intent && canSubmit && /*#__PURE__*/react.createElement(Summary_PaymentRequestButton, {
      clientSecret: formProgress.payment_intent.client_secret,
      onSuccess: handleTicketCreate
    }), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleOpenPayment,
      loading: isOpeningPayment,
      disabled: !canSubmit
    }, payButtonLabel)) : /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleTicketCreate,
      loading: isCreatingTicket,
      disabled: !canSubmit
    }, submitLabel), exchangeBlockedReason && /*#__PURE__*/react.createElement("p", {
      className: "mt-2 text-center text-sm text-amber-700"
    }, exchangeBlockedReason)))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, previewFailed && /*#__PURE__*/react.createElement("div", {
    className: "mx-5 rounded-md bg-amber-50 px-4 py-3 text-sm text-amber-800"
  }, pgettext('portal_i18n', 'Some of the selected items are no longer available. Please review your choices.')), !previewFailed && !preview && /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null), preview && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Summary_Exchange, {
    preview: preview,
    note: exchangeNote,
    onNoteChange: setExchangeNote,
    onNoteSave: saveExchangeNote
  }), /*#__PURE__*/react.createElement(Summary_Products, null), /*#__PURE__*/react.createElement(Summary_Refunds, {
    exchangePreview: preview
  }), /*#__PURE__*/react.createElement(Summary_CustomerInfo, null), /*#__PURE__*/react.createElement(Summary_PaymentInfo, {
    exchangePreview: preview,
    detailsOnly: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    onClick: handleChangeInformation,
    link: true,
    size: "small",
    icon: "pencil-alt",
    iconSize: "tiny"
  }, pgettext('portal_i18n', 'Change information')))));
}
/* harmony default export */ const Summary_ExchangeSummary = (ExchangeSummary);
;// ./react/portal/summary/Summary/Shipping.tsx








function IconText(_ref) {
  let {
    iconName,
    text
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: iconName,
    fitted: true,
    color: "gray",
    colorIntensity: 300,
    solid: true
  })), /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-500"
  }, text));
}
function Shipping_Shipping() {
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  if (!formProgress.shipping_route) {
    return null;
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium text-gray-900"
  }, (0,utils/* currentLanguage */.aS)(formProgress.shipping_route.name)), /*#__PURE__*/react.createElement("div", {
    className: "flex h-10 w-20 flex-shrink-0 items-center justify-center"
  }, ['PICKUP', 'DROP_OFF', 'FREIGHT'].includes(formProgress.shipping_route.provider_config.submit_type) && /*#__PURE__*/react.createElement("img", {
    src: formProgress.shipping_route.provider_config.logo_url,
    alt: (0,utils/* currentLanguage */.aS)(formProgress.shipping_route.name)
  }))), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(formProgress.shipping_route.description))), formProgress.shipping_route.provider_config.submit_type === 'DROP_OFF' && /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, formProgress.drop_off_branch && /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium"
  }, formProgress.drop_off_branch.name), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, formProgress.drop_off_branch.address.street, ", ", formProgress.drop_off_branch.address.city), /*#__PURE__*/react.createElement("table", {
    className: "mt-2 border-separate border-spacing-y-1 text-sm"
  }, /*#__PURE__*/react.createElement("tbody", null, (0,shipping_utils/* condensateOpenHours */.QJ)(formProgress.drop_off_branch).map(item => {
    const closedClass = item.openHours === gettext('closed') ? 'text-red-600' : '';
    return /*#__PURE__*/react.createElement("tr", {
      key: item.day
    }, /*#__PURE__*/react.createElement("td", {
      className: "whitespace-nowrap p-0 align-baseline font-medium"
    }, item.day), /*#__PURE__*/react.createElement("td", {
      className: "p-0 pl-3 text-gray-500 ".concat(closedClass)
    }, item.openHours));
  }))))), formProgress.shipping_route.provider_config.submit_type === 'IN_PERSON' && formProgress.customer_parcel_shop && /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(components_BranchInfo, {
    branch: formProgress.customer_parcel_shop,
    photoSize: "xl",
    showOpeningHours: true,
    showContacts: true,
    showMapLink: true,
    stackOnMobile: true
  })), formProgress.shipping_route.provider_config.submit_type === 'PICKUP' && /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/react.createElement(IconText, {
    iconName: "question-mark-circle",
    text: pgettext('portal_i18n', 'A courier picks up the package')
  }), /*#__PURE__*/react.createElement(IconText, {
    iconName: "calendar",
    text: getFormattedPickupTime(formProgress)
  }), /*#__PURE__*/react.createElement(IconText, {
    iconName: "location-marker",
    text: /*#__PURE__*/react.createElement(react.Fragment, null, pgettext('portal_i18n', 'From the address'), " ", getFormattedShippingAddress(formProgress))
  }))));
}
/* harmony default export */ const Summary_Shipping = (Shipping_Shipping);
;// ./react/portal/summary/Summary/index.tsx




















function RegularSummary() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    formProgress,
    setFormProgress,
    navigateNext
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const publicApi = (0,public_api/* default */.Ay)();
  const ticketCreateInFlight = (0,react.useRef)(false);
  const [ticketCreateError, setTicketCreateError] = (0,react.useState)(null);
  const checkWeight = (0,react.useCallback)(() => {
    if (formProgress.shipping_route && formProgress.immutable_order && (formProgress.shipping_route.min_weight || formProgress.shipping_route.max_weight)) {
      let totalWeight = 0;
      formProgress.products.forEach(product => {
        var _formProgress$immutab;
        const orderItem = (_formProgress$immutab = formProgress.immutable_order) === null || _formProgress$immutab === void 0 ? void 0 : _formProgress$immutab.items.find(item => item.id === product.immutable_order_item);
        if (orderItem) {
          var _orderItem$weight;
          totalWeight += Number((_orderItem$weight = orderItem.weight) !== null && _orderItem$weight !== void 0 ? _orderItem$weight : 0) * product.amount;
        }
      });
      if (formProgress.shipping_route.min_weight && totalWeight < formProgress.shipping_route.min_weight) {
        return false;
      }
      if (formProgress.shipping_route.max_weight && totalWeight > formProgress.shipping_route.max_weight) {
        return false;
      }
    }
    return true;
  }, [formProgress]);
  const [handleTicketCreate, isCreatingTicket] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (ticketCreateInFlight.current) {
      return;
    }
    ticketCreateInFlight.current = true;
    setTicketCreateError(null);
    try {
      setFormProgress(await publicApi.PortalFormProgressCreateTicketApi.create({
        id: formProgress.id
      }));
      PostMessageApi.ticketCreated(); // for SkipPay
      setTimeout(navigateNext); // wait for setFormProgress to finish
    } catch (error) {
      var _response$detail;
      const response = await getErrors(error).catch(() => null);
      setTicketCreateError((_response$detail = response === null || response === void 0 ? void 0 : response.detail) !== null && _response$detail !== void 0 ? _response$detail : pgettext('portal_i18n', 'We could not submit the request. Please review your choices.'));
    } finally {
      ticketCreateInFlight.current = false;
    }
  });
  const termsButtonCallback = (0,react.useCallback)(() => /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    key: "terms-and-conditions",
    onClick: () => window.open('https://www.retino.com/cs/obchodni-podminky-zpetne-dopravy-pro-koncove-zakazniky/', '_blank', 'noreferrer'),
    link: true
  }, pgettext('Nominative, name of the document', 'terms and conditions')), []);
  const hasUnfinishedPaymentIntent = formProgress.payment_intent && formProgress.payment_intent.status !== 'succeeded';
  const weightOutOfLimits = !checkWeight();
  let submitLabel = pgettext('portal_i18n', 'Create a ticket');
  if (formProgress.form.ticket_type_slug === 'TYPE_RETURN') {
    submitLabel = pgettext('portal_i18n', 'Confirm withdrawal from contract');
  }
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement(ui/* default */.A.ProgressHeader, {
      currentName: pgettext('portal_i18n', 'Summary')
    }),
    footer: /*#__PURE__*/react.createElement("div", null, weightOutOfLimits && /*#__PURE__*/react.createElement("p", {
      className: "mb-1 text-center text-sm text-red-500"
    }, pgettext('portal_i18n', 'The weight of the goods does not meet the limits of the selected shipping. Please choose another shipping method.')), hasUnfinishedPaymentIntent && /*#__PURE__*/react.createElement("div", {
      className: "mb-1 text-center leading-none"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-xs text-gray-500"
    }, react_string_replace_default()(pgettext('portal_i18n', 'You accept our %(terms_and_conditions)s by clicking on the button below.'), '%(terms_and_conditions)s', termsButtonCallback))), ticketCreateError && /*#__PURE__*/react.createElement("p", {
      className: "mb-2 text-center text-sm text-red-600"
    }, ticketCreateError), hasUnfinishedPaymentIntent ? /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col gap-4"
    }, formProgress.payment_intent && !weightOutOfLimits && /*#__PURE__*/react.createElement(Summary_PaymentRequestButton, {
      clientSecret: formProgress.payment_intent.client_secret,
      onSuccess: handleTicketCreate
    }), /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
      to: portalRoutes/* default */.A.formProgressFormProgressIdPayment({
        companyId,
        formProgressId: formProgress.id,
        lang
      })
    }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      disabled: weightOutOfLimits
    }, pgettext('portal_i18n', 'Pay by card')))) : /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
      primary: true,
      onClick: handleTicketCreate,
      loading: isCreatingTicket,
      disabled: weightOutOfLimits || isCreatingTicket
    }, submitLabel))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement(Summary_CustomerInfo, null), /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, /*#__PURE__*/react.createElement(Summary_Products, null), /*#__PURE__*/react.createElement(Summary_Refunds, null)), /*#__PURE__*/react.createElement(Summary_Shipping, null), /*#__PURE__*/react.createElement(Summary_PaymentInfo, null), /*#__PURE__*/react.createElement("div", {
    className: "px-5 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("span", null, react_string_replace_default()(pgettext('portal_i18n', 'Check that all information is correct. If something is wrong, change any information by clicking %(this_link)s.'), '%(this_link)s', () => /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    key: "change-info",
    onClick: () => navigate(portalRoutes/* default */.A.formProgressFormProgressIdBackwardsNavigation({
      companyId,
      formProgressId: formProgress.id,
      lang
    })),
    link: true
  }, pgettext('portal_i18n', 'this link')))), /*#__PURE__*/react.createElement("div", {
    className: "my-3"
  }))));
}
function Summary() {
  const {
    formProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  if (formProgress.state !== codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.SUMMARY) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  if (formProgress.has_exchange_intent) {
    return /*#__PURE__*/react.createElement(Summary_ExchangeSummary, null);
  }
  return /*#__PURE__*/react.createElement(RegularSummary, null);
}
/* harmony default export */ const summary_Summary = (Summary);
;// ./react/portal/Survey/DirectShipping.tsx




function DirectShipping(_ref) {
  let {
    directShippingAppreciation,
    setDirectShippingAppreciation,
    negativeShippingText,
    setNegativeShippingText,
    positiveShippingText,
    setPositiveShippingText,
    error
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mb-3 text-sm font-medium text-gray-700"
  }, pgettext('portal_i18n', 'Do you appreciate the possibility to order a shipping directly from the interactive form?')), /*#__PURE__*/react.createElement("div", {
    className: "flex justify-evenly gap-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    negative: directShippingAppreciation === codegen/* BackendPublicEnums */.C.YesNoEnum.NO,
    onClick: () => setDirectShippingAppreciation(codegen/* BackendPublicEnums */.C.YesNoEnum.NO)
  }, pgettext('portal_i18n', 'No')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: directShippingAppreciation === codegen/* BackendPublicEnums */.C.YesNoEnum.YES,
    onClick: () => setDirectShippingAppreciation(codegen/* BackendPublicEnums */.C.YesNoEnum.YES)
  }, pgettext('portal_i18n', 'Yes'))), error && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 font-medium text-red-600"
  }, error))), directShippingAppreciation && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, directShippingAppreciation === codegen/* BackendPublicEnums */.C.YesNoEnum.YES && /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: positiveShippingText,
    onChange: setPositiveShippingText,
    label: pgettext('portal_i18n', 'What do you appreciate the most when ordering a shipping directly? Were there any problems?')
  }), directShippingAppreciation === codegen/* BackendPublicEnums */.C.YesNoEnum.NO && /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: negativeShippingText,
    onChange: setNegativeShippingText,
    label: pgettext('portal_i18n', 'Regarding the shipping types, what are you not satisfied with? How can we make your experience better?')
  }))));
}
/* harmony default export */ const Survey_DirectShipping = (DirectShipping);
;// ./react/portal/Survey/Footer.tsx


function Footer(_ref) {
  let {
    onSubmit,
    isSubmitting
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "text-center text-xs leading-none text-gray-500"
  }, /*#__PURE__*/react.createElement("div", null, pgettext('portal_i18n', 'This feedback will NOT affect your claim in any way. It is not intended for the store, but for the provider of this self-checkout form.')), /*#__PURE__*/react.createElement("div", {
    className: "mb-1"
  }, pgettext('portal_i18n', 'Provided by'), ' ', /*#__PURE__*/react.createElement("a", {
    href: "https://retino.com",
    target: "_blank",
    rel: "noreferrer",
    className: "font-medium text-indigo-600 hover:text-indigo-800"
  }, "Retino")), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: true,
    onClick: onSubmit,
    loading: isSubmitting
  }, pgettext('portal_i18n', 'Submit')));
}
/* harmony default export */ const Survey_Footer = (Footer);
;// ./react/portal/Survey/InteractiveFormImportance.tsx



function InteractiveFormImportance(_ref) {
  let {
    interactiveFormImportance,
    setInteractiveFormImportance,
    error
  } = _ref;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mb-3 text-sm font-medium text-gray-700"
  }, pgettext('portal_i18n', 'Would you consider an interactive self-checkout form like this one when deciding where to place your next online order?')), /*#__PURE__*/react.createElement("div", {
    className: "flex justify-evenly gap-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    negative: interactiveFormImportance === codegen/* BackendPublicEnums */.C.YesNoEnum.NO,
    onClick: () => setInteractiveFormImportance(codegen/* BackendPublicEnums */.C.YesNoEnum.NO)
  }, pgettext('portal_i18n', 'No')), /*#__PURE__*/react.createElement(ui/* default */.A.Button, {
    primary: interactiveFormImportance === codegen/* BackendPublicEnums */.C.YesNoEnum.YES,
    onClick: () => setInteractiveFormImportance(codegen/* BackendPublicEnums */.C.YesNoEnum.YES)
  }, pgettext('portal_i18n', 'Yes'))), error && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 font-medium text-red-600"
  }, error)));
}
/* harmony default export */ const Survey_InteractiveFormImportance = (InteractiveFormImportance);
;// ./react/portal/Survey/NoShippingReason.tsx




function NoShippingReason(_ref) {
  let {
    noShippingReason,
    setNoShippingReason,
    noShippingReasonText,
    setNoShippingReasonText,
    error
  } = _ref;
  return /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mb-3 text-sm font-medium text-gray-700"
  }, pgettext('portal_i18n', 'What is the reason you did not choose any shipping?')), /*#__PURE__*/react.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form.Radio, {
    id: "no_shipping_reason_delivery_in_person",
    label: pgettext('portal_i18n', 'I will deliver the goods to the store in person'),
    name: "no_shipping_reason",
    value: noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.DELIVERY_IN_PERSON,
    onChange: () => setNoShippingReason(codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.DELIVERY_IN_PERSON),
    error: error
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Radio, {
    id: "no_shipping_reason_high_prices",
    label: pgettext('portal_i18n', 'The prices are too high'),
    name: "no_shipping_reason",
    value: noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.HIGH_PRICES,
    onChange: () => setNoShippingReason(codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.HIGH_PRICES),
    error: error
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Radio, {
    id: "no_shipping_reason_missing_shipping_type",
    label: pgettext('portal_i18n', 'My preferred shipping type was missing in the choices'),
    name: "no_shipping_reason",
    value: noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.MISSING_SHIPPING_TYPE,
    onChange: () => setNoShippingReason(codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.MISSING_SHIPPING_TYPE),
    error: error
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Radio, {
    id: "no_shipping_reason_bad_experience",
    label: pgettext('portal_i18n', "I've had a bad experience with the shipping ordered through Retino interactive form"),
    name: "no_shipping_reason",
    value: noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.BAD_EXPERIENCE,
    onChange: () => setNoShippingReason(codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.BAD_EXPERIENCE),
    error: error
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Form.Radio, {
    id: "no_shipping_reason_other",
    label: pgettext('portal_i18n', 'Other...'),
    name: "no_shipping_reason",
    value: noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.OTHER,
    onChange: () => setNoShippingReason(codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.OTHER),
    error: error
  })), error && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 font-medium text-red-600"
  }, error), (noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.OTHER || noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.MISSING_SHIPPING_TYPE) && /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: noShippingReasonText,
    onChange: setNoShippingReasonText,
    label: /*#__PURE__*/react.createElement("span", null, noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.MISSING_SHIPPING_TYPE && pgettext('portal_i18n', 'What shipping type was missing?'), noShippingReason === codegen/* BackendPublicEnums */.C.NoShippingReasonEnum.OTHER && pgettext('portal_i18n', 'Would you like to add some details regarding the reason?'))
  }))));
}
/* harmony default export */ const Survey_NoShippingReason = (NoShippingReason);
;// ./react/portal/Survey/Scale.tsx


function Scale(_ref) {
  let {
    rating,
    setRating
  } = _ref;
  const [hoveredRating, setHoveredRating] = (0,react.useState)();
  return /*#__PURE__*/react.createElement("div", {
    className: "flex justify-evenly text-red-500"
  }, [1, 2, 3, 4, 5].map(value => /*#__PURE__*/react.createElement("label", {
    key: value,
    className: "relative cursor-pointer rounded-md has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-[var(--colors-primary)]",
    onMouseEnter: () => setHoveredRating(value),
    onMouseLeave: () => setHoveredRating(null)
  }, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    name: "overall_satisfaction",
    checked: rating === value,
    onChange: () => setRating(value),
    className: "sr-only"
  }), /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, value), /*#__PURE__*/react.createElement(react_ui/* Icon */.In, {
    name: "heart",
    className: "h-10 w-10",
    solid: (rating !== null && rating !== void 0 ? rating : 0) >= value || (hoveredRating !== null && hoveredRating !== void 0 ? hoveredRating : 0) >= value
  }))));
}
/* harmony default export */ const Survey_Scale = (Scale);
;// ./react/portal/Survey/OverallSatisfaction.tsx




function OverallSatisfaction(_ref) {
  let {
    rating,
    setRating,
    negativeOverallText,
    setNegativeOverallText,
    positiveOverallText,
    setPositiveOverallText,
    error
  } = _ref;
  const questionId = (0,react.useId)();
  return /*#__PURE__*/react.createElement("div", {
    className: "-space-y-px"
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5",
    role: "radiogroup",
    "aria-labelledby": questionId
  }, /*#__PURE__*/react.createElement("div", {
    id: questionId,
    className: "mb-3 text-sm font-medium text-gray-700"
  }, pgettext('portal_i18n', 'How are you satisfied with the self-checkout process provided to you by Retino in comparison to filling in the PDF file and attaching it to the package?')), /*#__PURE__*/react.createElement(Survey_Scale, {
    rating: rating,
    setRating: setRating
  }), error && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 font-medium text-red-600"
  }, error))), rating && /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, rating && rating > 3 && /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: positiveOverallText,
    onChange: setPositiveOverallText,
    label: pgettext('portal_i18n', 'Which features do you value the most?')
  }), rating && rating <= 3 && /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: negativeOverallText,
    onChange: setNegativeOverallText,
    label: pgettext('portal_i18n', 'What was missing or disappointing in your experience with us? How can we improve your experience?')
  }))));
}
/* harmony default export */ const Survey_OverallSatisfaction = (OverallSatisfaction);
;// ./react/portal/Survey/index.tsx
function Survey_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Survey_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Survey_ownKeys(Object(t), !0).forEach(function (r) { Survey_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Survey_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Survey_defineProperty(obj, key, value) { key = Survey_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function Survey_toPropertyKey(t) { var i = Survey_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function Survey_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















function Survey() {
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    formProgress,
    updateFormProgress
  } = (0,FormProgressContext/* useFormProgress */.NG)();
  const {
    companyId,
    liked,
    lang
  } = (0,dist/* useParams */.g)();
  const [rating, setRating] = (0,react.useState)();
  const [negativeOverallText, setNegativeOverallText] = (0,react.useState)('');
  const [positiveOverallText, setPositiveOverallText] = (0,react.useState)('');
  const [directShippingAppreciation, setDirectShippingAppreciation] = (0,react.useState)();
  const [negativeShippingText, setNegativeShippingText] = (0,react.useState)('');
  const [positiveShippingText, setPositiveShippingText] = (0,react.useState)('');
  const [noShippingReason, setNoShippingReason] = (0,react.useState)();
  const [noShippingReasonText, setNoShippingReasonText] = (0,react.useState)('');
  const [interactiveFormImportance, setInteractiveFormImportance] = (0,react.useState)();
  const [additionalText, setAdditionalText] = (0,react.useState)('');
  const [errors, setErrors] = (0,react.useState)({});
  const [submitRef, submit] = useSubmitRef();
  const displayShippingSection = formProgress.states.includes('SHIPPING');
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (!rating) {
      setErrors(old => Survey_objectSpread(Survey_objectSpread({}, old), {}, {
        overall_satisfaction: pgettext('portal_i18n', 'Please fill in the rating')
      }));
    }
    if (displayShippingSection && !directShippingAppreciation) {
      setErrors(old => Survey_objectSpread(Survey_objectSpread({}, old), {}, {
        direct_shipping_appreciation: pgettext('portal_i18n', 'Please select an option')
      }));
    }
    if (!interactiveFormImportance) {
      setErrors(old => Survey_objectSpread(Survey_objectSpread({}, old), {}, {
        interactive_form_importance: pgettext('portal_i18n', 'Please select an option')
      }));
    }
    if (!noShippingReason && !formProgress.shipping_route && displayShippingSection) {
      setErrors(old => Survey_objectSpread(Survey_objectSpread({}, old), {}, {
        no_shipping_reason: pgettext('portal_i18n', 'Please select an option')
      }));
      return;
    }
    if (!rating || displayShippingSection && !directShippingAppreciation || !interactiveFormImportance) {
      return;
    }
    try {
      await publicApi.PortalNpsSurveyApi.create({
        request: {
          form_progress: formProgress.id,
          overall_satisfaction: rating,
          overall_satisfaction_pos_detail: positiveOverallText.length > 0 ? positiveOverallText : undefined,
          overall_satisfaction_neg_detail: negativeOverallText.length > 0 ? negativeOverallText : undefined,
          direct_shipping_appreciation: directShippingAppreciation,
          direct_shipping_appreciation_pos_detail: positiveShippingText.length > 0 ? positiveShippingText : undefined,
          direct_shipping_appreciation_neg_detail: negativeShippingText.length > 0 ? negativeShippingText : undefined,
          no_shipping_reason: noShippingReason,
          no_shipping_reason_detail: noShippingReasonText.length > 0 ? noShippingReasonText : undefined,
          interactive_form_importance: interactiveFormImportance,
          additional_opinion: additionalText.length > 0 ? additionalText : undefined,
          liked_retino: liked === '1'
        }
      });
      await updateFormProgress({});
      setErrors({});
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdResult({
        formProgressId: formProgress.id,
        companyId,
        lang
      }));
    } catch (errorResponse) {
      if (isResponse(errorResponse) && errorResponse.response.status === 400) {
        setErrors(await getErrors(errorResponse));
      }
    }
  });
  (0,react.useEffect)(() => {
    if (formProgress.survey_completed) {
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdResult({
        formProgressId: formProgress.id,
        companyId,
        lang
      }));
    }
  }, []);
  return /*#__PURE__*/react.createElement(ui/* default */.A.Page, {
    header: /*#__PURE__*/react.createElement("div", {
      className: "w-full border-b border-gray-200 bg-white px-5 py-3 shadow-md sm:py-6"
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-lg font-medium leading-6 text-gray-900"
    }, pgettext('portal_i18n', 'Rate your Retino experience'))),
    footer: /*#__PURE__*/react.createElement(Survey_Footer, {
      onSubmit: submit,
      isSubmitting: isSubmitting
    })
  }, /*#__PURE__*/react.createElement(ui/* default */.A.Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement("input", {
    hidden: true,
    type: "submit",
    ref: submitRef
  }), /*#__PURE__*/react.createElement("div", {
    className: "space-y-5"
  }, /*#__PURE__*/react.createElement(Survey_OverallSatisfaction, {
    rating: rating,
    setRating: setRating,
    positiveOverallText: positiveOverallText,
    setPositiveOverallText: setPositiveOverallText,
    negativeOverallText: negativeOverallText,
    setNegativeOverallText: setNegativeOverallText,
    error: errors.overall_satisfaction
  }), displayShippingSection && /*#__PURE__*/react.createElement(Survey_DirectShipping, {
    directShippingAppreciation: directShippingAppreciation,
    setDirectShippingAppreciation: setDirectShippingAppreciation,
    negativeShippingText: negativeShippingText,
    setNegativeShippingText: setNegativeShippingText,
    positiveShippingText: positiveShippingText,
    setPositiveShippingText: setPositiveShippingText,
    error: errors.direct_shipping_appreciation
  }), !formProgress.shipping_route && displayShippingSection && /*#__PURE__*/react.createElement(Survey_NoShippingReason, {
    noShippingReason: noShippingReason,
    setNoShippingReason: setNoShippingReason,
    noShippingReasonText: noShippingReasonText,
    setNoShippingReasonText: setNoShippingReasonText,
    error: errors.no_shipping_reason
  }), /*#__PURE__*/react.createElement(Survey_InteractiveFormImportance, {
    interactiveFormImportance: interactiveFormImportance,
    setInteractiveFormImportance: setInteractiveFormImportance,
    error: errors.interactive_form_importance
  }), /*#__PURE__*/react.createElement(ui/* default */.A.Card, null, /*#__PURE__*/react.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(react_ui/* Form */.lV.Textarea, {
    value: additionalText,
    onChange: setAdditionalText,
    label: pgettext('portal_i18n', 'Anything other you would like to tell us?')
  })))))));
}
/* harmony default export */ const portal_Survey = (Survey);
// EXTERNAL MODULE: ./react/portal/ticket-types/FormCardUI.tsx
var FormCardUI = __webpack_require__(49469);
;// ./react/portal/ticket-types/TicketTypes.tsx








function TicketTypes() {
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const publicApi = (0,public_api/* default */.Ay)();
  const forms = useForms();
  const handleSelectForm = async form => {
    // Check whether direct-link-order is in search
    const directLinkOrderId = window.appState.search.get('direct-link-order');
    if (directLinkOrderId) {
      const formProgress = await publicApi.PortalFormProgressApi.create({
        request: {
          company: companyId,
          form: form.id,
          order: directLinkOrderId,
          location: window.appState.search.get('location'),
          root_id: getPortalRootId()
        }
      });
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
        companyId,
        formProgressId: formProgress.id,
        lang
      }));
    } else if (!form.enable_order_search || !form.company_has_orders) {
      const formProgress = await publicApi.PortalFormProgressApi.create({
        request: {
          company: companyId,
          form: form.id,
          location: window.appState.search.get('location'),
          root_id: getPortalRootId()
        }
      });
      navigate(portalRoutes/* default */.A.formProgressFormProgressIdProducts({
        companyId,
        formProgressId: formProgress.id,
        lang
      }));
    } else {
      navigate(portalRoutes/* default */.A.formFormIdEmailOrder({
        companyId,
        formId: form.id,
        lang
      }));
    }
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-full p-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "md:grid md:grid-cols-2 md:gap-6"
  }, forms.map((form, index) => /*#__PURE__*/react.createElement(FormCardUI/* default */.A, {
    borderTop: index >= 1,
    key: form.id,
    form: form,
    onClick: () => handleSelectForm(form)
  }))), forms.length > 0 && forms[0].languages.length > 1 && /*#__PURE__*/react.createElement("div", {
    className: "mt-6 px-1 md:px-0"
  }, /*#__PURE__*/react.createElement("select", {
    className: "border-none bg-transparent text-sm",
    value: window.appState.lang,
    onChange: e => {
      const searchParams = new URLSearchParams(window.appState.search);
      navigate("".concat(portalRoutes/* default */.A.index({
        lang: e.target.value,
        companyId
      }), "?").concat(searchParams.toString()));
      window.location.reload();
    }
  }, forms[0].languages.map(l => /*#__PURE__*/react.createElement("option", {
    key: l,
    value: l
  }, constants/* allLanguagesLocalised */.P8[l]))))));
}
/* harmony default export */ const ticket_types_TicketTypes = (TicketTypes);
// EXTERNAL MODULE: ./react/portal/ui/FontSetting.tsx
var FontSetting = __webpack_require__(57868);
// EXTERNAL MODULE: ./react/ui/toast/ToastStore.ts
var ToastStore = __webpack_require__(2102);
;// ./react/portal_index.tsx
























































const RetinoPortal = (0,mobxreact_esm/* observer */.PA)(() => {
  const [toastStore] = (0,react.useState)(() => new ToastStore/* default */.Ay());
  const [searchParams] = (0,react_router_dom_dist/* useSearchParams */.ok)();
  const location = (0,dist/* useLocation */.zy)();
  const navigate = (0,dist/* useNavigate */.Zp)();
  const postMessageApi = usePostMessageApi();
  const unregisterLocationListener = (0,react.useRef)();
  const redirectToRetinoUrl = () => {
    const retinoUrl = searchParams.get('url') || '';
    if (retinoUrl) {
      const injectedRetinoUrl = retinoUrl;
      navigate(injectedRetinoUrl, {
        replace: true
      });
    }
  };
  (0,react.useLayoutEffect)(() => {
    window.appState.search = searchParams;
    window.appState.toastStore = toastStore;
  }, []);
  (0,react.useEffect)(() => {
    redirectToRetinoUrl();
  }, []);
  (0,react.useEffect)(() => {
    PostMessageApi.setUrl(location.pathname);
  }, [location.pathname]);
  (0,react.useEffect)(() => {
    if (unregisterLocationListener.current) {
      unregisterLocationListener.current();
    }
    unregisterLocationListener.current = postMessageApi.registerListener('locationData', data => {
      window.appState = window.appState || {};
      window.appState.parentLocation = data === null || data === void 0 ? void 0 : data.location;
    });
    PostMessageApi.requestLocationData();
    return () => {
      if (unregisterLocationListener.current) {
        unregisterLocationListener.current();
      }
    };
  }, []);
  if (window.appState.companyDisabled === true) {
    return /*#__PURE__*/react.createElement("div", {
      className: "p-8"
    }, /*#__PURE__*/react.createElement(react_ui/* Message */.QB, {
      border: true
    }, pgettext('portal_i18n', 'Retino account has been deactivated. Please remove this script from this page.')));
  }
  return /*#__PURE__*/react.createElement(ToastStore/* ToastStoreContext */.yG.Provider, {
    value: toastStore
  }, /*#__PURE__*/react.createElement(dist/* Routes */.BV, null, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(WithFormsContext, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(layout_ClosedModal, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.index.url,
    element: /*#__PURE__*/react.createElement(ticket_types_TicketTypes, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(WithFormAuth, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.authFormAuthIdClosed.url,
    element: /*#__PURE__*/react.createElement(portal_FormAuthClosed, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(FormProgressContext/* WithFormProgress */.OI, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdClosed.url,
    element: /*#__PURE__*/react.createElement(portal_FormProgressClosed, null)
  }))), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(layout_OpenedModal, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formFormIdEmailOrder.url,
    element: /*#__PURE__*/react.createElement(order_search_AuthOrderCodeEmail, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formFormIdEmail.url,
    element: /*#__PURE__*/react.createElement(OrderEmailSearch, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(WithFormAuth, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.authFormAuthDetail.url,
    element: /*#__PURE__*/react.createElement(portal_FormAuth, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(FormProgressContext/* WithFormProgress */.OI, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressDetail.url,
    element: /*#__PURE__*/react.createElement(portal_FormProgressRedirections, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.PRODUCTS
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdProducts.url,
    element: /*#__PURE__*/react.createElement(products_Products, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemDetail.url,
    element: /*#__PURE__*/react.createElement(products_ProductDetails, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdProductSelectList.url,
    element: /*#__PURE__*/react.createElement(ProductsSelectList, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdProductCustom.url,
    element: /*#__PURE__*/react.createElement(products_ProductsCustom, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemIdExchangeVariants.url,
    element: /*#__PURE__*/react.createElement(exchange_ExchangeVariants, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdOrderItemOrderItemIdExchangeCatalog.url,
    element: /*#__PURE__*/react.createElement(exchange_ExchangeCatalog, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdExchangeSummary.url,
    element: /*#__PURE__*/react.createElement(portal_FormProgressRedirections, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(WithShippingProvidersConfig, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.SHIPPING
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShipping.url,
    element: /*#__PURE__*/react.createElement(shipping_Shipping, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingCountry.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingCountry, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingType.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingTypeList, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingZipCode.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingZipCode, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingPickup.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingPickup, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffMap.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingDropOffMap, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingDropOffBranch.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingDropOffBranch, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdShippingInPersonBranch.url,
    element: /*#__PURE__*/react.createElement(shipping_ShippingInPersonBranch, null)
  }))), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.REFUNDS
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdRefund.url,
    element: /*#__PURE__*/react.createElement(refunds_RefundSelect, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdRefundAccount.url,
    element: /*#__PURE__*/react.createElement(refunds_RefundSelectAccount, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.CUSTOMER
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdCustomerInfo.url,
    element: /*#__PURE__*/react.createElement(customer_CustomerInfo, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.SUMMARY
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(Stripe, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdSummary.url,
    element: /*#__PURE__*/react.createElement(summary_Summary, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdPayment.url,
    element: /*#__PURE__*/react.createElement(payment_Payment, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdExchangeSummaryShipping.url,
    element: /*#__PURE__*/react.createElement(exchange_ExchangeShipping, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdExchangeSummaryPayment.url,
    element: /*#__PURE__*/react.createElement(exchange_ExchangePayment, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdBackwardsNavigation.url,
    element: /*#__PURE__*/react.createElement(summary_BackwardsNavigation, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(UpdateFormProgressState/* default */.A, {
      state: codegen/* BackendPublicEnums */.C.PortalFormProgressStateEnum.RESULT
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdResult.url,
    element: /*#__PURE__*/react.createElement(portal_Result, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: portalRoutes/* default */.A.formProgressFormProgressIdSurveyLiked.url,
    element: /*#__PURE__*/react.createElement(portal_Survey, null)
  })))))), /*#__PURE__*/react.createElement(ScrollToTop/* default */.A, null), /*#__PURE__*/react.createElement(react_ui/* ToastContainer */.N9, null));
});
const container = document.getElementById('retino-react-root');
setupIframeResizer(container);
const root = (0,client/* createRoot */.H)(container);
root.render( /*#__PURE__*/react.createElement(react_router_dom_dist/* BrowserRouter */.Kd, null, /*#__PURE__*/react.createElement(errorBoundaries/* ErrorBoundary */.t, {
  fallbackComponent: ErrorFallback
}, /*#__PURE__*/react.createElement(public_api/* PublicApiProvider */.Fm, null, /*#__PURE__*/react.createElement(PostMessageApiProvider, null, /*#__PURE__*/react.createElement(PortalUIThemeContext/* WithPortalUITheme */.oy, null, /*#__PURE__*/react.createElement(FontSetting/* default */.A, null, /*#__PURE__*/react.createElement(RetinoPortal, null))))))));
;// ./assets/portal_bundle.jsx
/*
 *   This will build into .js and .css files that can be rendered:
 *
 *   include:    {% load render_bundle from webpack_loader %}
 *   head:       {% render_bundle 'portal_index' 'css' %}
 *   footer:     {% render_bundle 'portal_index' 'js' %}
 */









/* styles */



/* react app */


(0,mobx_esm/* configure */.jK)({
  enforceActions: 'never',
});

if (true) {
  sdk/* init */.T({
    dsn: 'https://b66899ef04f24590954284699e871c64@sentry.io/1223003',
    environment: "production",
    release: 'could-not-get-sha',
    denyUrls: blacklisted_urls/* default */.A,
    ignoreErrors: blacklisted_errors/* default */.A,
  });

  const scope = esm_exports/* getCurrentScope */.o5();
  scope.setTag('bundle', 'Portal');
  scope.setExtra('appState', window.appState);

  window.Sentry = esm;
} else {}

moment_default().locale(window.appState.lang);


/***/ }),

/***/ 5114:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var layouts_main_sidebar_LogoIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56858);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);



function RetinoLoader(_ref) {
  let {
    gray,
    transparent
  } = _ref;
  const color = gray ? 'text-gray-600' : 'text-brand-700';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .hJ, {
    inverted: true,
    transparent: transparent,
    open: true,
    onOverlayClick: () => null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex flex-shrink-0 items-center justify-center px-6 ".concat(color)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-48"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(layouts_main_sidebar_LogoIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Loader */ .aH, {
    size: "huge"
  })))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RetinoLoader);

/***/ }),

/***/ 41906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $g: () => (/* binding */ formatPrice),
/* harmony export */   HA: () => (/* binding */ nl2br),
/* harmony export */   Mq: () => (/* binding */ weekDays),
/* harmony export */   Rg: () => (/* binding */ isFrontendOutdated),
/* harmony export */   aS: () => (/* binding */ currentLanguage),
/* harmony export */   dF: () => (/* binding */ monthNames),
/* harmony export */   g6: () => (/* binding */ toggleItem),
/* harmony export */   hW: () => (/* binding */ nl2p),
/* harmony export */   k0: () => (/* binding */ loadScript),
/* harmony export */   l7: () => (/* binding */ convertDecimal),
/* harmony export */   q2: () => (/* binding */ convertHeicToJpeg),
/* harmony export */   qr: () => (/* binding */ useContextSafe),
/* harmony export */   uU: () => (/* binding */ containsHTMLTags)
/* harmony export */ });
/* unused harmony exports rgetattr, assert, currencyDisplay, useI18nToStr, arrayMove, changeCollection, stripHtml, usePrevValue, isProductionEnvironment, useRerender, getForegroundColor, isUUID, roundHalfUp, indexArrayByProp, useAsyncEffect, formatDateAsMomentCalendar, getNextNDays, compareObjects, compareQueries, makeAbsoluteUrl, isUrlValid, isImage, excerpt, formatNumber, formatLongDate, getOrderPortalDirectLink, useStoreUrlConnect, parseUrlSearch, parsedUrlSearchArrayValuesToSingleValues, toUrlSearchString, LocalStorageCache */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var contexts_CurrentLanguageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60758);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var stores_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25193);
/* provided dependency */ var moment = __webpack_require__(95093);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








/**
 * Get nested attribute from object
 * rgetattr(obj, 'test.attr1') == obj.test.attr1
 * @param {object} obj
 * @param {string} attrName
 * @param {string} separator
 */
const rgetattr = function (obj, attrName) {
  let separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  const attrList = attrName.split(separator);
  let value = obj && obj[attrList[0]];
  for (let i = 1; i < attrList.length; ++i) value = value && value[attrList[i]];
  return value;
};
function assert(condition) {
  let msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion Error';
  if (!condition) {
    throw new Error(msg);
  }
}
const currencyDisplay = currencyISO => stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .allCurrenciesSymbol */ .pH[currencyISO] || currencyISO;
const currentLanguage = (i18nObject, lang) => {
  if (i18nObject === null || i18nObject === undefined) return '';
  if (typeof i18nObject === 'string') {
    return i18nObject;
  }

  // Helper function to get value with fallback to base language
  const getLangWithFallback = langCode => {
    const value = i18nObject[langCode];
    if (value) return value;

    // Try base language if regional variant (e.g., 'de-at' -> 'de')
    if (langCode.includes('-')) {
      const baseLang = langCode.split('-')[0];
      return i18nObject[baseLang];
    }
    return undefined;
  };

  // Try provided lang parameter first
  if (lang) {
    const value = getLangWithFallback(lang);
    if (value) return value;
  }

  // Try window.appState.lang
  const appLang = window.appState.lang;
  const appValue = getLangWithFallback(appLang);
  if (appValue) return appValue;

  // Finally, fallback to first truthy value
  return Object.values(i18nObject).find(a => !!a) || '';
};
const useI18nToStr = () => {
  const lang = useCurrentLanguage();
  return i18nObject => currentLanguage(i18nObject, lang) || '';
};
const arrayMove = (items, oldIndex, newIndex) => {
  const copiedItems = [...items]; // shallow copy
  const [tmp] = copiedItems.splice(oldIndex, 1);
  copiedItems.splice(newIndex, 0, tmp);
  return copiedItems;
};
function changeCollection(col1, col2, oldIndex, newIndex) {
  const copyCol1 = [...col1]; // shallow copy
  const copyCol2 = [...col2]; // shallow copy
  const [tmp] = copyCol1.splice(oldIndex, 1); // remove from old collection
  copyCol2.splice(newIndex, 0, tmp); // insert to new
  return [copyCol1, copyCol2];
}
const convertDecimal = (price, currency) => Number(price) / 100;
const formatPrice = function (price, currency) {
  let isDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isDecimal) price = convertDecimal(price, currency);
  try {
    const fractionDigits = price % 1 === 0 ? 0 : undefined;
    const langCode = window.appState.lang;
    const priceFormatter = Intl.NumberFormat(langCode, {
      style: 'currency',
      currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
    return priceFormatter.format(price);
  } catch (error) {
    console.error(error);
    return "".concat(price, " ").concat(currency);
  }
};
function nl2br(str) {
  str = str || '';
  const newlineRegex = /(\r\n|\r|\n)/g;
  if (typeof str === 'number') {
    return str;
  }
  if (typeof str !== 'string') {
    return '';
  }
  return str.split(newlineRegex).map((line, index) => {
    if (line.match(newlineRegex)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement('br', {
        key: index
      });
    }
    return line;
  });
}
function nl2p(str) {
  return str.split('\n').map(item => "<p>".concat(item, "</p>")).join('');
}
function stripHtml(html) {
  var _DOMParser$parseFromS;
  return ((_DOMParser$parseFromS = new DOMParser().parseFromString(html, 'text/html').body.textContent) === null || _DOMParser$parseFromS === void 0 ? void 0 : _DOMParser$parseFromS.trim()) || '';
}
const usePrevValue = props => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = props;
  });
  return ref.current;
};
const isProductionEnvironment = () => "production" === 'production';
const useRerender = () => {
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(v => !v), []);
  return rerender;
};
const getForegroundColor = backgroundColor => {
  /* This will be black or white - the one that will be more suitable for selected background color */
  const darkColor = '#000000';
  const lightColor = '#ffffff';

  // creates array ["RR", "GG", "BB"]
  const parsedColor = backgroundColor.slice(1).match(/.{2}/g);
  if (parsedColor === null || parsedColor.length !== 3) return darkColor;

  // applies this magic formula 'if (red*0.299 + green*0.587 + blue*0.114) > 186 use #000000 else use #ffffff'
  const backgroundColorIntensivness = parsedColor.map(x => parseInt(x, 16)).reduce((acc, curr, i) => acc + curr * [0.299, 0.587, 0.114][i], 0);
  return backgroundColorIntensivness > 150 ? darkColor : lightColor;
};
const isUUID = str => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
const roundHalfUp = (value, decimals) => {
  const decimal = Math.round(Number("".concat(value, "e").concat(decimals)));
  return Number("".concat(decimal, "e-").concat(decimals));
};
function useContextSafe(context) {
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  if (value === null || value === undefined) {
    throw Error("Context ".concat(context, " must be used within context provider!"));
  }
  return value;
}
const indexArrayByProp = (array, prop) => array.reduce((acc, curr) => {
  acc[curr[prop]] = curr;
  return acc;
}, {});
const useAsyncEffect = (func, deps) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
  func();
}, deps);
const formatDateAsMomentCalendar = date => moment(date).calendar(null, {
  sameDay: "[".concat(gettext('Today'), "]"),
  nextDay: "[".concat(gettext('Tomorrow'), "]"),
  nextWeek: 'LL',
  lastDay: "[".concat(gettext('Yesterday'), "]"),
  lastWeek: 'LL',
  sameElse: 'LL'
});
const weekDays = [gettext('Monday'), gettext('Tuesday'), gettext('Wednesday'), gettext('Thursday'), gettext('Friday'), gettext('Saturday'), gettext('Sunday')];
const monthNames = [gettext('January'), gettext('February'), gettext('March'), gettext('April'), gettext('May'), gettext('June'), gettext('July'), gettext('August'), gettext('September'), gettext('October'), gettext('November'), gettext('December')];
const getNextNDays = count => {
  const today = new Date();
  const addDays = days => {
    const d = new Date(today.valueOf());
    d.setDate(d.getDate() + days);
    return d;
  };
  const getDayIndex = offset => (offset + today.getDay()) % 7;
  const getDayName = offset => "".concat(getDayIndex(offset) === today.getDay() ? gettext('Tomorrow') : weekDays[getDayIndex(offset)], ", ").concat(moment(addDays(offset + 1)).format('D. M.'));
  return [...Array(count).keys()].map(i => [getDayIndex(i), getDayName(i)]);
};
function compareObjects(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return isEqual(omit(q1, excludeFields), omit(q2, excludeFields));
}
function compareQueries(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return compareObjects(q1, q2, [...excludeFields, 'page', 'search']);
}
function toggleItem(list, updatedElement) {
  if (!list) {
    return [updatedElement];
  }
  return list.includes(updatedElement) ? list.filter(item => item !== updatedElement) : [...list, updatedElement];
}
function makeAbsoluteUrl(url) {
  if (url) {
    const defaultProtocol = 'https';
    if (!url.match(/^(https?:)?\/\//)) {
      return "".concat(defaultProtocol, "://").concat(url);
    }
  }
  return url;
}
function isUrlValid(url) {
  const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm;
  return urlRegex.test(url);
}
function isImage(filename) {
  if (filename === undefined || filename === null) return false;
  return filename.match(/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/);
}
const excerpt = (s, len) => s.length > len ? "".concat(s.substr(0, len - 3), "...") : s;
const formatNumber = n => new Intl.NumberFormat(window.appState.lang).format(n);
const formatLongDate = isoDate => {
  const date = new Date(isoDate);
  return date.toLocaleDateString(window.appState.lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
function getOrderPortalDirectLink(companyId, email, orderCode, lang) {
  return "".concat(window.location.origin, "/").concat(lang, "/order-tracking/").concat(companyId, "/direct-link/?email=").concat(email, "&code=").concat(orderCode);
}
function useStoreUrlConnect(store) {
  const isMounted = useRef(true);
  const location = useLocation();
  const [, setSearchParams] = useSearchParams();

  // setSearchParams is recreated whenever the location changes, but the sync outlives a render.
  const setSearchParamsRef = useRef(setSearchParams);
  setSearchParamsRef.current = setSearchParams;
  const [sync] = useState(() => new StoreUrlSync(store, (queryString, options) => {
    if (isMounted.current) setSearchParamsRef.current(queryString, options);
  }));

  // Runs on mount and on every Back/Forward; the sync ignores the echo of its own writes.
  useEffect(() => {
    sync.applyUrl(location.search);
  }, [location.search]);
  useEffect(() => {
    isMounted.current = true;
    const disposer = autorun(() => {
      sync.applyStore();
    });
    return () => {
      disposer();
      isMounted.current = false;
    };
  }, []);
}
function parseUrlSearch(search) {
  if (!search) {
    return {};
  }

  // Parse url search string into object. Each key has an array of values (even single values are in array).
  const searchParams = new URLSearchParams(search);
  const result = {};
  searchParams.forEach((value, key) => {
    if (!(key in result)) {
      result[key] = [];
    }
    try {
      result[key].push(JSON.parse(value));
    } catch (e) {
      result[key].push(value);
    }
  });
  return result;
}
function parsedUrlSearchArrayValuesToSingleValues(parsedUrlSearch) {
  // e.g. {'is_valid': [true], 'another_key': [7], 'key': [2, 6, 7]} -> {'is_valid': true, 'another_key': 7, 'key': [2, 6, 7]}
  return Object.entries(parsedUrlSearch).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return Array.isArray(value) && value.length === 1 ? _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value[0]
    }) : _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value
    });
  }, {});
}
function toUrlSearchString(queryObj) {
  if (!queryObj || Object.keys(queryObj).length === 0) {
    return '';
  }
  const searchParams = new URLSearchParams();
  Object.entries(queryObj).forEach(_ref2 => {
    let [key, value] = _ref2;
    return value !== undefined && (Array.isArray(value) ? value.forEach(val => searchParams.append(key, val)) : searchParams.append(key, value));
  });
  return searchParams.toString();
}
function isFrontendOutdated() {
  return window.appState.bundleHash !== window.appState.latestBundleHash;
}
function containsHTMLTags(str) {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
const convertHeicToJpeg = async file => {
  /**
   * Converts a HEIC image file to a JPEG format.
   *
   * @param {File} file - The HEIC file to be converted.
   *
   * @returns {Promise<File>} - A Promise that resolves to the converted JPEG file.
   *
   * @description
   * This function takes a HEIC file as input, uses a web worker and an external library (libheif)
   * to process and convert the HEIC file to JPEG format. The conversion is done asynchronously,
   * and the resulting JPEG file is returned in a Promise. The function also handles error reporting
   * through Sentry in case of conversion or worker errors.
   *
   * - It creates a temporary URL for the input file.
   * - It communicates with a web worker responsible for performing the conversion using the HEIF library.
   * - The converted file's name is derived from the original HEIC file but with a ".jpeg" extension.
   * - Any errors during conversion are captured by Sentry and propagated to the caller via rejection.
   * - The temporary URL is revoked after the conversion is complete.
   */

  const workerScriptUrl = "".concat(window.appState.baseStaticUrl, "heicToJpgConvertor.js");
  const libHeifUrl = "".concat(window.appState.baseStaticUrl, "libheif-bundle.js");
  const workerScriptContent = await (await fetch(workerScriptUrl)).blob();
  const url = URL.createObjectURL(workerScriptContent);

  // this needs to be a data/blob URL because Workers need to be served from the same origin as the main thread
  // therefore we cannot load the worker script from a different origin (e.g. cdn)
  // See https://developer.mozilla.org/en-US/docs/Web/API/Worker/Worker#security_considerations
  // and https://stackoverflow.com/questions/21913673/execute-web-worker-from-different-origin
  const worker = new Worker(url);
  const convertedFile = await new Promise((resolve, reject) => {
    const imageBlob = new Blob([file], {
      type: 'image/heic'
    });
    worker.postMessage({
      file: imageBlob,
      libHeifUrl
    });
    worker.onmessage = e => {
      if (e.data.error) {
        window.Sentry.captureException(new Error(e.data.error));
        reject(new Error(e.data.error));
      } else if (e.data.blob) {
        const name = file.name.replace(/\.heic$/i, '.jpeg');
        resolve(new File([e.data.blob], name, {
          type: 'image/jpeg'
        }));
      }
    };
    worker.onerror = err => {
      window.Sentry.captureException(err);
      reject(err);
    };
  });
  worker.terminate();
  URL.revokeObjectURL(url);
  return convertedFile;
};
const loadScript = (() => {
  // Cache for storing ongoing load promises
  const scriptPromises = {};
  return (src, id) => {
    // If a script load has already been initiated, return the same promise
    if (scriptPromises[id]) {
      return scriptPromises[id];
    }
    scriptPromises[id] = new Promise((resolve, reject) => {
      const scriptElement = document.getElementById(id);
      if (!scriptElement) {
        // Create the script element if it doesn't exist
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        const handleLoadScriptSuccess = () => {
          script.setAttribute('loaded', 'true'); // Mark as loaded
          resolve({
            successful: true
          });
          delete scriptPromises[id]; // Clean up cache
        };
        const handleLoadScriptFail = event => {
          reject(new Error(event.toString()));
          delete scriptPromises[id]; // Clean up cache
        };
        script.addEventListener('load', handleLoadScriptSuccess, {
          once: true
        });
        script.addEventListener('error', handleLoadScriptFail, {
          once: true
        });
        document.head.appendChild(script);
      } else if (scriptElement.getAttribute('loaded') === 'true') {
        // If the script is already loaded
        resolve({
          successful: true
        });
      } else {
        // Script is not yet loaded, wait for it to finish loading
        scriptElement.addEventListener('load', () => resolve({
          successful: true
        }), {
          once: true
        });
        scriptElement.addEventListener('error', event => reject(new Error(event.toString())), {
          once: true
        });
      }
    });
    return scriptPromises[id];
  };
})();

/**
 * A cache interface for storing and retrieving data with timestamps
 */

/**
 * LocalStorageCache provides a convenient way to cache data in localStorage with
 * automatic expiration handling.
 */
class LocalStorageCache {
  /**
   * Create a new LocalStorageCache instance
   *
   * @param key - The specific key for this cache instance
   * @param prefix - The prefix for the localStorage key
   * @param timeoutSec - Timeout in seconds (default: 7 days)
   */
  constructor(key) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LOCAL_STORAGE_CACHE';
    let timeoutSec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7 * 24 * 60 * 60;
    this.cacheKey = void 0;
    this.prefix = void 0;
    this.key = void 0;
    this.timeoutMs = void 0;
    this.prefix = prefix;
    this.key = key;
    this.timeoutMs = timeoutSec * 1000;
    this.cacheKey = "".concat(this.prefix, "_").concat(this.key);
  }

  /**
   * Store data in the cache
   *
   * @param data - The data to cache
   * @param isRetry - Whether this is a retry attempt after clearing space
   * @returns void
   */
  save(data) {
    let isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const cachedData = {
      timestamp: Date.now(),
      data
    };
    try {
      localStorage.setItem(this.cacheKey, JSON.stringify(cachedData));
    } catch (error) {
      // Check if it's a quota exceeded error using MDN-specified identifiers
      // https://developer.mozilla.org/en-US/docs/Web/API/Storage_API/Storage_quotas_and_eviction_criteria#web_storage
      if (!isRetry && error instanceof DOMException && (
      // Standard
      error.name === 'QuotaExceededError' || error.code === DOMException.QUOTA_EXCEEDED_ERR ||
      // Firefox
      error.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
      // Safari/WebKit
      error.name === 'QUOTA_EXCEEDED_ERR')) {
        // Clear old caches with the same prefix
        if (this.prefix) {
          this.clearCachesWithPrefix();
        } else {
          this.clear();
        }
        // Try again with isRetry flag to prevent infinite recursion
        this.save(data, true);
      } else if (window.Sentry) {
        // Either it's already a retry attempt or it's a different error
        window.Sentry.captureException(error);
      }
    }
  }

  /**
   * Load data from the cache if it exists and is not expired
   *
   * @returns The cached data or null if no valid cache exists
   */
  load() {
    const cachedDataString = localStorage.getItem(this.cacheKey);
    if (cachedDataString) {
      try {
        const cachedData = JSON.parse(cachedDataString);
        const currentTime = Date.now();

        // Check if cache is still valid (less than timeout)
        if (cachedData.timestamp && currentTime - cachedData.timestamp < this.timeoutMs) {
          return cachedData.data;
        }
      } catch (error) {
        if (window.Sentry) {
          window.Sentry.captureException(error);
        }
      }

      // Cache is expired or invalid, remove it
      localStorage.removeItem(this.cacheKey);
    }
    return null;
  }

  /**
   * Check if there is valid data in the cache
   *
   * @returns boolean indicating if valid cache exists
   */
  hasValidCache() {
    return this.load() !== null;
  }

  /**
   * Remove this cache entry
   */
  clear() {
    localStorage.removeItem(this.cacheKey);
  }

  /**
   * Clear all caches with the given prefix
   *
   * @param prefix - The prefix to match for clearing caches
   */
  clearCachesWithPrefix() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.prefix)) {
        keysToRemove.push(key);
      }
    }

    // Remove the collected keys
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  arrayMove,
  assert,
  containsHTMLTags,
  convertHeicToJpeg,
  currencyDisplay,
  currentLanguage,
  excerpt,
  formatDateAsMomentCalendar,
  formatLongDate,
  formatPrice,
  getForegroundColor,
  getOrderPortalDirectLink,
  indexArrayByProp,
  isFrontendOutdated,
  isImage,
  isUrlValid,
  loadScript,
  LocalStorageCache,
  makeAbsoluteUrl,
  monthNames,
  nl2br,
  nl2p,
  parseUrlSearch,
  rgetattr,
  roundHalfUp,
  toUrlSearchString,
  useAsyncEffect,
  usePrevValue,
  useRerender,
  weekDays
});

/***/ }),

/***/ 4396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   e: () => (/* binding */ useFormProgressState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47767);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var portal_contexts_FormProgressContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16523);




const FormProgressStateContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useFormProgressState = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .useContextSafe */ .qr)(FormProgressStateContext);
function UpdateFormProgressState(_ref) {
  let {
    state
  } = _ref;
  const {
    updateFormProgress
  } = (0,portal_contexts_FormProgressContext__WEBPACK_IMPORTED_MODULE_2__/* .useFormProgress */ .NG)();
  const [formProgressState, setFormProgressState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(state);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setFormProgressState(state);
    updateFormProgress({
      state
    });
  }, [state, updateFormProgress]);
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => formProgressState, [formProgressState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormProgressStateContext.Provider, {
    value: value
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router__WEBPACK_IMPORTED_MODULE_3__/* .Outlet */ .sv, null));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UpdateFormProgressState);

/***/ }),

/***/ 16523:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NG: () => (/* binding */ useFormProgress),
/* harmony export */   OI: () => (/* binding */ WithFormProgress)
/* harmony export */ });
/* unused harmony export FormProgressContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47767);
/* harmony import */ var components_RetinoLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5114);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41906);
/* harmony import */ var public_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35750);
/* harmony import */ var public_api_codegen__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7816);
/* harmony import */ var routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19312);







const FormProgressContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useFormProgress = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .useContextSafe */ .qr)(FormProgressContext);
function WithFormProgress() {
  const navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_6__/* .useNavigate */ .Zp)();
  const {
    companyId,
    formProgressId,
    lang
  } = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_6__/* .useParams */ .g)();
  const publicApi = (0,public_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Ay)();
  const [formProgress, setFormProgress] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [navigatedFromSummary, setNavigatedFromSummary] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [progressBarValue, setProgressBarValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const formProgressIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(formProgressId);
  formProgressIdRef.current = formProgressId;
  const storeFormProgress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(response => {
    if (response.id === formProgressIdRef.current) {
      setFormProgress(response);
    }
  }, []);
  const handleLoad = async () => {
    const response = await publicApi.PortalFormProgressApi.retrieve({
      id: formProgressId
    });
    storeFormProgress(response);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    handleLoad();
  }, [formProgressId]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const isCurrentFormProgress = (formProgress === null || formProgress === void 0 ? void 0 : formProgress.id) === formProgressId;
    if (isCurrentFormProgress && formProgress.result_ticket && formProgress.state && formProgress.state !== 'RESULT') {
      navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdResult({
        companyId,
        formProgressId,
        lang
      }));
    }
  }, [companyId, formProgress, formProgressId, lang, navigate]);

  // PATCHes must not run concurrently (lost updates, #6322) and responses must
  // be applied in request order, so each request waits for the previous one.
  const patchQueue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Promise.resolve());
  const updateFormProgress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async partialFormProgress => {
    const request = patchQueue.current.then(() => publicApi.PortalFormProgressApi.patch({
      id: formProgressId,
      request: partialFormProgress
    }));
    patchQueue.current = request.catch(() => undefined);
    const response = await request;
    storeFormProgress(response);
    return response;
  }, [formProgressId, storeFormProgress]);
  const navigateToState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(state => {
    switch (state) {
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.PRODUCTS:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdProducts({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.EXCHANGE_SUMMARY:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdSummary({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SHIPPING:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdShipping({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.REFUNDS:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdRefund({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.CUSTOMER:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdCustomerInfo({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SUMMARY:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdSummary({
          companyId,
          formProgressId,
          lang
        }));
        break;
      case public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.RESULT:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressIdResult({
          companyId,
          formProgressId,
          lang
        }));
        break;
      default:
        navigate(routes_codegen_portalRoutes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.formProgressFormProgressDetail({
          companyId,
          formProgressId,
          lang
        }));
        break;
    }
  }, [companyId, formProgressId, lang, navigate]);
  const navigateNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async sourceFormProgress => {
    const currentFormProgress = sourceFormProgress !== null && sourceFormProgress !== void 0 ? sourceFormProgress : formProgress;
    if (currentFormProgress) {
      let nextState = currentFormProgress.states[(currentFormProgress.states.indexOf(currentFormProgress.state) || 0) + 1];
      if (navigatedFromSummary) {
        nextState = public_api_codegen__WEBPACK_IMPORTED_MODULE_4__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SUMMARY;
        setNavigatedFromSummary(false);
      }
      navigateToState(nextState);
    }
  }, [formProgress, navigateToState, navigatedFromSummary]);
  const navigateBack = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    if (formProgress) {
      const previousState = formProgress.states[(formProgress.states.indexOf(formProgress.state) || 0) - 1];
      navigateToState(previousState);
    }
  }, [formProgress, navigateToState]);
  const navigateFromSummary = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async to => {
    setNavigatedFromSummary(true);
    navigate(to);
  }, [navigate]);
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    formProgress: formProgress,
    updateFormProgress,
    navigateToState,
    navigateNext,
    navigateBack,
    navigateFromSummary,
    navigatedFromSummary,
    setFormProgress: storeFormProgress,
    progressBarValue,
    setProgressBarValue
  }), [formProgress, updateFormProgress, navigateToState, navigateNext, navigateBack, navigateFromSummary, navigatedFromSummary, storeFormProgress, progressBarValue, setProgressBarValue]);
  if (!formProgress || formProgress.id !== formProgressId) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(components_RetinoLoader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, null);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormProgressContext.Provider, {
    value: value
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_6__/* .Outlet */ .sv, null));
}


/***/ }),

/***/ 17961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31453);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28095);
/* harmony import */ var _FontSetting__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57868);
/* harmony import */ var _Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15125);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46378);
/* harmony import */ var _Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92636);
/* harmony import */ var _ProgressBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55421);
/* harmony import */ var _ProgressHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61975);








const PortalUI = {
  Button: _Button__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  Card: _Card__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
  FontSetting: _FontSetting__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
  Form: _Form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Header: _Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  Page: _Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
  ProgressBar: _ProgressBar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A,
  ProgressHeader: _ProgressHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PortalUI);

/***/ }),

/***/ 7816:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* reexport safe */ _enums__WEBPACK_IMPORTED_MODULE_0__.C)
/* harmony export */ });
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2538);


/***/ }),

/***/ 19312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);

const portalRoutes = {
  index: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/'),
  authFormAuthDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/auth/:formAuthId/'),
  formProgressFormProgressDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/'),
  authFormAuthIdClosed: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/auth/:formAuthId/closed/'),
  formProgressFormProgressIdClosed: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/closed/'),
  formFormIdEmailOrder: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form/:formId/email-order/'),
  formFormIdEmail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form/:formId/email/'),
  formProgressFormProgressIdProducts: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/products/'),
  formProgressFormProgressIdProductSelectList: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/product-select-list/'),
  formProgressFormProgressIdOrderItemOrderItemDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/order-item/:orderItemId/'),
  formProgressFormProgressIdProductCustom: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/product/custom/'),
  formProgressFormProgressIdOrderItemOrderItemIdExchange: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/order-item/:orderItemId/exchange/'),
  formProgressFormProgressIdOrderItemOrderItemIdExchangeVariants: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/order-item/:orderItemId/exchange/variants/'),
  formProgressFormProgressIdOrderItemOrderItemIdExchangeCatalog: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/order-item/:orderItemId/exchange/catalog/'),
  formProgressFormProgressIdExchangeSummary: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/exchange-summary/'),
  formProgressFormProgressIdExchangeSummaryShipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/exchange-summary/shipping/'),
  formProgressFormProgressIdExchangeSummaryPayment: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/exchange-summary/payment/'),
  formProgressFormProgressIdShipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/'),
  formProgressFormProgressIdShippingCountry: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/country/'),
  formProgressFormProgressIdShippingType: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/type/'),
  formProgressFormProgressIdShippingZipCode: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/zip-code/'),
  formProgressFormProgressIdShippingPickup: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/pickup/'),
  formProgressFormProgressIdShippingDropOffMap: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/drop-off-map/'),
  formProgressFormProgressIdShippingDropOffBranch: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/drop-off-branch/'),
  formProgressFormProgressIdShippingInPersonBranch: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/shipping/in-person-branch/'),
  formProgressFormProgressIdRefund: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/refund/'),
  formProgressFormProgressIdRefundAccount: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/refund/account'),
  formProgressFormProgressIdCustomerInfo: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/customer-info/'),
  formProgressFormProgressIdSummary: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/summary/'),
  formProgressFormProgressIdPayment: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/payment/'),
  formProgressFormProgressIdBackwardsNavigation: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/backwards-navigation/'),
  formProgressFormProgressIdResult: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/result/'),
  formProgressFormProgressIdSurveyLiked: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/iframe/:companyId/form-progress/:formProgressId/survey/:liked')
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (portalRoutes);

/***/ }),

/***/ 2413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QJ: () => (/* binding */ condensateOpenHours)
/* harmony export */ });
/* unused harmony exports getShippingProviderName, getShippingStatusName, getShippingProviderLogo, getShippingTypePrice, getShippingTypesPriceStr */
/* harmony import */ var img_shipping_logo_ppl_jpg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14821);
/* harmony import */ var img_shipping_logo_zasilkovna_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19869);
/* harmony import */ var img_shipping_logo_ppl_dhl_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36908);
/* harmony import */ var img_shipping_logo_dhl_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46137);
/* harmony import */ var img_shipping_logo_zasilkovna_big_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54518);
/* harmony import */ var img_shipping_logo_gls_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93193);
/* harmony import */ var img_shipping_logo_liftago_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65711);
/* harmony import */ var img_shipping_dpd_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60291);
/* harmony import */ var img_shipping_logo_geis_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34237);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);










const getShippingProviderName = shippingProvider => {
  switch (shippingProvider) {
    case 'RETINO_PPL':
    case 'CUSTOMER_RETINO_PPL':
      return gettext('PPL Parcelshop');
    case 'CUSTOMER_RETINO_GLS_DROPOFF':
    case 'MY_GLS_DROPOFF':
      return gettext('GLS Parcelshop');
    case 'CUSTOMER_RETINO_GLS_PICKUP':
    case 'CUSTOMER_RETINO_GLS_PICKUP_SK':
    case 'CUSTOMER_RETINO_GLS_PICKUP_HU':
      return gettext('GLS pickup');
    case 'ZASILKOVNA':
      return gettext('Zasilkovna');
    case 'GLS':
    case 'MY_GLS':
      return gettext('GLS pickup');
    case 'GLS_DROPOFF_PL':
      return gettext('GLS Parcelshop Poland');
    case 'PPL':
      return gettext('PPL pickup');
    case 'DPD_PICKUP':
    case 'CUSTOMER_PAID_RETINO_DPD_PICKUP':
      return gettext('DPD pickup');
    case 'DPD_DROPOFF':
    case 'CUSTOMER_PAID_RETINO_DPD_DROPOFF':
      return gettext('DPD dropoff');
    case 'LIFTAGO':
      return gettext('Liftago');
    case 'RETURN_CONNECT':
      return gettext('PPL Return Connect');
    case 'CUSTOM_OTHER_PROVIDER':
      return gettext('Custom shipping provider');
    case 'GEIS':
      return gettext('Geis');
    case 'DHL_FREIGHT':
      return gettext('DHL Freight');
    case 'DHL_DROPOFF':
      return gettext('DHL Parcelshop');
    default:
      return null;
  }
};
const getShippingStatusName = status => {
  switch (status) {
    case 'STATUS_INIT':
      return gettext('Allowed');
    case 'STATUS_PENDING_CONFIRMATION':
      return gettext('Pending confirmation');
    case 'STATUS_ACCEPTED':
      return gettext('Generated shipping label');
    case 'STATUS_SUBMITTED':
      return gettext('Delivered to the branch');
    case 'STATUS_TRANSPORT':
      return gettext('Supplied by the carrier');
    case 'STATUS_DELIVERED':
      return gettext('Delivered');
    case 'STATUS_UNDELIVERED':
      return gettext('Undelivered');
    case 'STATUS_CANCELED':
      return gettext('Cancelled');
    case 'STATUS_REFUNDED':
      return gettext('Refunded');
    case 'STATUS_UNKNOWN':
      return gettext('Unknown');
    default:
      return null;
  }
};
const getShippingProviderLogo = function (shippingProvider) {
  let shape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'square';
  switch (shippingProvider) {
    case 'RETINO_PPL':
    case 'CUSTOMER_RETINO_PPL':
    case 'PPL':
      return img_shipping_logo_ppl_jpg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A;
    case 'ZASILKOVNA':
      return shape === 'rect' ? img_shipping_logo_zasilkovna_big_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A : img_shipping_logo_zasilkovna_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A;
    case 'GLS':
    case 'MY_GLS':
    case 'MY_GLS_DROPOFF':
    case 'GLS_DROPOFF_PL':
    case 'CUSTOMER_RETINO_GLS_PICKUP':
    case 'CUSTOMER_RETINO_GLS_PICKUP_SK':
    case 'CUSTOMER_RETINO_GLS_PICKUP_HU':
    case 'CUSTOMER_RETINO_GLS_DROPOFF':
    case 'CUSTOMER_RETINO_GLS_DROPOFF_SK':
    case 'CUSTOMER_RETINO_GLS_DROPOFF_HU':
      return img_shipping_logo_gls_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A;
    case 'LIFTAGO':
      return img_shipping_logo_liftago_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A;
    case 'DPD_DROPOFF':
    case 'DPD_PICKUP':
    case 'CUSTOMER_PAID_RETINO_DPD_DROPOFF':
    case 'CUSTOMER_PAID_RETINO_DPD_PICKUP':
      return img_shipping_dpd_logo_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A;
    case 'RETURN_CONNECT':
      return img_shipping_logo_ppl_dhl_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A;
    case 'GEIS':
      return img_shipping_logo_geis_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A;
    case 'DHL_DROPOFF':
    case 'DHL_FREIGHT':
      return img_shipping_logo_dhl_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A;
    default:
      return null;
  }
};
const getShippingTypePrice = item => item.shipping_provider_data.paid_by_customer && item.shipping_provider_data.customer_price ? item.shipping_provider_data.customer_price : {
  price: Number(item.displayed_price),
  currency: item.displayed_currency
};
const getShippingTypesPriceStr = shippingTypes => {
  const allFree = !shippingTypes.some(item => getShippingTypePrice(item).price);
  if (allFree) {
    return gettext('free');
  }
  const someFree = shippingTypes.some(item => !getShippingTypePrice(item).price);
  const lowestPrice = shippingTypes.reduce((_ref, item) => {
    let {
      price,
      currency
    } = _ref;
    return getShippingTypePrice(item).price < price && getShippingTypePrice(item).price > 0 ? {
      price: getShippingTypePrice(item).price,
      currency: getShippingTypePrice(item).currency
    } : {
      price,
      currency
    };
  }, {
    price: Infinity,
    currency: ''
  });
  if (someFree) {
    return interpolate(gettext('free or from %(price)s'), {
      price: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency)
    }, true);
  }
  if (shippingTypes.length === 1) {
    return (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency);
  }
  return interpolate(gettext('from %(price)s'), {
    price: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency)
  }, true);
};
const condensateOpenHours = dropOffBranch => {
  let startDayId = 0;
  let endDayId = startDayId;
  const condensatedOpenHours = [];
  Object.keys(dropOffBranch.work_hours).forEach(dayId => {
    const currentDayWorkHours = dropOffBranch.work_hours[dayId].flat();
    const nextDayWorkHours = dropOffBranch.work_hours[Number(dayId) + 1] ? dropOffBranch.work_hours[Number(dayId) + 1].flat() : null;
    if (currentDayWorkHours && nextDayWorkHours && currentDayWorkHours.length === nextDayWorkHours.length && currentDayWorkHours.every((value, index) => value === nextDayWorkHours[index]) || !currentDayWorkHours && !nextDayWorkHours && endDayId < helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq.length - 1) {
      endDayId += 1;
    } else {
      const daysName = startDayId === endDayId ? helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[startDayId].slice(0, 2) : "".concat(helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[startDayId].slice(0, 2), "\u2013").concat(helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[endDayId].slice(0, 2));
      condensatedOpenHours.push({
        day: daysName,
        openHours: dropOffBranch.work_hours[startDayId] && dropOffBranch.work_hours[startDayId].map(hour => hour.join('\u2013')).join(', ') || gettext('closed')
      });
      endDayId += 1;
      startDayId = endDayId;
    }
  });
  return condensatedOpenHours;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  getShippingProviderLogo,
  getShippingProviderName,
  getShippingTypePrice,
  getShippingTypesPriceStr,
  condensateOpenHours
});

/***/ }),

/***/ 25193:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P8: () => (/* binding */ allLanguagesLocalised),
/* harmony export */   mn: () => (/* binding */ allCountries),
/* harmony export */   pH: () => (/* binding */ allCurrenciesSymbol)
/* harmony export */ });
/* unused harmony exports ONBOARDING_SAMPLE_ORDER_CODE, flags, historyItemTypes, notificationTypes, commonCountries, allLanguages, countryCodeToCountryName, allCurrenciesName, supportedLanguages */
const ONBOARDING_SAMPLE_ORDER_CODE = 'TUTORIAL-0001';
const flags = {
  FLAG_CREATED_BY_SHOPTET: 'created_by_shoptet',
  FLAG_SHOPTET_API_IMPORT_ORDERS: 'shoptet_api_import_orders',
  FLAG_IS_DISABLED: 'is_disabled',
  FLAG_IS_RETINO_SALES: 'is_retino_sales',
  FLAG_IS_RETINO_ADMIN: 'is_retino_admin',
  FLAG_ENABLE_KEYBOARD_SHORTCUTS: 'enable_keyboard_shortcuts',
  FLAG_DISPLAY_TRANSPORT_SETTINGS: 'display_doprava_settings',
  FLAG_DISPLAY_API_SETTINGS: 'display_api_settings',
  FLAG_DISPLAY_BADGE_SETTINGS: 'display_odznak_settings',
  FLAG_DISPLAY_BILLING_SETTINGS: 'display_billing_settings',
  FLAG_SAMPLE_TICKET: 'sample_ticket'
};
const historyItemTypes = {
  MESSAGE: 'MESSAGE',
  SYSTEM: 'SYSTEM',
  DOCUMENT: 'DOCUMENT',
  TRANSPORT: 'TRANSPORT',
  SHIPPING_REQUEST: 'SHIPPING_REQUEST',
  INTERNAL_NOTE: 'INTERNAL_NOTE',
  RATING_COMMENT: 'RATING_COMMENT',
  REFUND_REQUEST: 'REFUND_REQUEST',
  ACTIVITY: 'ACTIVITY'
};
const notificationTypes = {
  TICKET_MESSAGE_ADDED_BY_CUSTOMER: 'TICKET_MESSAGE_ADDED_BY_CUSTOMER',
  TICKET_INTERNAL_NOTE_MENTION: 'TICKET_INTERNAL_NOTE_MENTION',
  TICKET_MESSAGE_UNDELIVERED: 'TICKET_MESSAGE_UNDELIVERED',
  TICKET_CREATED_BY_CUSTOMER: 'TICKET_CREATED_BY_CUSTOMER',
  TICKET_UPCOMING_DATE: 'TICKET_UPCOMING_DATE',
  TICKET_ASSIGNED: 'TICKET_ASSIGNED',
  TICKET_RATED: 'TICKET_RATED'
};
const allCountries = {
  AF: gettext('Afghanistan'),
  AX: gettext('Åland Islands'),
  AL: gettext('Albania'),
  DZ: gettext('Algeria'),
  AS: gettext('American Samoa'),
  AD: gettext('Andorra'),
  AO: gettext('Angola'),
  AI: gettext('Anguilla'),
  AQ: gettext('Antarctica'),
  AG: gettext('Antigua and Barbuda'),
  AR: gettext('Argentina'),
  AM: gettext('Armenia'),
  AW: gettext('Aruba'),
  AU: gettext('Australia'),
  AT: gettext('Austria'),
  AZ: gettext('Azerbaijan'),
  BS: gettext('Bahamas'),
  BH: gettext('Bahrain'),
  BD: gettext('Bangladesh'),
  BB: gettext('Barbados'),
  BY: gettext('Belarus'),
  BE: gettext('Belgium'),
  BZ: gettext('Belize'),
  BJ: gettext('Benin'),
  BM: gettext('Bermuda'),
  BT: gettext('Bhutan'),
  BO: gettext('Bolivia (Plurinational State of)'),
  BQ: gettext('Bonaire, Sint Eustatius and Saba'),
  BA: gettext('Bosnia and Herzegovina'),
  BW: gettext('Botswana'),
  BV: gettext('Bouvet Island'),
  BR: gettext('Brazil'),
  IO: gettext('British Indian Ocean Territory'),
  BN: gettext('Brunei Darussalam'),
  BG: gettext('Bulgaria'),
  BF: gettext('Burkina Faso'),
  BI: gettext('Burundi'),
  CV: gettext('Cabo Verde'),
  KH: gettext('Cambodia'),
  CM: gettext('Cameroon'),
  CA: gettext('Canada'),
  KY: gettext('Cayman Islands'),
  CF: gettext('Central African Republic'),
  TD: gettext('Chad'),
  CL: gettext('Chile'),
  CN: gettext('China'),
  CX: gettext('Christmas Island'),
  CC: gettext('Cocos (Keeling) Islands'),
  CO: gettext('Colombia'),
  KM: gettext('Comoros'),
  CD: gettext('Congo (the Democratic Republic of the)'),
  CG: gettext('Congo'),
  CK: gettext('Cook Islands'),
  CR: gettext('Costa Rica'),
  CI: gettext("Côte d'Ivoire"),
  HR: gettext('Croatia'),
  CU: gettext('Cuba'),
  CW: gettext('Curaçao'),
  CY: gettext('Cyprus'),
  CZ: gettext('Czechia'),
  DK: gettext('Denmark'),
  DJ: gettext('Djibouti'),
  DM: gettext('Dominica'),
  DO: gettext('Dominican Republic'),
  EC: gettext('Ecuador'),
  EG: gettext('Egypt'),
  SV: gettext('El Salvador'),
  GQ: gettext('Equatorial Guinea'),
  ER: gettext('Eritrea'),
  EE: gettext('Estonia'),
  ET: gettext('Ethiopia'),
  FK: gettext('Falkland Islands  [Malvinas]'),
  FO: gettext('Faroe Islands'),
  FJ: gettext('Fiji'),
  FI: gettext('Finland'),
  FR: gettext('France'),
  GF: gettext('French Guiana'),
  PF: gettext('French Polynesia'),
  TF: gettext('French Southern Territories'),
  GA: gettext('Gabon'),
  GM: gettext('Gambia'),
  GE: gettext('Georgia'),
  DE: gettext('Germany'),
  GH: gettext('Ghana'),
  GI: gettext('Gibraltar'),
  GR: gettext('Greece'),
  GL: gettext('Greenland'),
  GD: gettext('Grenada'),
  GP: gettext('Guadeloupe'),
  GU: gettext('Guam'),
  GT: gettext('Guatemala'),
  GG: gettext('Guernsey'),
  GN: gettext('Guinea'),
  GW: gettext('Guinea-Bissau'),
  GY: gettext('Guyana'),
  HT: gettext('Haiti'),
  HM: gettext('Heard Island and McDonald Islands'),
  VA: gettext('Holy See'),
  HN: gettext('Honduras'),
  HK: gettext('Hong Kong'),
  HU: gettext('Hungary'),
  IS: gettext('Iceland'),
  IN: gettext('India'),
  ID: gettext('Indonesia'),
  IR: gettext('Iran (Islamic Republic of)'),
  IQ: gettext('Iraq'),
  IE: gettext('Ireland'),
  IM: gettext('Isle of Man'),
  IL: gettext('Israel'),
  IT: gettext('Italy'),
  JM: gettext('Jamaica'),
  JP: gettext('Japan'),
  JE: gettext('Jersey'),
  JO: gettext('Jordan'),
  KZ: gettext('Kazakhstan'),
  KE: gettext('Kenya'),
  KI: gettext('Kiribati'),
  KP: gettext("Korea (the Democratic People's Republic of)"),
  KR: gettext('Korea (the Republic of)'),
  KW: gettext('Kuwait'),
  KG: gettext('Kyrgyzstan'),
  LA: gettext("Lao People's Democratic Republic"),
  LV: gettext('Latvia'),
  LB: gettext('Lebanon'),
  LS: gettext('Lesotho'),
  LR: gettext('Liberia'),
  LY: gettext('Libya'),
  LI: gettext('Liechtenstein'),
  LT: gettext('Lithuania'),
  LU: gettext('Luxembourg'),
  MO: gettext('Macao'),
  MK: gettext('Macedonia'),
  MG: gettext('Madagascar'),
  MW: gettext('Malawi'),
  MY: gettext('Malaysia'),
  MV: gettext('Maldives'),
  ML: gettext('Mali'),
  MT: gettext('Malta'),
  MH: gettext('Marshall Islands'),
  MQ: gettext('Martinique'),
  MR: gettext('Mauritania'),
  MU: gettext('Mauritius'),
  YT: gettext('Mayotte'),
  MX: gettext('Mexico'),
  FM: gettext('Micronesia (Federated States of)'),
  MD: gettext('Moldova'),
  MC: gettext('Monaco'),
  MN: gettext('Mongolia'),
  ME: gettext('Montenegro'),
  MS: gettext('Montserrat'),
  MA: gettext('Morocco'),
  MZ: gettext('Mozambique'),
  MM: gettext('Myanmar'),
  NA: gettext('Namibia'),
  NR: gettext('Nauru'),
  NP: gettext('Nepal'),
  NL: gettext('Netherlands'),
  NC: gettext('New Caledonia'),
  NZ: gettext('New Zealand'),
  NI: gettext('Nicaragua'),
  NE: gettext('Niger'),
  NG: gettext('Nigeria'),
  NU: gettext('Niue'),
  NF: gettext('Norfolk Island'),
  MP: gettext('Northern Mariana Islands'),
  NO: gettext('Norway'),
  OM: gettext('Oman'),
  PK: gettext('Pakistan'),
  PW: gettext('Palau'),
  PS: gettext('Palestine, State of'),
  PA: gettext('Panama'),
  PG: gettext('Papua New Guinea'),
  PY: gettext('Paraguay'),
  PE: gettext('Peru'),
  PH: gettext('Philippines'),
  PN: gettext('Pitcairn'),
  PL: gettext('Poland'),
  PT: gettext('Portugal'),
  PR: gettext('Puerto Rico'),
  QA: gettext('Qatar'),
  RE: gettext('Réunion'),
  RO: gettext('Romania'),
  RU: gettext('Russian Federation'),
  RW: gettext('Rwanda'),
  BL: gettext('Saint Barthélemy'),
  SH: gettext('Saint Helena, Ascension and Tristan da Cunha'),
  KN: gettext('Saint Kitts and Nevis'),
  LC: gettext('Saint Lucia'),
  MF: gettext('Saint Martin (French part)'),
  PM: gettext('Saint Pierre and Miquelon'),
  VC: gettext('Saint Vincent and the Grenadines'),
  WS: gettext('Samoa'),
  SM: gettext('San Marino'),
  ST: gettext('Sao Tome and Principe'),
  SA: gettext('Saudi Arabia'),
  SN: gettext('Senegal'),
  RS: gettext('Serbia'),
  SC: gettext('Seychelles'),
  SL: gettext('Sierra Leone'),
  SG: gettext('Singapore'),
  SX: gettext('Sint Maarten (Dutch part)'),
  SK: gettext('Slovakia'),
  SI: gettext('Slovenia'),
  SB: gettext('Solomon Islands'),
  SO: gettext('Somalia'),
  ZA: gettext('South Africa'),
  GS: gettext('South Georgia and the South Sandwich Islands'),
  SS: gettext('South Sudan'),
  ES: gettext('Spain'),
  LK: gettext('Sri Lanka'),
  SD: gettext('Sudan'),
  SR: gettext('Suriname'),
  SJ: gettext('Svalbard and Jan Mayen'),
  SZ: gettext('Swaziland'),
  SE: gettext('Sweden'),
  CH: gettext('Switzerland'),
  SY: gettext('Syrian Arab Republic'),
  TW: gettext('Taiwan (Province of China)'),
  TJ: gettext('Tajikistan'),
  TZ: gettext('Tanzania, United Republic of'),
  TH: gettext('Thailand'),
  TL: gettext('Timor-Leste'),
  TG: gettext('Togo'),
  TK: gettext('Tokelau'),
  TO: gettext('Tonga'),
  TT: gettext('Trinidad and Tobago'),
  TN: gettext('Tunisia'),
  TR: gettext('Turkey'),
  TM: gettext('Turkmenistan'),
  TC: gettext('Turks and Caicos Islands'),
  TV: gettext('Tuvalu'),
  UG: gettext('Uganda'),
  UA: gettext('Ukraine'),
  AE: gettext('United Arab Emirates'),
  GB: gettext('United Kingdom of Great Britain and Northern Ireland'),
  UM: gettext('United States Minor Outlying Islands'),
  US: gettext('United States of America'),
  UY: gettext('Uruguay'),
  UZ: gettext('Uzbekistan'),
  VU: gettext('Vanuatu'),
  VE: gettext('Venezuela (Bolivarian Republic of)'),
  VN: gettext('Viet Nam'),
  VG: gettext('Virgin Islands (British)'),
  VI: gettext('Virgin Islands (U.S.)'),
  WF: gettext('Wallis and Futuna'),
  EH: gettext('Western Sahara'),
  YE: gettext('Yemen'),
  ZM: gettext('Zambia'),
  ZW: gettext('Zimbabwe')
};

// Countries offered in pickers and filters by default; the rest is reachable through search.
const commonCountries = (/* unused pure expression or super */ null && (['AU', 'AT', 'BY', 'BE', 'BA', 'BG', 'CA', 'CN', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'GL', 'HU', 'IS', 'IN', 'IE', 'IL', 'IT', 'JP', 'KR', 'LV', 'LI', 'LT', 'LU', 'MK', 'MT', 'MX', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'QA', 'RO', 'RU', 'SA', 'RS', 'SK', 'SI', 'ZA', 'ES', 'SE', 'CH', 'TW', 'TR', 'UA', 'AE', 'GB', 'US', 'VN']));
const allLanguages = {
  en: gettext('English'),
  de: gettext('German'),
  'de-at': gettext('German (Austria)'),
  'de-ch': gettext('German (Switzerland)'),
  cs: gettext('Czech'),
  sk: gettext('Slovak'),
  pl: gettext('Polish'),
  hu: gettext('Hungarian'),
  ro: gettext('Romanian'),
  es: gettext('Spanish'),
  it: gettext('Italian'),
  'it-ch': gettext('Italian (Switzerland)'),
  fr: gettext('French'),
  'fr-ch': gettext('French (Switzerland)'),
  'fr-be': gettext('French (Belgium)'),
  hr: gettext('Croatian'),
  bg: gettext('Bulgarian'),
  sl: gettext('Slovenian'),
  el: gettext('Greek'),
  nl: gettext('Dutch'),
  'nl-be': gettext('Dutch (Belgium)'),
  nb: gettext('Norwegian'),
  lv: gettext('Latvian'),
  lt: gettext('Lithuanian'),
  et: gettext('Estonian'),
  da: gettext('Danish'),
  sv: gettext('Swedish'),
  fi: gettext('Finnish'),
  pt: gettext('Portuguese'),
  uk: gettext('Ukrainian'),
  sr: gettext('Serbian')
};
const allLanguagesLocalised = {
  en: 'English',
  de: 'Deutsch',
  'de-at': 'Deutsch (Österreich)',
  'de-ch': 'Deutsch (Schweiz)',
  cs: 'Česky',
  sk: 'Slovenčina',
  pl: 'Polski',
  hu: 'Magyar',
  ro: 'Română',
  es: 'Espanol',
  it: 'Italiano',
  'it-ch': 'Italiano (Svizzera)',
  fr: 'Français',
  'fr-ch': 'Français (Suisse)',
  'fr-be': 'Français (Belgique)',
  nb: 'Norsk',
  hr: 'Hrvatski',
  bg: 'български',
  sl: 'Slovenščina',
  et: 'Eesti',
  el: 'Ελληνικά',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  nl: 'Nederlandse',
  'nl-be': 'Nederlands (België)',
  da: 'Dansk',
  fi: 'Suomi',
  sv: 'Svenska',
  pt: 'Português',
  uk: 'Українська',
  sr: 'Српски'
};
const countryCodeToCountryName = countryCode => {
  const displayNames = new Intl.DisplayNames([window.appState.lang], {
    type: 'region'
  });
  try {
    return displayNames.of(countryCode);
  } catch (e) {
    // In case when country code is not valid, return the country code itself
    return countryCode;
  }
};
const allCurrenciesName = {
  AUD: gettext('Australian dollar'),
  BGN: gettext('Bulgarian lev'),
  CAD: gettext('Canadian dollar'),
  CZK: gettext('Czech koruna'),
  DKK: gettext('Danish krone'),
  EUR: gettext('Euro'),
  GBP: gettext('British pound'),
  HRK: gettext('Croatian kuna'),
  HUF: gettext('Hungarian forint'),
  CHF: gettext('Swiss franc'),
  ILS: gettext('Israeli new shekel'),
  JPY: gettext('Japanese yen'),
  MXN: gettext('Mexican peso'),
  NOK: gettext('Norwegian krone'),
  PLN: gettext('Polish złoty'),
  RON: gettext('Romanian leu'),
  SEK: gettext('Swedish krona'),
  SGD: gettext('Singapore dollar'),
  THB: gettext('Thai baht'),
  UAH: gettext('Ukrainian hryvnia'),
  USD: gettext('United States dollar')
};
const allCurrenciesSymbol = {
  CZK: 'Kč',
  EUR: '€',
  PLN: 'zł',
  GBP: '£',
  RON: 'lei',
  HUF: 'Ft',
  UAH: '₴',
  CHF: 'Fr',
  USD: '$',
  HRK: 'kn',
  BGN: 'лв',
  AUD: '$',
  CAD: '$',
  DKK: 'kr',
  ILS: '₪',
  JPY: '¥',
  MXN: '$',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  NOK: 'kr'
};
const supportedLanguages = (/* unused pure expression or super */ null && (['cs', 'hu', 'ro', 'en']));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  flags,
  historyItemTypes,
  notificationTypes
});

/***/ }),

/***/ 9432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cj: () => (/* binding */ useCopyToClipboard),
/* harmony export */   W6: () => (/* binding */ useHistory),
/* harmony export */   m_: () => (/* binding */ useAsyncFunction)
/* harmony export */ });
/* unused harmony export useAppStateLanguage */
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96540);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47767);



function useAsyncFunction(fn, callback) {
  const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  });
  const wrapper = async function () {
    setIsLoading(true);
    try {
      const result = await fn(...arguments);
      if (isMounted.current) {
        setIsLoading(false);
        if (callback) {
          callback();
        }
        return result;
      }
    } catch (error) {
      if (isMounted.current) {
        setIsLoading(false);
        throw error;
      }
    }
  };
  return [wrapper, isLoading];
}
function useAppStateLanguage(initial) {
  const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initial || window.appState.lang);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.appState.lang = lang;
  }, [lang]);
  return [lang, setLang];
}
function useHistory() {
  const navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useNavigate */ .Zp)();
  const location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .zy)();
  const [listeners, setListeners] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    listeners.forEach(func => func(location.pathname));
  }, [location.pathname]);
  const listen = func => {
    setListeners(old => [...old, func]);
    function unregisterCallback() {
      setListeners(old => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .toggleItem */ .g6)(old, func));
    }
    return unregisterCallback;
  };
  return {
    push: navigate,
    go: navigate,
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    listen,
    location
  };
}
function useCopyToClipboard() {
  const [openPopup, setOpenPopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const copyToClipboard = text => () => {
    const textarea = document.createElement('textarea');
    textarea.innerText = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    setOpenPopup(true);
    setTimeout(() => setOpenPopup(false), 1000);
  };
  return {
    copyToClipboard,
    openCopiedPopup: openPopup
  };
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  useAsyncFunction,
  useAppStateLanguage
});

/***/ }),

/***/ 5367:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60990);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
/* harmony import */ var _CardContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98736);
/* harmony import */ var _CardFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66058);
/* harmony import */ var _CardHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5376);






function Card(_ref) {
  let {
    id,
    basic,
    children,
    loading = false,
    flat = false
  } = _ref;
  const classArray = ['relative', 'bg-white', 'rounded-lg'];
  if (flat) {
    classArray.push('border', 'border-gray-200');
  } else {
    classArray.push('shadow');
  }
  if (basic) {
    classArray.push('card-basic'); // custom class
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classArray.join(' '),
    id: id
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .e, {
    className: "absolute inset-0 z-20",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Card, {
  Content: _CardContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
  Header: _CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  Footer: _CardFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A
}));

/***/ }),

/***/ 45751:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _FeedEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31871);


function Feed(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "feed flow-root"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, children));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Feed, {
  Event: _FeedEvent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A
}));

/***/ }),

/***/ 35443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $n: () => (/* reexport */ Button/* default */.A),
  Sc: () => (/* reexport */ Checkbox/* default */.A),
  pT: () => (/* reexport */ confirm_Confirm),
  cG: () => (/* reexport */ Divider/* default */.A),
  lV: () => (/* reexport */ Form/* default */.A),
  In: () => (/* reexport */ Icon/* default */.Ay$),
  JU: () => (/* reexport */ Label/* default */.A),
  aH: () => (/* reexport */ Loader/* default */.A),
  QB: () => (/* reexport */ Message/* default */.A),
  aF: () => (/* reexport */ Modal/* default */.A),
  hJ: () => (/* reexport */ Overlay/* default */.A),
  zD: () => (/* reexport */ Popup/* default */.A),
  ZL: () => (/* reexport */ Portal/* default */.A),
  z2: () => (/* reexport */ ProgressBar/* default */.A),
  Y4: () => (/* reexport */ Segment/* default */.A),
  N9: () => (/* reexport */ ToastContainer/* default */.A),
  oR: () => (/* reexport */ toast/* default */.A)
});

// UNUSED EXPORTS: ActionPanel, Breadcrumbs, Card, CodeInput, Collapse, CollapsibleText, Dimmer, Dropdown, Feed, FeedEvent, Input, Multiselect, NamedProperty, Pagination, Radio, RadioPanel, Select, SlideOver, Statistic, Step, StepGroup, Table, Tabs, Textarea

// EXTERNAL MODULE: ./react/ui/action-panel/ActionPanel.tsx
var ActionPanel = __webpack_require__(50188);
// EXTERNAL MODULE: ./react/ui/breadcrumbs/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(45181);
// EXTERNAL MODULE: ./react/ui/button/Button.tsx
var Button = __webpack_require__(43787);
// EXTERNAL MODULE: ./react/ui/card/Card.tsx
var Card = __webpack_require__(5367);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/ui/form/code-input/CodeInput.tsx

function CodeInput(_ref) {
  let {
    length = 6,
    value,
    onChange,
    error,
    autoFocus,
    onComplete,
    alphanumeric = false
  } = _ref;
  const inputRefs = useRef([]);
  const completedRef = useRef(false);
  useEffect(() => {
    if (autoFocus && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [autoFocus]);
  useEffect(() => {
    if (value.length === length && onComplete && !completedRef.current) {
      completedRef.current = true;
      onComplete(value);
    } else if (value.length < length) {
      completedRef.current = false;
    }
  }, [value, length, onComplete]);
  const handleChange = (index, char) => {
    const pattern = alphanumeric ? /^[a-zA-Z0-9]*$/ : /^\d*$/;
    if (!pattern.test(char)) return;
    const newValue = value.split('');
    newValue[index] = char.slice(-1).toUpperCase();
    const joined = newValue.join('').slice(0, length);
    onChange(joined);
    if (char && index < length - 1) {
      var _inputRefs$current;
      (_inputRefs$current = inputRefs.current[index + 1]) === null || _inputRefs$current === void 0 || _inputRefs$current.focus();
    }
  };
  const handleKeyDown = (index, e) => {
    // Handle backspace: clear current digit or move to previous
    if (e.key === 'Backspace') {
      e.preventDefault(); // Prevent default to control deletion ourselves
      const newValue = value.split('');
      if (newValue[index]) {
        newValue[index] = '';
        onChange(newValue.join(''));
      } else if (index > 0) {
        var _inputRefs$current2;
        newValue[index - 1] = '';
        onChange(newValue.join(''));
        (_inputRefs$current2 = inputRefs.current[index - 1]) === null || _inputRefs$current2 === void 0 || _inputRefs$current2.focus();
      }
      return;
    }

    // Handle arrow navigation between inputs
    if (e.key === 'ArrowLeft' && index > 0) {
      var _inputRefs$current3;
      e.preventDefault(); // Prevent cursor movement inside input
      (_inputRefs$current3 = inputRefs.current[index - 1]) === null || _inputRefs$current3 === void 0 || _inputRefs$current3.focus();
    } else if (e.key === 'ArrowRight' && index < length - 1) {
      var _inputRefs$current4;
      e.preventDefault(); // Prevent cursor movement inside input
      (_inputRefs$current4 = inputRefs.current[index + 1]) === null || _inputRefs$current4 === void 0 || _inputRefs$current4.focus();
    }
  };
  const handlePaste = e => {
    e.preventDefault(); // Prevent default single-char paste, handle full code paste
    const pattern = alphanumeric ? /[^a-zA-Z0-9]/g : /\D/g;
    const pastedData = e.clipboardData.getData('text').replace(pattern, '').slice(0, length).toUpperCase();
    if (pastedData) {
      var _inputRefs$current$fo;
      onChange(pastedData);
      const focusIndex = Math.min(pastedData.length, length - 1);
      (_inputRefs$current$fo = inputRefs.current[focusIndex]) === null || _inputRefs$current$fo === void 0 || _inputRefs$current$fo.focus();
    }
  };
  const handleFocus = e => {
    e.target.select();
  };
  const digits = Array.from({
    length
  }, (_, i) => value[i] || '');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-center gap-2"
  }, digits.map((digit, index) => /*#__PURE__*/React.createElement("input", {
    key: index,
    ref: el => {
      inputRefs.current[index] = el;
    },
    type: "text",
    inputMode: alphanumeric ? 'text' : 'numeric',
    autoComplete: "one-time-code",
    "aria-label": interpolate(gettext('Digit %s'), [index + 1]),
    maxLength: 1,
    value: digit,
    onChange: e => handleChange(index, e.target.value),
    onKeyDown: e => handleKeyDown(index, e),
    onPaste: handlePaste,
    onFocus: handleFocus,
    className: "h-12 w-10 rounded-lg text-center font-mono text-lg font-semibold shadow-sm ring-1 transition-colors focus:-outline-offset-1 focus:outline-2 ".concat(error ? 'text-red-900 ring-red-300 focus:outline-red-500' : 'text-gray-900 ring-black/10 focus:outline-indigo-500')
  }))), error && /*#__PURE__*/React.createElement("p", {
    className: "mt-2 text-center text-sm text-red-600"
  }, error));
}
/* harmony default export */ const code_input_CodeInput = ((/* unused pure expression or super */ null && (CodeInput)));
;// ./react/ui/confirm/Confirm.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function Confirm(_ref) {
  let {
    header = gettext('Confirm'),
    content = gettext('Are you sure?'),
    children,
    confirmButton = {},
    cancelButton = {
      children: gettext('Cancel')
    },
    negative = false,
    confirmDelete = false,
    onConfirm,
    onCancel,
    size,
    stopPropagation = true
  } = _ref;
  const [isOpen, setIsOpen] = (0,react.useState)(false);
  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm();
  };
  const handleCancel = () => {
    setIsOpen(false);
    if (onCancel) onCancel();
  };
  confirmButton.onClick = handleConfirm;
  cancelButton.onClick = handleCancel;
  if (negative) {
    confirmButton = _objectSpread({
      negative: true
    }, confirmButton);
  } else {
    confirmButton = _objectSpread({
      primary: true,
      children: gettext('Confirm')
    }, confirmButton);
  }
  if (confirmDelete) {
    confirmButton = _objectSpread({
      children: gettext('Delete')
    }, confirmButton);
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.cloneElement(children, {
    onClick: e => {
      if (stopPropagation) {
        e.stopPropagation();
      }
      setIsOpen(true);
    }
  }), /*#__PURE__*/react.createElement(Modal/* default */.A, {
    open: isOpen,
    onClose: handleCancel,
    size: size
  }, /*#__PURE__*/react.createElement(Modal/* default */.A.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "sm:flex sm:items-start"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
  }, /*#__PURE__*/react.createElement(Icon/* default */.Ay$, {
    name: "exclamation",
    className: "h-6 w-6 text-red-600"
  })), /*#__PURE__*/react.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "text-lg font-medium leading-6 text-gray-900",
    id: "modal-headline"
  }, header), /*#__PURE__*/react.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/react.createElement("p", {
    className: "text-sm text-gray-500"
  }, content))))), /*#__PURE__*/react.createElement(Modal/* default */.A.Footer, {
    gray: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-end gap-3"
  }, /*#__PURE__*/react.createElement(Button/* default */.A, _extends({
    classNames: classes => [...classes, 'sm:mt-0', 'sm:w-auto', 'sm:text-sm']
  }, cancelButton)), /*#__PURE__*/react.createElement(Button/* default */.A, _extends({
    classNames: classes => [...classes, 'sm:w-auto', 'sm:text-sm']
  }, confirmButton))))));
}
/* harmony default export */ const confirm_Confirm = (Confirm);
// EXTERNAL MODULE: ./react/ui/dimmer/Dimmer.tsx
var Dimmer = __webpack_require__(81647);
// EXTERNAL MODULE: ./react/ui/divider/Divider.tsx
var Divider = __webpack_require__(81245);
// EXTERNAL MODULE: ./react/ui/dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(94557);
// EXTERNAL MODULE: ./react/ui/feed/Feed.tsx
var Feed = __webpack_require__(45751);
// EXTERNAL MODULE: ./react/ui/feed/FeedEvent.tsx
var FeedEvent = __webpack_require__(31871);
// EXTERNAL MODULE: ./react/ui/form/Form.tsx
var Form = __webpack_require__(14823);
// EXTERNAL MODULE: ./react/ui/form/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(95520);
// EXTERNAL MODULE: ./react/ui/icon/Icon.tsx + 454 modules
var Icon = __webpack_require__(53623);
// EXTERNAL MODULE: ./react/ui/form/input/Input.tsx
var Input = __webpack_require__(31496);
// EXTERNAL MODULE: ./react/ui/label/Label.tsx
var Label = __webpack_require__(69817);
// EXTERNAL MODULE: ./react/ui/loader/Loader.tsx
var Loader = __webpack_require__(473);
// EXTERNAL MODULE: ./react/ui/message/Message.tsx
var Message = __webpack_require__(69349);
// EXTERNAL MODULE: ./react/ui/modal/Modal.tsx
var Modal = __webpack_require__(95857);
// EXTERNAL MODULE: ./react/ui/form/multiselect/Multiselect.tsx
var Multiselect = __webpack_require__(35688);
;// ./react/ui/named-propery/NamedProperty.tsx

function NamedProperty(_ref) {
  let {
    name,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-sm font-medium text-gray-500"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-sm text-gray-900"
  }, value));
}
/* harmony default export */ const named_propery_NamedProperty = ((/* unused pure expression or super */ null && (NamedProperty)));
// EXTERNAL MODULE: ./react/ui/overlay/Overlay.tsx
var Overlay = __webpack_require__(65321);
// EXTERNAL MODULE: ./react/ui/pagination/Pagination.tsx
var Pagination = __webpack_require__(29635);
// EXTERNAL MODULE: ./react/ui/popup/Popup.tsx
var Popup = __webpack_require__(59005);
// EXTERNAL MODULE: ./react/ui/portal/Portal.tsx
var Portal = __webpack_require__(95971);
// EXTERNAL MODULE: ./react/ui/progressbar/ProgressBar.tsx
var ProgressBar = __webpack_require__(7777);
// EXTERNAL MODULE: ./react/ui/form/radio/Radio.tsx
var Radio = __webpack_require__(51304);
// EXTERNAL MODULE: ./react/ui/segment/Segment.tsx
var Segment = __webpack_require__(16369);
// EXTERNAL MODULE: ./react/ui/form/select/Select.tsx
var Select = __webpack_require__(44874);
// EXTERNAL MODULE: ./react/ui/slide-over/SlideOver.tsx
var SlideOver = __webpack_require__(33708);
// EXTERNAL MODULE: ./react/ui/statistic/Statistic.tsx
var Statistic = __webpack_require__(18973);
// EXTERNAL MODULE: ./react/ui/step/Step.tsx
var Step = __webpack_require__(747);
// EXTERNAL MODULE: ./react/ui/step/StepGroup.tsx
var StepGroup = __webpack_require__(17526);
// EXTERNAL MODULE: ./react/ui/table/Table.tsx
var Table = __webpack_require__(19873);
// EXTERNAL MODULE: ./react/ui/tabs/Tabs.tsx + 1 modules
var Tabs = __webpack_require__(46305);
// EXTERNAL MODULE: ./react/ui/form/textarea/Textarea.tsx
var Textarea = __webpack_require__(97670);
// EXTERNAL MODULE: ./react/ui/toast/index.ts
var toast = __webpack_require__(82468);
// EXTERNAL MODULE: ./react/ui/toast/ToastContainer.tsx + 1 modules
var ToastContainer = __webpack_require__(34161);
// EXTERNAL MODULE: ./react/ui/collapse/Collapse.tsx
var Collapse = __webpack_require__(84373);
// EXTERNAL MODULE: ./react/ui/collapsible-text/CollapsibleText.tsx
var CollapsibleText = __webpack_require__(7522);
// EXTERNAL MODULE: ./react/ui/form/radioPanel/RadioPanel.tsx
var RadioPanel = __webpack_require__(43320);
;// ./react/ui/index.ts











































/***/ }),

/***/ 95857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60990);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
/* harmony import */ var ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(473);
/* harmony import */ var _ModalContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59910);
/* harmony import */ var _ModalFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81972);
/* harmony import */ var _ModalHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91446);







function getSizeClass(size) {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
}
const getMaxSizeClassName = size => {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
};
function Modal(_ref) {
  let {
    id,
    loading = false,
    size = 'lg',
    dismissible = false,
    elevated = false,
    open,
    onClose,
    children
  } = _ref;
  const keyListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleClose = () => {
    if (onClose) onClose();
  };
  const handleOverlayClick = () => {
    handleClose();
  };
  const listenToEscape = e => {
    if (e.keyCode === 27) {
      handleClose(); // close on escape
    }
  };
  const addListener = () => {
    if (!keyListener.current) {
      window.addEventListener('keydown', listenToEscape, false);
      keyListener.current = listenToEscape;
    }
  };
  const removeListener = () => {
    if (keyListener.current) {
      window.removeEventListener('keydown', keyListener.current, false);
      keyListener.current = null;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (open) {
      addListener();
    } else {
      removeListener();
    }
    return () => {
      removeListener();
    };
  }, [open]);
  const sizeClass = getSizeClass(size);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Overlay */ .hJ, {
    open: open,
    onOverlayClick: handleOverlayClick,
    elevated: elevated
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    id: id,
    show: open,
    className: "inline-block transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all my-8 align-middle ".concat(sizeClass, " w-full"),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "modal-headline",
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 translate-y-0 scale-95",
    enterTo: "opacity-100 translate-y-0 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 scale-100",
    leaveTo: "opacity-0 translate-y-4 translate-y-0 scale-95"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    className: "absolute inset-0 z-50",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center bg-white opacity-70 rounded-lg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onClick: e => e.stopPropagation(),
    className: "contents"
  }, children), dismissible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute top-0 right-0 hidden pt-4 pr-4 block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    type: "button",
    className: "rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: () => handleClose()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "sr-only"
  }, gettext('Close')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: "x",
    className: "h-6 w-6",
    "aria-hidden": "true"
  })))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Modal, {
  Header: _ModalHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
  Content: _ModalContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Footer: _ModalFooter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			548: 0,
/******/ 			541: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkretino"] = self["webpackChunkretino"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, [311,15,441,400,136,491,588,748,613,541,664,385,406,538,716], () => (__webpack_require__(27461)))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [311,15,441,400,136,491,588,748,613,541,664,385,406,538,716], () => (__webpack_require__(91195)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;